/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AccountId` scalar represents the MongoDB ObjectId of a Buffer Account */
  AccountId: { input: any; output: any; }
  /** The `ChannelGroupId` scalar represents the MongoDB ObjectId of a Channel Group. */
  ChannelGroupId: { input: any; output: any; }
  /** The `ChannelId` scalar represents the MongoDB ObjectId of a Buffer Channel */
  ChannelId: { input: any; output: any; }
  /**
   * The `CommentId` scalar represents the MongoDB ObjectId of a Comment.
   * A Comment is a reply to a post
   */
  CommentId: { input: any; output: any; }
  /** The `Date` scalar represents a date */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents a date and time following the ISO 8601 standard. */
  DateTime: { input: any; output: any; }
  /** The `DraftId` scalar represents the MongoDB ObjectId of a Buffer Draft */
  DraftId: { input: any; output: any; }
  /** The `ErrorMessageId` scalar represents the MongoDB ObjectId of an Error Message in our CMS */
  ErrorMessageId: { input: any; output: any; }
  /**
   * The `FeedCollectionId` scalar represents the MongoDB ObjectId of a Feed Group
   * A Feed Group is a collection of Feeds for a particular organization
   */
  FeedCollectionId: { input: any; output: any; }
  /**
   * The `FeedId` scalar represents the MongoDB ObjectId of a Content Feed (eg RSS)
   * A Feed is a source of content- for example, a specific RSS feed
   */
  FeedId: { input: any; output: any; }
  /**
   * The `FeedItemId` scalar represents the MongoDB ObjectId of a Feed Item
   * A Feed Item is a single item in a Feed- for example, an article from an RSS feed
   */
  FeedItemId: { input: any; output: any; }
  /** The `HexColorCode` scalar represents a valid hex color code. */
  HexColorCode: { input: any; output: any; }
  /** The `IdeaId` scalar represents the MongoDB ObjectId of a Buffer Idea */
  IdeaId: { input: any; output: any; }
  /** The `MimeType` scalar represents a valid MIME type, e.g. `image/png` */
  MimeType: { input: any; output: any; }
  /** The `NoteId` scalar represents the MongoDB ObjectId of a Buffer Note */
  NoteId: { input: any; output: any; }
  /** The `OrganizationId` scalar represents the MongoDB ObjectId of a Buffer Organization */
  OrganizationId: { input: any; output: any; }
  /** The `PostId` scalar represents the MongoDB ObjectId of a Buffer Post */
  PostId: { input: any; output: any; }
  /** The `SavedReplyId` scalar represents the MongoDB ObjectId of a Saved Reply. */
  SavedReplyId: { input: any; output: any; }
  /** The `ShopGridLinkId` scalar represents the MongoDB ObjectId of a Buffer ShopGridLink */
  ShopGridLinkId: { input: any; output: any; }
  /** The `SubProfileId` scalar represents the MongoDB ObjectId of a Buffer SubProfile */
  SubProfileId: { input: any; output: any; }
  /** The `TagId` scalar represents the MongoDB ObjectId of a Buffer Tag */
  TagId: { input: any; output: any; }
  /** The `TimeZone` scalar represents a valid timezone, e.g. `America/New_York` */
  TimeZone: { input: any; output: any; }
  /** The `URL` scalar represents a valid URL */
  URL: { input: any; output: any; }
};

/** AI Specific settings */
export type AiSettings = {
  __typename?: 'AISettings';
  /** Flag that indicates if AI onboarding has been completed */
  onboarded?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSettingsInput = {
  /** Flag that indicates if AI onboarding has been completed */
  onboarded: Scalars['Boolean']['input'];
};

/** Response for successful getAccessTokenForChannel query */
export type AccessTokens = {
  __typename?: 'AccessTokens';
  /** access token for channel */
  accessToken: Scalars['String']['output'];
  /** shared access token for channel */
  sharedAccessToken?: Maybe<Scalars['String']['output']>;
  /**
   * JWT token to that can be used instead of TFA code. This token expires in 30 minutes and allows advocates a short window
   * of time to perform sensitive actions without needing to enter a TFA code again.
   */
  tfaToken?: Maybe<Scalars['String']['output']>;
};

/** Account is a representation of a Buffer user. */
export type Account = {
  __typename?: 'Account';
  /** The internal admin comment associated with this account */
  adminComment?: Maybe<Scalars['String']['output']>;
  avatar: Scalars['String']['output'];
  backupEmail?: Maybe<Scalars['String']['output']>;
  backupEmailVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Fetch all channels for the account taking in account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using AccountOrganization.channels, Organization.channels or Query.channels instead
   * @deprecated Use root 'channels' query instead
   */
  channels: Array<Channel>;
  /** The connected apps for the account */
  connectedApps?: Maybe<Array<ConnectedApp>>;
  /** Date the account was created in the Core DB. For older customers, it's possible a Publish account existed in the Publish DB for this customer before this date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentOrganization?: Maybe<AccountOrganization>;
  /** Array of user's dismissed banners */
  dismissedBanners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email: Scalars['String']['output'];
  emailVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  featureFlips: Array<Scalars['String']['output']>;
  hasVerifiedBackupEmail?: Maybe<Scalars['Boolean']['output']>;
  hasVerifiedEmail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Used during the login verification flow to indicate if the user has successfully completed the login verification flow.
   * This field will only be set for users who require login verification.
   */
  hasVerifiedLogin?: Maybe<Scalars['Boolean']['output']>;
  hellonextSsoToken?: Maybe<Scalars['String']['output']>;
  helpScoutBeaconSignature?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isImpersonation: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  /** The date of the last login for the account */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date that the login verification flow was initiated.
   * This field will only be set for users who require login verification.
   */
  loginVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The account name, different from the organization name */
  name?: Maybe<Scalars['String']['output']>;
  organizations: Array<AccountOrganization>;
  /** The accounts preferences */
  preferences?: Maybe<Preferences>;
  products?: Maybe<Array<ProductLink>>;
  role: AccountRole;
  /** Account specific settings */
  settings?: Maybe<Settings>;
  /** Flag for new users to indicate if banner should be shown for email verification */
  shouldShowEmailVerificationCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** Flag for existing users to indicate if banner should be shown to request email verification */
  shouldShowEmailVerificationLinkRequest?: Maybe<Scalars['Boolean']['output']>;
  /** The account-level TFA information */
  tfa?: Maybe<Tfa>;
  /** The account-level timezone - this is used as a default input for streaks, posting plans, and new channel channel connections. */
  timezone?: Maybe<Scalars['String']['output']>;
};


/** Account is a representation of a Buffer user. */
export type AccountChannelsArgs = {
  input?: InputMaybe<AccountChannelsInput>;
  product?: InputMaybe<Product>;
};


/** Account is a representation of a Buffer user. */
export type AccountOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
};

/** Input for the channels field on Account */
export type AccountChannelsInput = {
  /** Query's filter. */
  filter?: InputMaybe<ChannelsFiltersInput>;
};

export type AccountCompleteEmailVerification = AccountCompleteEmailVerificationErrorJwtExpired | AccountCompleteEmailVerificationResponse | Error;

export type AccountCompleteEmailVerificationErrorJwtExpired = {
  __typename?: 'AccountCompleteEmailVerificationErrorJWTExpired';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  errorMessageCode: Scalars['String']['output'];
};

export type AccountCompleteEmailVerificationResponse = {
  __typename?: 'AccountCompleteEmailVerificationResponse';
  channelId?: Maybe<Scalars['ID']['output']>;
  redirectTo?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  sucessMessageCode: Scalars['String']['output'];
};

/** Reason to delete an account */
export type AccountDeletedReason = {
  /** Additional information about the account deletion */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the account to be deleted */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccountInitiateEmailVerificationError = {
  __typename?: 'AccountInitiateEmailVerificationError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountInitiateEmailVerificationPayload = AccountInitiateEmailVerificationError | AccountInitiateEmailVerificationResponse;

export type AccountInitiateEmailVerificationResponse = {
  __typename?: 'AccountInitiateEmailVerificationResponse';
  success: Scalars['Boolean']['output'];
};

/** AccountOrganization is a representation of a Buffer Organization resolved through a Buffer Account. */
export type AccountOrganization = {
  __typename?: 'AccountOrganization';
  billing: Billing;
  /** @deprecated deprecated in favor of billing field */
  billingDetails?: Maybe<BillingDetails>;
  billingNotifications: BillingNotificationSet;
  canAddPaymentDetails: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of privileges field */
  canEdit: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of privileges field */
  canManageBilling?: Maybe<Scalars['Boolean']['output']>;
  canMigrateToBufferViaHub?: Maybe<CanMigrateToOneBuffer>;
  canMigrateToOneBuffer: CanMigrateToOneBuffer;
  /** @deprecated deprecated in favor of field 'limits' */
  channelLimit: Scalars['Int']['output'];
  channelRecommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Fetch all channels for the account taking in account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using AccountOrganization.channels, Organization.channels or Query.channels instead
   */
  channels: Array<Channel>;
  commonTrackingProperties?: Maybe<CommonTrackingProperties>;
  contactAccountId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedObjects?: Maybe<Array<Maybe<DismissedObject>>>;
  entitlements: Array<Maybe<Entitlement>>;
  /**
   * Feature flips belonging to the organization admin account
   * in the future, we might want to start creating feature flips in the
   * organization object itself
   */
  featureFlips: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is the organization enrolled in the alpha program? */
  isAlphaEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the organization enrolled in the beta program? */
  isBetaEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCurrentOrganization: Scalars['Boolean']['output'];
  isOneBufferOrganization: Scalars['Boolean']['output'];
  lifetimeConnectedChannelsCount?: Maybe<Array<Maybe<LifetimeConnectedChannelCount>>>;
  limits: OrganizationLimits;
  members: MemberConnection;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  privileges: AccountPrivileges;
  role: Role;
  /**
   * We display the invite CTA when the organization account is an admin and when there are no more
   * members in the organization than the admin.
   */
  shouldDisplayInviteCTA: Scalars['Boolean']['output'];
  shouldShowTeamMemberOrganizationDowngradedBanner: Scalars['Boolean']['output'];
  /** Fetch all accounts that can be new owners for this organization */
  validNewOwners: Array<Account>;
};


/** AccountOrganization is a representation of a Buffer Organization resolved through a Buffer Account. */
export type AccountOrganizationChannelsArgs = {
  input?: InputMaybe<OrganizationChannelsInput>;
  product?: InputMaybe<Product>;
};

export type AccountPrivileges = {
  __typename?: 'AccountPrivileges';
  canEdit: Scalars['Boolean']['output'];
  canManageAllNotes: Scalars['Boolean']['output'];
  canManageBilling: Scalars['Boolean']['output'];
  canManageChannels: Scalars['Boolean']['output'];
  canManageTeamMembers: Scalars['Boolean']['output'];
  canPublishStartPages: Scalars['Boolean']['output'];
  canReceiveOrganizationOwnership: Scalars['Boolean']['output'];
  canTransferOwnership: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
};

export type AccountRemoveError = {
  __typename?: 'AccountRemoveError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountRemovePayload = AccountRemoveError | AccountRemoveResponse;

export type AccountRemoveResponse = {
  __typename?: 'AccountRemoveResponse';
  /** The id of the account that was removed. */
  id: Scalars['String']['output'];
};

export enum AccountRole {
  Admin = 'admin',
  Customer = 'customer'
}

export type AccountSetSettingsError = {
  __typename?: 'AccountSetSettingsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountSetSettingsResponse = {
  __typename?: 'AccountSetSettingsResponse';
  settings: Settings;
  success: Scalars['Boolean']['output'];
};

export type AccountSuspendResponse = Error | Response;

export type AccountUnsuspendResponse = Error | Response;

/** input for the accountUpdateRole mutation */
export type AccountUpdateRoleInput = {
  accountId: Scalars['String']['input'];
  role: AccountRole;
};

/** The response of the accountUpdateRole mutation */
export type AccountUpdateRoleResponse = Error | Response;

/** An actor represents who/what the currently authorized entity is */
export enum Actor {
  /** Represents a caller querying the core-api from api-gateway */
  Account = 'Account',
  /** Represents a caller making a request to the authentication service from the api-gateway */
  ApiGateway = 'ApiGateway',
  /** Represents a caller, who is a Buffer Admin, querying the core-api from api-gateway */
  BufferAdmin = 'BufferAdmin',
  /** Represents a caller querying the core-api from an internal service */
  InternalService = 'InternalService',
  /** Represents a caller who are authenticated using a Publish access token */
  LegacyClient = 'LegacyClient',
  /** NullActor to be used in test to represent a request that is not authenticated */
  NullActor = 'NullActor',
  /** For request coming from the legacy RPC API */
  RpcClient = 'RpcClient',
  /** Represents a script using some of the use cases */
  Script = 'Script'
}

export type AddEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteType: NoteType;
  text: Scalars['String']['input'];
};

export type AddEntityNotePayload = AddEntityNoteResponse | CoreWebAppCommonError;

export type AddEntityNoteResponse = {
  __typename?: 'AddEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Input to pass when creating a Note */
export type AddNoteToPostInput = {
  /** The id of post */
  postId: Scalars['PostId']['input'];
  /** The content of note to create */
  text: Scalars['String']['input'];
};

/** Create note request response payload. */
export type AddNoteToPostPayload = AddNoteToPostSuccess | InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response returns the full up-to-date post from after the note was created */
export type AddNoteToPostSuccess = {
  __typename?: 'AddNoteToPostSuccess';
  /** Post on which the note was successfully created */
  post: Post;
};

export type AddOrUpdateDismissedObjectError = {
  __typename?: 'AddOrUpdateDismissedObjectError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AddOrUpdateDismissedObjectPayload = AddOrUpdateDismissedObjectError | AddOrUpdateDismissedObjectResponse;

export type AddOrUpdateDismissedObjectResponse = {
  __typename?: 'AddOrUpdateDismissedObjectResponse';
  success: Scalars['Boolean']['output'];
};

/** addPostToQueue mutation schedule to the next available post by id. */
export type AddPostToQueueInput = {
  /** Post id to schedule to the next available slot. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by addPostToQueue mutation. */
export type AddPostToQueuePayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the mutation to add a shop grid custom link */
export type AddShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Link text to be saved */
  text: Scalars['String']['input'];
  /** URL to be saved */
  url: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum AllowedCommentsStatuses {
  Autodismissed = 'AUTODISMISSED',
  Dismissed = 'DISMISSED',
  Engaged = 'ENGAGED',
  None = 'NONE'
}

export type AlphaFeature = {
  __typename?: 'AlphaFeature';
  description: Scalars['String']['output'];
  feedbackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platforms: Array<FeaturePlatform>;
};

export type AnalyticsAnswer = {
  __typename?: 'AnalyticsAnswer';
  best?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Array<Maybe<AnalyticsAnswersMetric>>>;
};

export type AnalyticsAnswers = {
  __typename?: 'AnalyticsAnswers';
  day: AnalyticsAnswer;
  frequency: AnalyticsAnswer;
  type: AnalyticsAnswer;
};

export type AnalyticsAnswersMetric = {
  __typename?: 'AnalyticsAnswersMetric';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AnalyticsContent = {
  __typename?: 'AnalyticsContent';
  description?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDaily = {
  __typename?: 'AnalyticsDaily';
  day: Scalars['Date']['output'];
  organic: AnalyticsDailyStatisticsOrganic;
  paid?: Maybe<AnalyticsDailyStatisticsPaid>;
  previousDay?: Maybe<Scalars['Date']['output']>;
  previousOrganic?: Maybe<AnalyticsDailyStatisticsOrganic>;
  previousPaid?: Maybe<AnalyticsDailyStatisticsPaid>;
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
};

export type AnalyticsDailyStatisticsOrganic = {
  __typename?: 'AnalyticsDailyStatisticsOrganic';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  followersGainOrganic?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  pageViews?: Maybe<Scalars['Int']['output']>;
  postsCount?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDailyStatisticsPaid = {
  __typename?: 'AnalyticsDailyStatisticsPaid';
  followersGainPaid?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsHashtag = {
  __typename?: 'AnalyticsHashtag';
  avgClicks?: Maybe<Scalars['Float']['output']>;
  avgComments?: Maybe<Scalars['Float']['output']>;
  avgEngagement?: Maybe<Scalars['Float']['output']>;
  avgEngagementRate?: Maybe<Scalars['Float']['output']>;
  avgImpressions?: Maybe<Scalars['Float']['output']>;
  avgLikes?: Maybe<Scalars['Float']['output']>;
  avgMentions?: Maybe<Scalars['Float']['output']>;
  avgShares?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  postsCount: Scalars['Int']['output'];
};

export type AnalyticsLastUpdatedAtInput = {
  channelId: Scalars['String']['input'];
  ingestionType: ChannelIngestionType;
  organizationId: Scalars['String']['input'];
};

export type AnalyticsOrderByField = {
  field: AnalyticsSortFields;
  order: AnalyticsSortOrder;
};

export type AnalyticsPeriodPostStatistics = {
  __typename?: 'AnalyticsPeriodPostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  postsCount: Scalars['Int']['output'];
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsPost = {
  __typename?: 'AnalyticsPost';
  content?: Maybe<AnalyticsContent>;
  id: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
  statistics?: Maybe<AnalyticsPostStatistics>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsPostStatistics = {
  __typename?: 'AnalyticsPostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsPostsTotals = {
  __typename?: 'AnalyticsPostsTotals';
  organic: AnalyticsPeriodPostStatistics;
  paid?: Maybe<AnalyticsPeriodPostStatistics>;
  previousOrganic?: Maybe<AnalyticsPeriodPostStatistics>;
};

export enum AnalyticsSortFields {
  Clicks = 'CLICKS',
  Comments = 'COMMENTS',
  Engagements = 'ENGAGEMENTS',
  EngagementRate = 'ENGAGEMENT_RATE',
  Impressions = 'IMPRESSIONS',
  Likes = 'LIKES',
  Mentions = 'MENTIONS',
  SentAt = 'SENT_AT',
  Shares = 'SHARES'
}

export enum AnalyticsSortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type AnalyticsTotals = {
  __typename?: 'AnalyticsTotals';
  organic: AnalyticsDailyStatisticsOrganic;
  paid?: Maybe<AnalyticsDailyStatisticsPaid>;
  previousOrganic?: Maybe<AnalyticsDailyStatisticsOrganic>;
  previousPaid?: Maybe<AnalyticsDailyStatisticsPaid>;
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
};

/** Annotation representing all the entities in the text */
export type Annotation = {
  __typename?: 'Annotation';
  /**
   * The content of the annotation. Annotations can sometimes be different from the actual text content.
   * E.g., Mastodon mentions have 'text: @buffer', but includes the server name in the content, 'content: @buffer@threads.net'
   */
  content: Scalars['String']['output'];
  /** The indices of the annotation in the text */
  indices: Array<Scalars['Int']['output']>;
  /** The text representation of the annotation, eg '@buffer' */
  text: Scalars['String']['output'];
  /** The type of the annotation */
  type: AnnotationType;
  /** The URL the annotation points to */
  url: Scalars['String']['output'];
};

/** Annotation representing all the entities in the text */
export type AnnotationInputFacebook = {
  /** The content of the annotation, e.g. '107509875938399' */
  content: Scalars['String']['input'];
  /** The indices of the annotation in the text, e.g. [6, 9] (from 6 to 9 characters in the text) */
  indices: Array<Scalars['Int']['input']>;
  /** The text representation of the annotation, eg 'Buffer' */
  text: Scalars['String']['input'];
  /** The URL the annotation points to, e.g. https://www.facebook.com/107509875938399 */
  url: Scalars['String']['input'];
};

/** Annotation representing all the entities in the text */
export type AnnotationInputLinkedIn = {
  /** The entity of the annotation, e.g. urn:li:organization:1521226 */
  entity: Scalars['String']['input'];
  /** The id of the annotation, e.g. 1521226 */
  id: Scalars['String']['input'];
  /** The length of the annotation, e.g. 6 */
  length: Scalars['Int']['input'];
  /** The link of the annotation, e.g. https://www.linkedin.com/company/bufferapp */
  link: Scalars['String']['input'];
  /** The localized name of the annotation, e.g. Buffer */
  localizedName: Scalars['String']['input'];
  /** The start of the annotation, e.g. 5 */
  start: Scalars['Int']['input'];
  /** The vanity name of the annotation, e.g. bufferapp */
  vanityName: Scalars['String']['input'];
};

/** List of possible types for an annotation */
export enum AnnotationType {
  Annotation = 'annotation',
  Cashtag = 'cashtag',
  Hashtag = 'hashtag',
  Mention = 'mention',
  Url = 'url'
}

/** Approve Post request. */
export type ApprovePostInput = {
  /** Post id to approve. */
  id: Scalars['PostId']['input'];
};

/** Reject approval request response payload. */
export type ApprovePostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Asset interface with common fields */
export type Asset = {
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Asset types */
export enum AssetType {
  Document = 'document',
  Image = 'image',
  Video = 'video'
}

/** Asset interface with common fields */
export type AssetsInput = {
  /** Documents to be attached to the post */
  documents?: InputMaybe<Array<DocumentAssetInput>>;
  /** Images to be attached to the post */
  images?: InputMaybe<Array<ImageAssetInput>>;
  /** Link to be attached to the post */
  link?: InputMaybe<LinkAssetInput>;
  /** Videos to be attached to the post */
  videos?: InputMaybe<Array<VideoAssetInput>>;
};

export type Attachment = {
  __typename?: 'Attachment';
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttributionInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  upgradePathName?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthConnectionFlowType {
  Multi = 'multi',
  Single = 'single'
}

/** Represent the author of a post or note. */
export type Author = {
  __typename?: 'Author';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The email address of the author. */
  email: Scalars['String']['output'];
  /** The unique identifier of the author. */
  id: Scalars['AccountId']['output'];
  /** Indicates whether the author is a deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** The name of the author. Null if the user has not yet set a name. */
  name?: Maybe<Scalars['String']['output']>;
};

export type AuthorizeChannelsError = {
  __typename?: 'AuthorizeChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** An enum representing the type of error that occurred. */
  errorType: ChannelAuthorizationErrorType;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AuthorizeChannelsPayload = AuthorizeChannelsError | AuthorizeChannelsResponse;

export type AuthorizeChannelsResponse = {
  __typename?: 'AuthorizeChannelsResponse';
  channels: Array<Channel>;
};

export type BackfillChannelPostsAndAnalyticsPayload = BasicError | MutationBasicResponse;

export type BackfillChannelUpdatesResponse = Error | Response;

/** Input for backfilling the updates for grid preview */
export type BackfillUpdatesForGridInput = {
  /** The channel id to backfill updates for */
  channelId: Scalars['ChannelId']['input'];
};

/**
 * The payload of the response from backfillUpdatesForGrid.
 * Since it requires internal client, UnauthorizedError is thrown
 * for unofficial clients. If the rate limit is hit, the response
 * is still successful to not throw too many errors at the client.
 */
export type BackfillUpdatesForGridPayload = BackfillUpdatesForGridResponse | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** success response for updateLastActivityAtForChannel mutation */
export type BackfillUpdatesForGridResponse = MutationSuccess & {
  __typename?: 'BackfillUpdatesForGridResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Represents the main information for a comment in the system. */
export type BaseComment = {
  /** Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** Information about the author of the comment. */
  author: CommentAuthor;
  /** Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Last Reply to this comment. */
  lastReply?: Maybe<LastReply>;
  /** Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp when this comment was created on the third-party service. It could be undefined
   *   if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type BaseResponse = Error | Response;

export type BasicChannelInfo = {
  __typename?: 'BasicChannelInfo';
  /** The avatar URL of the channel */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The display name of the channel */
  displayName: Scalars['String']['output'];
  /** The service ID of the channel */
  serviceId: Scalars['String']['output'];
};

export type BasicError = MutationBasicError & {
  __typename?: 'BasicError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type BetaFeature = {
  __typename?: 'BetaFeature';
  description: Scalars['String']['output'];
  feedbackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platforms: Array<FeaturePlatform>;
};

/** Represents the billing details for both One Buffer and Multi-Products organizations. */
export type Billing = {
  address?: Maybe<Address>;
  balance: Scalars['Float']['output'];
  canAccessAnalytics: Scalars['Boolean']['output'];
  canAccessEngagement: Scalars['Boolean']['output'];
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  taxDetails?: Maybe<TaxDetails>;
  taxExempt?: Maybe<Scalars['String']['output']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type BillingCreateCheckoutSessionPayload = BillingCreateCheckoutSessionResponse | BillingError;

export type BillingCreateCheckoutSessionResponse = {
  __typename?: 'BillingCreateCheckoutSessionResponse';
  /** The url returned by Stripe as a redirect for success, failed, or cancelled session */
  redirectUrl: Scalars['String']['output'];
};

/** Deprecated in favor of the CreateCustomerPortalSessionPayload type. */
export type BillingCreateCustomerPortalSessionPayload = BillingCreateCustomerPortalSessionResponse | BillingError;

/** Deprecated in favor of the CreateCustomerPortalSessionResponse type. */
export type BillingCreateCustomerPortalSessionResponse = {
  __typename?: 'BillingCreateCustomerPortalSessionResponse';
  /** The customer session url returned by Stripe */
  customerPortalSessionUrl: Scalars['String']['output'];
};

export type BillingCreateSetupIntentResponse = {
  __typename?: 'BillingCreateSetupIntentResponse';
  /** The setup intent client secret returned by Stripe to use in the Stripe payment mehtod form */
  clientSecret: Scalars['String']['output'];
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

export type BillingCreatedSetupIntentPayload = BillingCreateSetupIntentResponse | BillingError;

/**
 * Represents the billing details structured to mock our legacy RPC endpoint. This was to help transitioning from RPC to GraphQL without having to change how the core settings frontend works.
 * Deprecated in favor of Billing type.
 */
export type BillingDetails = {
  __typename?: 'BillingDetails';
  allStripeAccounts: Array<Maybe<Customer>>;
};

export type BillingError = {
  __typename?: 'BillingError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export enum BillingGateway {
  Android = 'android',
  Apple = 'apple',
  Bank = 'bank',
  Check = 'check',
  Gift = 'gift',
  None = 'none',
  Paypal = 'paypal',
  Revenuecat = 'revenuecat',
  Stripe = 'stripe'
}

export enum BillingGatewayPlatform {
  Android = 'android',
  Apple = 'apple',
  Web = 'web'
}

export type BillingIncreaseSubscriptionQuantityByChannelIdsPayload = BillingError | BillingResponse;

export enum BillingInterval {
  Month = 'month',
  Year = 'year'
}

export type BillingMigrateToOneBufferPayload = BillingError | BillingMigrateToOneBufferResponse;

export type BillingMigrateToOneBufferResponse = {
  __typename?: 'BillingMigrateToOneBufferResponse';
  billing: Billing;
};

export type BillingNotificationSet = {
  __typename?: 'BillingNotificationSet';
  shouldDowngradeMobileSubscription?: Maybe<Scalars['Boolean']['output']>;
  shouldUpgradeMobileSubscription?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingResponse = {
  __typename?: 'BillingResponse';
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

export type BillingStartTrialPayload = BillingError | BillingResponse;

export enum BillingState {
  Free = 'free',
  Paid = 'paid',
  Trial = 'trial'
}

export type BillingUpdateCustomerPaymentMethodPayload = BillingError | BillingResponse;

/** The payload response of the billing mutations */
export type BillingUpdateSubscriptionPlanPayload = BillingError | BillingUpdateSubscriptionPlanResponse;

export type BillingUpdateSubscriptionPlanResponse = {
  __typename?: 'BillingUpdateSubscriptionPlanResponse';
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdate>;
  success: Scalars['Boolean']['output'];
};

export type BillingUpdateSubscriptionQuantityPayload = BillingError | BillingUpdateSubscriptionPlanResponse;

/** Input Types */
export type BlockConfigInput = {
  data?: InputMaybe<BlockDataInput>;
  type?: InputMaybe<StartPageBlockTypes>;
};

export type BlockDataInput = {
  backgroundMedia?: InputMaybe<MediaInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  htmlJson?: InputMaybe<Scalars['String']['input']>;
  htmlText?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
  logoMedia?: InputMaybe<MediaInput>;
  media?: InputMaybe<MediaInput>;
  overlay?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlockMutationResponse = BlockMutationSuccess | CommonError;

/** Query / Mutation responses */
export type BlockMutationSuccess = MutationResponse & {
  __typename?: 'BlockMutationSuccess';
  block?: Maybe<StartPageBlock>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BlocksMutationResponse = BlocksMutationSuccess | CommonError;

export type BlocksMutationSuccess = MutationResponse & {
  __typename?: 'BlocksMutationSuccess';
  blocks?: Maybe<Array<Maybe<StartPageBlock>>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Bluesky metadata */
export type BlueskyMetadata = {
  __typename?: 'BlueskyMetadata';
  /** The instance of bluesky of the channel */
  serverUrl: Scalars['String']['output'];
};

/** Bluesky post metadata */
export type BlueskyPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'BlueskyPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Bluesky post metadata */
export type BlueskyPostMetadataInput = {
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

export type Calendar = {
  __typename?: 'Calendar';
  campaigns?: Maybe<Array<PublishingCampaign>>;
  days?: Maybe<Array<CalendarDay>>;
  posts: Array<PublishingPost>;
};

export type CalendarDay = Day & {
  __typename?: 'CalendarDay';
  /** A list of campaigns present on the requested day */
  campaigns?: Maybe<Array<PublishingCampaign>>;
  /** The number of posts for the given day */
  counts?: Maybe<Array<PostServiceCount>>;
  /** The day of the week, e.g., 'Monday' */
  dayName: DayName;
  /** The numerical day of the month, e.g., 31 */
  dayOfMonth: Scalars['Int']['output'];
  /** A collection of time spans for the given day which may contain posts */
  intervals?: Maybe<Array<CalendarInterval>>;
  /** The name of the month, e.g., 'January' */
  monthName: MonthName;
  /** A list of posts for the given day */
  posts?: Maybe<Array<PublishingPost>>;
  /** The start timestamp of the day in seconds */
  startTimestamp: Scalars['Int']['output'];
};

export type CalendarInput = {
  /** MOCK MODE ONLY: Seed value for random generator */
  _seed?: InputMaybe<Scalars['Int']['input']>;
  /** The campaign(s) to fetch posts for */
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel(s) to fetch posts for */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate: Scalars['Int']['input'];
  /** Whether or not to include posts with status set to 'draft' */
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The span of time for each group of posts */
  intervalSize?: InputMaybe<IntervalSize>;
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate: Scalars['Int']['input'];
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String']['input'];
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a span of time in the calendar which may or may not contain post items.
 * The length of the interval is configured by the intervalLength passed to the query.
 */
export type CalendarInterval = {
  __typename?: 'CalendarInterval';
  /** A human readable label for the start of the interval, e.g., '2 PM' or '14:00' */
  label: Scalars['String']['output'];
  /** A list of posts within this interval */
  posts?: Maybe<Array<PublishingPost>>;
  /** A unix timestamp representing the beginning of the interval */
  startTimestamp: Scalars['Int']['output'];
};

/** Input to fetch a single post by id */
export type CalendarPostInput = {
  /** The id of the post to fetch */
  id: Scalars['ID']['input'];
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String']['input'];
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime: Scalars['Boolean']['input'];
};

export type CalendarsPayload = Calendar | PublishingError;

export type CanMigrateToOneBuffer = {
  __typename?: 'CanMigrateToOneBuffer';
  /** Whether the organization is eligible to be migrated to One Buffer */
  canMigrate: Scalars['Boolean']['output'];
  /** Reasons why canMigrate resolved to false. It will be an empty array otherwise. */
  reasons: Array<Maybe<Scalars['String']['output']>>;
  /** Subscription discount information used in the migration process */
  subscriptionDiscount?: Maybe<Discount>;
};

/** input for cancelTrial mutation */
export type CancelTrialInput = {
  /** Id of organization on the trial. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** cancelTrial response payload. */
export type CancelTrialPayload = CancelTrialResponse | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response for successful cancelTrial mutation */
export type CancelTrialResponse = MutationSuccess & {
  __typename?: 'CancelTrialResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Channel entity */
export type Channel = {
  __typename?: 'Channel';
  /**
   * The level of permissions a user has for a channel.
   * Only use for communication purposes.
   * To make decision about specific action a user can take, please use Post.allowedActions or Note.allowedActions.
   * If the entity you work with doesn't have allowedActions, please implement that pattern.
   * Source: field resolver
   * Defined in: new proposal
   */
  accessLevel: ChannelAccessLevel;
  /**
   * The allowed actions for the current user
   * Source: field resolver
   * Defined in: new proposal
   */
  allowedActions: Array<ChannelAction>;
  /**
   * A collection of timestamps with related to analytics ingestion for the channel or for the channel updates
   * Source: mapper from channel collection - channel.analytics
   * Defined in: current implementation
   */
  analytics?: Maybe<ChannelAnalyticsMetadata>;
  /**
   * The version of the third-party API used by the channel - null if we don't track the version on the backend
   * Source: mapper from channel collection - channel.credentials.apiVersion
   * Defined in: current implementation
   */
  apiVersion?: Maybe<Scalars['String']['output']>;
  /**
   * The avatar URL of the channel
   * Source: mapper from channel collection - channel.avatar
   * Defined in: both proposals
   */
  avatar: Scalars['String']['output'];
  /**
   * Indicates if banners should be shown - often tied to using an old version of the API
   * Source: mapper from channel collection data
   * Defined in: new proposal
   */
  banners: Array<ChannelBanner>;
  /**
   * Indicates if the user can publish the start page
   * Source: field resolver - legacy query.resolver
   * Defined in: current implementation
   * @deprecated Use allowedActions instead
   */
  canPublishStartPage: Scalars['Boolean']['output'];
  /**
   * The creation date of the channel
   * Source: mapper from channel collection - channel.createdAt
   * Defined in: both proposals
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Formatted name of the channel service and type: e.g. 'Twitter Profile' or 'Facebook Page'
   * Source: mapper from channel collection - channel.service and channel.type
   * Defined in: current implementation
   */
  descriptor: Scalars['String']['output'];
  /**
   * The display name of the channel - nullable (reason?)
   * Source: mapper from channel collection - channel.displayName
   * Defined in: current implementation
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The channel's URL on the social network (e.g. instagram.com/username or facebook.com/page)
   * Source: field resolver
   * Returns null if the channel is not supported
   */
  externalLink?: Maybe<Scalars['String']['output']>;
  /**
   * Whether at least one member of the orginization who have access to this channel
   * also has a user device registered for push notifications
   */
  hasActiveMemberDevice: Scalars['Boolean']['output'];
  /**
   * The ID of the channel
   * Source: mapper from channel collection - channel._id
   * Defined in: both proposals
   */
  id: Scalars['ChannelId']['output'];
  /**
   * Indicates if the channel is properly connected to Buffer
   * Source: mapper from channel collection - channel.credentials.invalid
   * Defined in: both proposals
   */
  isDisconnected: Scalars['Boolean']['output'];
  /**
   * Indicates if the channel is locked - Locked channels can't be used for posting.
   * A channel can be locked when the organization downgrades and reduces the channel quantity of their plan.
   * Source: mapper from channel collection - channel.isLocked
   * Defined in: both proposals
   */
  isLocked: Scalars['Boolean']['output'];
  /**
   * Indicates if the channel was recently created (in less than 10 seconds). This is used to determine the redirect modal after channel authorization
   * Source: mapper from channel collection - channel.createdAt comparison with current time
   * Defined in: current implementation
   */
  isNew: Scalars['Boolean']['output'];
  /**
   * Indicates is the queue is paused for the channel. A paused queue means schedules posts won't be published.
   * Source: Field resolver - From profiles collection - profile.paused
   * Defined in: new proposal
   */
  isQueuePaused: Scalars['Boolean']['output'];
  /** Link Shortening settings for the channel */
  linkShortening: ChannelLinkShortening;
  /**
   * Metadata about the location of the business associated with the channel. Only available for Facebook and GPB
   * Source: mapper from channel collection - channel.locationData
   * Defined in: current implementation
   * @deprecated Use metadata instead
   */
  locationData?: Maybe<LocationData>;
  /**
   * Metadata or settings depending on the service type - such as the server URL for Mastodon or Location data for Facebook/GPB
   * Source: Field resolver - From channel collection: channel.locationData + channel.serverURL | profile collection: profile.default_to_reminder
   * Defined in: new proposal
   */
  metadata?: Maybe<ChannelMetadata>;
  /**
   * The name of the channel - the handle name, username, etc.
   * Source: mapper from channel collection - channel.name
   * Defined in: both proposals
   */
  name: Scalars['String']['output'];
  /**
   * Data Loader is not applied here so we risk having a n+1 query if we fetch this field for a set of channels
   * Source: field resolvers in legacy query.resolver
   * Defined in: current implementation
   * @deprecated only used internally - we don't want to promote for public API
   */
  organization?: Maybe<ChannelOrganization>;
  /**
   * The organization ID of the channel
   * Source: mapper from channel collection - channel.organizationId
   * Defined in: both proposals
   */
  organizationId: Scalars['OrganizationId']['output'];
  /** The posting goal for the channel */
  postingGoal?: Maybe<PostingGoal>;
  /**
   * Provides the posting slots for each day of the week
   * Source: field resolver based on profiles collection - getPostingSchedule
   */
  postingSchedule: Array<ScheduleV2>;
  /** Products that support a given channel */
  products?: Maybe<Array<Product>>;
  /**
   * Scopes requested for a given channel - empty array if we don't have them tracked
   * Source: mapper from channel collection - channel.credentials.scopes
   * Defined in: current implementation
   */
  scopes: Array<Maybe<Scalars['String']['output']>>;
  /**
   * The instance of mastodon of the channel
   * Source: mapper from channel collection - channel.serverUrl
   * Defined in: current implementation
   * @deprecated Use metadata instead
   */
  serverUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Represents the social network
   * Source: mapper from channel collection - channel.serviceType
   * Defined in: both proposals
   */
  service: Service;
  /**
   * Similar to metadata - Deprecated
   * Source: mapper from channel collection - channel.serviceData
   * Defined in: current implementation
   * @deprecated use metadata (TwitterMetadata) instead
   */
  serviceData?: Maybe<ServiceData>;
  /**
   * Represents the external ID of the channel on social network API
   * Source: mapper from channel collection - channel.serviceId
   * Defined in: both proposals
   */
  serviceId: Scalars['String']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowLinkedInUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowPinterestUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowTiktokUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * The timezone of the channel - Default if not set is Europe/London
   * Source: field resolver based on profiles collection - timezone
   * Defined in: both proposals
   */
  timezone: Scalars['String']['output'];
  /**
   * The type of the channel - Page, Profile, Business, Group, Account, etc.
   * Source: mapper from channel collection - channel.type
   * Defined in: both proposals
   */
  type: ChannelType;
  /**
   * The last time the channel was updated
   * Source: mapper from channel collection - channel.updatedAt
   * Defined in: both proposals
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Weekly posting limit for the channel
   * @deprecated This field is not used anymore
   */
  weeklyPostingLimit?: Maybe<WeeklyPostingLimit>;
};

/**
 * The level of permissions a user has for a channel.
 * Only use for communication purposes.
 * To make decision about specific action a user can take, please use Post.allowedActions or Note.allowedActions.
 * If the entity you work with doesn't have allowedActions, please implement that pattern.
 */
export enum ChannelAccessLevel {
  FullPosting = 'fullPosting',
  None = 'none',
  RequiresApproval = 'requiresApproval'
}

/** List of possible actions that can be performed on a Channel */
export enum ChannelAction {
  PublishStartPage = 'publishStartPage'
}

export type ChannelAnalyticsLastUpdateAtPayload = Error | Response;

/** List of analytics timestamp used to track the last time the channel was checked for updates/posts */
export type ChannelAnalyticsMetadata = {
  __typename?: 'ChannelAnalyticsMetadata';
  /** Timestamp of the last time the channel succesfully collected channel analytics */
  channelLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel succesfully collected post analytics */
  postsLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was checked for update/post analytics */
  updatesLastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was checked for collecting new updates/posts */
  updatesLastCollectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChannelAuthorizationError = {
  __typename?: 'ChannelAuthorizationError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export enum ChannelAuthorizationErrorType {
  NoChannelsError = 'noChannelsError',
  NotEnoughPermissions = 'notEnoughPermissions',
  StealingNotAllowed = 'stealingNotAllowed',
  UndefinedError = 'undefinedError'
}

/** Input for getting the authorization info for a network. */
export type ChannelAuthorizationInfoInput = {
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelAuthorizationInfoMetadata>;
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to authorize. */
  service: Service;
};

/** Metadata for Channel Authorization for different services */
export type ChannelAuthorizationInfoMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
};

/** The response with authorization info for a network. */
export type ChannelAuthorizationInfoResponse = {
  __typename?: 'ChannelAuthorizationInfoResponse';
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['output'];
  /** The state token used for the authorization URL */
  state: Scalars['String']['output'];
  /** The URL to use to authorize the channel. */
  url: Scalars['String']['output'];
};

export type ChannelAuthorizationInput = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  service: Service;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Instagram API to be used for authorization */
export enum ChannelAuthorizationInstagramApi {
  /** Facebook Login API - used for business and creator accounts, with all features */
  FacebookLogin = 'facebookLogin',
  /** Instagram Login API - used for business and creator accounts, with limited features */
  InstagramLogin = 'instagramLogin'
}

/** Instagram metadata for Channel Authorization */
export type ChannelAuthorizationInstagramMetadata = {
  /** Method of authorization used for IG Auth */
  apiVersion: ChannelAuthorizationInstagramApi;
};

/** Mastodon metadata for Channel Authorization */
export type ChannelAuthorizationMastodonMetadata = {
  /** Follow Buffer in the mastodon.social instance */
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Mastodon server to be used for connection */
  server: Scalars['String']['input'];
};

export type ChannelAuthorizationPayload = ChannelAuthorizationError | ChannelAuthorizationResponse;

export type ChannelAuthorizationResponse = {
  __typename?: 'ChannelAuthorizationResponse';
  channel: Channel;
  /** @deprecated deprecated in favor of returning a channel */
  success: Scalars['Boolean']['output'];
};

/** Twitter metadata for Channel Authorization */
export type ChannelAuthorizationTwitterMetadata = {
  /** The Twitter oauth_verifier token to be used for getting the credentials */
  codeVerifier: Scalars['String']['input'];
};

export type ChannelAuthorizationUrlError = {
  __typename?: 'ChannelAuthorizationUrlError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelAuthorizationUrlInput = {
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
  service: Service;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelAuthorizationUrlPayload = ChannelAuthorizationUrlError | ChannelAuthorizationUrlResponse;

export type ChannelAuthorizationUrlResponse = {
  __typename?: 'ChannelAuthorizationUrlResponse';
  url: Scalars['String']['output'];
};

/** Allows the backfilling of posts and analytics for a given channel */
export type ChannelBackfillInput = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The list of channel banners that we currently support */
export enum ChannelBanner {
  LinkedinUpgrade = 'linkedinUpgrade',
  PinterestUpgrade = 'pinterestUpgrade',
  TiktokUpgrade = 'tiktokUpgrade'
}

/** Options that define how the service should be grouped */
export enum ChannelCategory {
  Creator = 'creator',
  Ecommerce = 'ecommerce',
  SmallBusiness = 'small_business'
}

export type ChannelConnectionAvailability = {
  __typename?: 'ChannelConnectionAvailability';
  connectionAvailability: ConnectionAvailability;
  service: Service;
  serviceId: Scalars['String']['output'];
};

/** Channel Authorization error when a channel cannot be stolen */
export type ChannelConnectionCannotStealChannelError = MutationError & {
  __typename?: 'ChannelConnectionCannotStealChannelError';
  /** The error message */
  message: Scalars['String']['output'];
};

export type ChannelConnectionInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: ChannelCredentialsInput;
  service: Service;
  serviceId: Scalars['String']['input'];
};

/** Input for listing the channels of a service. */
export type ChannelConnectionListInput = {
  /** The code to be used to exchange the access_token. */
  code: Scalars['String']['input'];
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelConnectionListMetadata>;
  /** The organization ID to list the channels. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to list the channels from. */
  service: Service;
};

/** Input for metadata for Channel Connection List */
export type ChannelConnectionListMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
  /** Twitter metadata for Channel Authorization */
  twitterMetadata?: InputMaybe<ChannelAuthorizationTwitterMetadata>;
};

/** The payload of the response from ChannelConnectionList */
export type ChannelConnectionListPayload = ChannelConnectionListResponse | ChannelConnectionNoChannelsError | UnauthorizedError | UnexpectedError;

/** The response with the list of channels fetch from the service. */
export type ChannelConnectionListResponse = {
  __typename?: 'ChannelConnectionListResponse';
  /** The list of channels */
  channels: Array<ConnectableChannel>;
};

/** Channel Authorization error when there are no channels found */
export type ChannelConnectionNoChannelsError = MutationError & {
  __typename?: 'ChannelConnectionNoChannelsError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** Input for reconnecting the channels of a service. */
export type ChannelConnectionRefreshInput = {
  /** The code to be used to exchange the access_token. */
  code: Scalars['String']['input'];
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelConnectionRefreshMetadata>;
  /** The organization ID to reconnect the service. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to reconnect. */
  service: Service;
};

/** Input for metadata for Channel Authorization Reconnect */
export type ChannelConnectionRefreshMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
  /** Twitter metadata for Channel Authorization */
  twitterMetadata?: InputMaybe<ChannelAuthorizationTwitterMetadata>;
};

/** The payload of the response from ChannelConnectionRefresh */
export type ChannelConnectionRefreshPayload = ChannelConnectionCannotStealChannelError | ChannelConnectionNoChannelsError | ChannelConnectionRefreshResponse | ChannelConnectionRefreshWrongAccountError | UnauthorizedError | UnexpectedError;

/** The response with the list of channels that were reconnected. */
export type ChannelConnectionRefreshResponse = {
  __typename?: 'ChannelConnectionRefreshResponse';
  /** The list of channels that were reconnected. */
  channels: Array<Channel>;
};

export type ChannelConnectionRefreshWrongAccountError = MutationError & {
  __typename?: 'ChannelConnectionRefreshWrongAccountError';
  /** Channel that exist on network but are not connected to Buffer */
  channel: BasicChannelInfo;
  /** The error message */
  message: Scalars['String']['output'];
};

/** The current connection status of the service */
export type ChannelConnectionStatus = {
  __typename?: 'ChannelConnectionStatus';
  /** An optional message to be displayed when the ConnectionStatus is of the `disabled` type */
  message?: Maybe<Scalars['String']['output']>;
  /** The connection status of a service */
  status: ConnectionStatus;
};

export type ChannelCredentials = {
  __typename?: 'ChannelCredentials';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  accessTokenSecret?: Maybe<Scalars['String']['output']>;
  invalid?: Maybe<Scalars['Boolean']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharedAccessToken?: Maybe<Scalars['String']['output']>;
  sharedAccessTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharedOwner?: Maybe<Scalars['String']['output']>;
};

export type ChannelCredentialsInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  accessTokenSecret?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedAccessToken?: InputMaybe<Scalars['String']['input']>;
  sharedAccessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedOwner?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelData = {
  __typename?: 'ChannelData';
  googlebusiness?: Maybe<GoogleBusinessData>;
  instagram?: Maybe<InstagramData>;
  linkedin?: Maybe<LinkedinData>;
  pinterest?: Maybe<PinterestData>;
  startPage?: Maybe<StartPageData>;
  threads?: Maybe<ThreadsData>;
  youtube?: Maybe<YoutubeData>;
};

/** A group of channels that can be managed together. */
export type ChannelGroup = {
  __typename?: 'ChannelGroup';
  /** ID of the account that owns this channel group */
  accountId: Scalars['AccountId']['output'];
  /** The number of channels in the channel group, regardless of the limit set on the channel group */
  channelCount: Scalars['Int']['output'];
  /** The channels that are part of the Channel Group. Sorted */
  channels?: Maybe<Array<Channel>>;
  /** The date and time the channel group was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the channel group */
  id: Scalars['ChannelGroupId']['output'];
  /** Display name of the channel group */
  name: Scalars['String']['output'];
  /** ID of the organization this channel group belongs to */
  organizationId: Scalars['OrganizationId']['output'];
  /** The date and time the channel group was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for fetching a single channel group */
export type ChannelGroupInput = {
  /** The channel group ID */
  id: Scalars['ChannelGroupId']['input'];
};

/** Channel Group Query Payload: Success and errors */
export type ChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Response for channel group query */
export type ChannelGroupResponse = {
  __typename?: 'ChannelGroupResponse';
  /** The channel group */
  channelGroup: ChannelGroup;
};

/** Input for fetching all channel groups for an account in the organization */
export type ChannelGroupsInput = {
  /** The account for which the user fetches the channel groups */
  accountId: Scalars['AccountId']['input'];
  /** The limit of the channel groups to fetch */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The organization for which the user fetches the channel groups */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Channel Groups Query Payload: Success and errors */
export type ChannelGroupsPayload = ChannelGroupsResponse | UnauthorizedError | UnexpectedError;

/** Response for channel groups query */
export type ChannelGroupsResponse = {
  __typename?: 'ChannelGroupsResponse';
  /** The channel groups */
  channelGroups: Array<ChannelGroup>;
};

export enum ChannelIngestionType {
  Channel = 'channel',
  Posts = 'posts'
}

/** Input for the channel query */
export type ChannelInput = {
  /** The ID of the channel to be retrieved */
  id: Scalars['ChannelId']['input'];
};

export type ChannelLimitError = {
  __typename?: 'ChannelLimitError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
};

/** Settings for link shortening */
export type ChannelLinkShortening = {
  __typename?: 'ChannelLinkShortening';
  /** Configuration of link shortening integration. Null if disabled. */
  config?: Maybe<LinkShorteningConfig>;
  /** If link shortening is enabled for the channel */
  isEnabled: Scalars['Boolean']['output'];
};

/** The payload of the response from updateChannelLinkShortening */
export type ChannelLinkShorteningPayload = ChannelLinkShortening | NotFoundError | UnauthorizedError | UnexpectedError;

export type ChannelLocationData = {
  __typename?: 'ChannelLocationData';
  location?: Maybe<Scalars['String']['output']>;
  mapsLink?: Maybe<Scalars['String']['output']>;
};

/** Metadata or settings about the channel depending on the service type */
export type ChannelMetadata = BlueskyMetadata | FacebookMetadata | GoogleBusinessMetadata | InstagramMetadata | LinkedInMetadata | MastodonMetadata | PinterestMetadata | TwitterMetadata;

export type ChannelMutationResponse = ChannelResponse | Error;

export enum ChannelNativeService {
  StartPage = 'startPage'
}

/** Subset of the Organization type - only used internally to reduce the number of GraphQL queries - should not be used in public API */
export type ChannelOrganization = {
  __typename?: 'ChannelOrganization';
  /** Account ID of the "main" admin */
  contactAccountId: Scalars['String']['output'];
  /** List of entitlements for the organization */
  entitlements: Array<Maybe<Entitlement>>;
  /** The ID of the organization */
  id: Scalars['OrganizationId']['output'];
};

/** Error returned when the channel needs a refresh */
export type ChannelRefreshRequired = MutationError & {
  __typename?: 'ChannelRefreshRequired';
  /** ChannelIds that need refreshing */
  channelIds: Array<Scalars['ChannelId']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

export type ChannelResponse = {
  __typename?: 'ChannelResponse';
  channel: Channel;
  success: Scalars['Boolean']['output'];
};

export type ChannelServiceDataInput = {
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelSlotDetails = {
  __typename?: 'ChannelSlotDetails';
  /** The number of channels purchased that the customer will pay a per unit amount. For non Agency plans that will be equal to currentQuantity */
  chargableQuantity: Scalars['Int']['output'];
  /** The number of channels purchased for this subscription. */
  currentQuantity: Scalars['Int']['output'];
  /** Fixed amount for the plan. It will contain a non 0 value only for the Agency plan */
  flatFee: Scalars['Float']['output'];
  /** The lowest value that the quantity can have for the specific subscription. It will be 1 for all plans except for Agency, where it will be 10. */
  minimumQuantity: Scalars['Int']['output'];
  /** The price that a customer will pay for every chargableQuantity */
  pricePerQuantity: Scalars['Float']['output'];
};

export type ChannelStoreTemporaryCredentialsResponse = Error | Response;

export enum ChannelThirdPartyService {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  Googlebusiness = 'googlebusiness',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Mastodon = 'mastodon',
  Pinterest = 'pinterest',
  Threads = 'threads',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Youtube = 'youtube'
}

/** Channel is a representation of a social media account or page that can be connected to Buffer. */
export enum ChannelType {
  Account = 'account',
  Business = 'business',
  Channel = 'channel',
  Group = 'group',
  Page = 'page',
  Profile = 'profile'
}

export type ChannelUpdateCredentialsInput = {
  credentials: ChannelCredentialsInput;
  service: Service;
  serviceIds: Array<Scalars['String']['input']>;
};

export type ChannelUpdateLockedStatusInput = {
  channelId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
};

export type ChannelUpdateLockedStatusResponse = ChannelLimitError | Error | Response;

export type ChannelWithCredentialsInput = {
  avatar: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials?: InputMaybe<ChannelCredentialsInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  locationData?: InputMaybe<LocationDataInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  /** Channels are now linked to a single Buffer product by default. This field will be removed on the 29th September */
  products?: InputMaybe<Array<Product>>;
  serverUrl?: InputMaybe<Scalars['String']['input']>;
  service: ChannelThirdPartyService;
  serviceData?: InputMaybe<ChannelServiceDataInput>;
  serviceId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: ChannelType;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChannelsConnectError = {
  __typename?: 'ChannelsConnectError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelsConnectPayload = ChannelsConnectError | ChannelsConnectResponse;

export type ChannelsConnectResponse = {
  __typename?: 'ChannelsConnectResponse';
  channels: Array<Channel>;
};

/** Filter to pass when fetching channels. */
export type ChannelsFiltersInput = {
  /**
   * If not defined, it returns all channels
   * Else,
   *   if true, it only returns locked channels
   *   if false, it only returns not locked channels
   */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If not passed, it return all channels
   * Else, it filters the channels based on what the product supports.
   */
  product?: InputMaybe<Product>;
};

/** Input to pass when fetching channels. */
export type ChannelsInput = {
  /** A list of option filters - passing null means we don't want to filter */
  filter?: InputMaybe<ChannelsFiltersInput>;
  /** The Organization id to fetch channels for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type ChannelsSetRecommendationsError = {
  __typename?: 'ChannelsSetRecommendationsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelsSetRecommendationsPayload = ChannelsSetRecommendationsError | ChannelsSetRecommendationsResponse;

export type ChannelsSetRecommendationsResponse = {
  __typename?: 'ChannelsSetRecommendationsResponse';
  success: Scalars['Boolean']['output'];
};

export type ChannelsUpdateCredentialsResponse = Error | Response;

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Float']['output'];
  amountAvailableForRefund: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  amountRefunded: Scalars['Float']['output'];
  canBeRefunded: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  /** 'isRefunded' will only be true if the charge was fully refunded. It will remain false for partial refunds */
  isRefunded: Scalars['Boolean']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: ChargeStatus;
};

export enum ChargeStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

/** Query responses */
export type Checklist = {
  __typename?: 'Checklist';
  id: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
  title: Scalars['String']['output'];
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
};

export type ChecklistsPayload = ChecklistsResponse | CoreWebAppCommonError;

export type ChecklistsResponse = {
  __typename?: 'ChecklistsResponse';
  checklists?: Maybe<Array<Maybe<Checklist>>>;
};

export type ChildBlockConfigInput = {
  data?: InputMaybe<BlockDataInput>;
  parentBlockId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StartPageBlockTypes>;
};

/** Client response returned by the client query, containing configuration details for the client making the request */
export type Client = {
  __typename?: 'Client';
  supportStatus: ClientSupportStatus;
};

/** Error response returned when there is a problem retrieving the information for a client */
export type ClientError = {
  __typename?: 'ClientError';
  cause: Scalars['String']['output'];
};

export type ClientInput = {
  platform: ClientPlatform;
  version: Scalars['String']['input'];
};

/** Payload response returned by the client query */
export type ClientPayload = Client | ClientError;

/** The platform that the client is being used on */
export enum ClientPlatform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

/** Specifies the support status of a client, along with an (optional) reason as to why that client might not be supported */
export type ClientSupportStatus = {
  __typename?: 'ClientSupportStatus';
  reason?: Maybe<Scalars['String']['output']>;
  status: SupportStatus;
};

export type Comment = {
  __typename?: 'Comment';
  attachment?: Maybe<Attachment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Error>;
  from?: Maybe<From>;
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  needsAttention?: Maybe<Scalars['Boolean']['output']>;
  replies?: Maybe<Array<Maybe<Reply>>>;
  repliesNeedsAttention?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AllowedCommentsStatuses>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Represents the author of a comment. */
export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The default avatar settings of the author. */
  defaultAvatarSettings?: Maybe<DefaultAvatarSettings>;
  /** The name of the author. */
  name?: Maybe<Scalars['String']['output']>;
  /** The username of the author. */
  username: Scalars['String']['output'];
};

/** Input for the comment context query */
export type CommentContextInput = {
  /** The comment id to fetch context for */
  commentId: Scalars['CommentId']['input'];
};

/** Response for the comment context query */
export type CommentContextResponse = {
  __typename?: 'CommentContextResponse';
  /** Original comment */
  comment: CommentData;
  /**
   * Array of comments parents of the input comment.
   * Empty array if the input comment is a root comment.
   */
  context?: Maybe<Array<CommentData>>;
};

/** A Comment can be a Comment received from a Third Party or a Comment sent by Buffer */
export type CommentData = CommentFromBuffer | CommentFromThirdParty;

/** The different status for a comment sent by Buffer */
export enum CommentEngagementStatusTypes {
  /** Comment created but not sent yet to the third party */
  Draft = 'draft',
  /** The publishing process failed */
  Error = 'error',
  /** The publishing process is in progress */
  Processing = 'processing',
  /** The publishing process succeded */
  Published = 'published'
}

/**
 * Describes a comment sent by Buffer where we need to track the publishing
 * process status.
 * publishedAt and publicUrl are optional as the publishing process could fail.
 */
export type CommentFromBuffer = BaseComment & {
  __typename?: 'CommentFromBuffer';
  /** BaseComment: Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** BaseComment: Information about the author of the comment. */
  author: CommentAuthor;
  /** BaseComment:  Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** BaseComment:  The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** BaseComment: ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** BaseComment: Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * BaseComment: Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** BaseComment: Last Reply to this comment. */
  lastReply?: Maybe<LastReply>;
  /** BaseComment: Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * BaseComment: Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** BaseComment: The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * BaseComment: The timestamp when this comment was created on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Describes the status of a comment sent by Buffer to third party
   * and potential errors.
   */
  publishingStatus: PublishingStatus;
  /**
   * BaseComment: The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** BaseComment: The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** BaseComment: The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * BaseComment: The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** BaseComment: The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Describes a comment received from a third-party. We'll add labels, sentimentAnalysis
 * and suggestions during the ingestion process.
 */
export type CommentFromThirdParty = BaseComment & {
  __typename?: 'CommentFromThirdParty';
  /** BaseComment: Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** BaseComment: Information about the author of the comment. */
  author: CommentAuthor;
  /** BaseComment:  Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** BaseComment:  The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** BaseComment: ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** BaseComment: Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * BaseComment: Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Labels assigned to the comment. e.g. question, negativity */
  labels: Array<CommentLabel>;
  /** BaseComment: Last Reply to this comment. */
  lastReply?: Maybe<LastReply>;
  /** BaseComment: Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * BaseComment: Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** BaseComment: The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * BaseComment: The timestamp when this comment was created on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * BaseComment: The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /**
   * Sentiment analysis results for the comment. It could contain detailed
   * information related to the label assigned to the comment.
   * It is optional because it won't calculated in all the cases.
   */
  sentimentAnalysis?: Maybe<Array<SentimentAnalysis>>;
  /** BaseComment: The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** BaseComment: The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /** Suggested actions or responses for the comment. */
  suggestions: Array<Suggestion>;
  /**
   * BaseComment: The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** BaseComment: The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Labels that can be assigned to a comment. */
export enum CommentLabel {
  /** The comment contains negative sentiment. */
  Negative = 'negative',
  /** The comment doesn't contain negative or positive sentiment. */
  Neutral = 'neutral',
  /** The comment contains positive sentiment. */
  Positive = 'positive',
  /** The comment is a question. */
  Question = 'question',
  /** The author of the comment is a super fan */
  Superfan = 'superfan'
}

/** We support only the "rich" type for now. */
export type CommentOEmbed = OEmbedRich;

/** The comments score broken down to its individual score metrics, responseRate, responseSpeed, consistency */
export type CommentScoreDetailed = {
  __typename?: 'CommentScoreDetailed';
  /**
   * The consistency of comments
   * maximum value is 20
   */
  consistency: CommentsScoreMetric;
  /**
   * The response rate of comments
   * maximum value is 50
   */
  responseRate: CommentsScoreMetric;
  /**
   * The response speed of comments
   * maximum value is 30
   */
  responseSpeed: CommentsScoreMetric;
  /** The total value of the comments score. Maximum value is 100. */
  totalValue: Scalars['Int']['output'];
};

/** Fields that can be used to sort comments. */
export enum CommentSortableKey {
  /** Sort comments based on their published timestamp. */
  PublishedAt = 'publishedAt'
}

/** Possible statuses of a comment. */
export enum CommentStatus {
  /** The comment has been dismissed. */
  Dismissed = 'dismissed',
  /**
   * new is not a real status but it's considered as a status here for simplicity
   * a new comment is an unreplied one received in the last 48 hours and not seen by the user
   */
  New = 'new',
  /** The comment has received a reply. */
  Replied = 'replied',
  /** The comment is being replied to. */
  Replying = 'replying',
  /** The comment has not been replied to. */
  Unreplied = 'unreplied'
}

/**
 * Suggestions source: currently, they could be generated by AI or from a kind
 * of template
 */
export enum CommentSuggestionSource {
  /** Suggestions generated by AI */
  Ai = 'ai',
  /** Suggestions selected from a file with fixed suggestions */
  Template = 'template'
}

/** Input for the commentSuggestions query */
export type CommentSuggestionsInput = {
  /** The comment id to fetch suggestions for */
  commentId: Scalars['CommentId']['input'];
  /** Whether to regenerate the suggestions, false by default */
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for the quick replies generated by the AI */
export type CommentSuggestionsResponse = {
  __typename?: 'CommentSuggestionsResponse';
  /** List of suggestions for the comment */
  suggestions: Array<Suggestion>;
};

/** Input for the comment thread query */
export type CommentThreadInput = {
  /** The comment id to fetch thread for */
  commentId: Scalars['CommentId']['input'];
};

/** Response for the comment thread query */
export type CommentThreadResponse = {
  __typename?: 'CommentThreadResponse';
  /** The thread of the comment */
  thread: Array<CommentData>;
};

/** Comments Count for a channel */
export type CommentsCount = {
  __typename?: 'CommentsCount';
  /** The id of the channel if a channelId list was provided as input */
  channelId: Scalars['ChannelId']['output'];
  /** The count of comments that satisfies the filters */
  count: Scalars['Int']['output'];
  /**
   * This field is used by the BE to limit the results in the DB query
   * when the query fails due to a time out.
   * BE will return the used limit to the FE and the FE will have to handle it
   * to get the remaining data.
   */
  limit: Scalars['Int']['output'];
};

/** Filters for the comments count query */
export type CommentsCountsFiltersInput = {
  /**
   * When set, it will filter comments by channel.
   * If not provided, query will return count for the organization
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The sentiment of comments to return: Labels are question, negativity, etc. */
  label?: InputMaybe<CommentLabel>;
  /** The postId to fetch comments for */
  postId?: InputMaybe<Array<Scalars['PostId']['input']>>;
  /**
   * When set, it will filter comments by the date they were published.
   * DateTimeComprator is a range filter with a start and end date.
   */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /**
   * When set, it will filter comments by status: new, replied, unreplied, dismissed
   * new is not a real status but it's considered as a status here for simplicity
   */
  status?: InputMaybe<Array<CommentStatus>>;
};

/** Input for the comments count query */
export type CommentsCountsInput = {
  /** The filters to apply to the comments query */
  filters?: InputMaybe<CommentsCountsFiltersInput>;
  /** The Organization id to fetch comments counts for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Query Response */
export type CommentsCountsResponse = {
  __typename?: 'CommentsCountsResponse';
  /** list of counts */
  counts: Array<CommentsCount>;
};

/** Represents a single comment and its pagination cursor. */
export type CommentsEdge = {
  __typename?: 'CommentsEdge';
  /** A unique identifier (cursor) for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual comment data. */
  node: CommentData;
};

/** Fields that can be used to filter comments. */
export type CommentsFiltersInput = {
  /** The channel(s) ids to fetch comments for */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The sentiment of comments to return */
  label?: InputMaybe<CommentLabel>;
  /** The postId to fetch comments for */
  postId?: InputMaybe<Array<Scalars['PostId']['input']>>;
  /** When set, it will filter comments by the date they were published */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /** When set, it will filter comments by status: new, replied, unreplied, dismissed */
  status?: InputMaybe<Array<CommentStatus>>;
};

/** Input for the comments query */
export type CommentsInput = {
  /** The filters to apply to the comments query */
  filters?: InputMaybe<CommentsFiltersInput>;
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * The preferred option to sort the comments query results.
   *    default: newestFirst if no provided
   */
  sort?: InputMaybe<Array<CommentsSortInput>>;
};

/** Input for the comments insights query */
export type CommentsInsightsInput = {
  /** The channel id to fetch comments for */
  channelId: Scalars['ChannelId']['input'];
  /** The prompt to fetch comments for */
  prompt: Scalars['String']['input'];
};

/** Response for the comments insights query */
export type CommentsInsightsResponse = {
  __typename?: 'CommentsInsightsResponse';
  /** The insights for the given channel and prompt */
  insights: Scalars['String']['output'];
};

/** Input based on the oEmbed specification plus a required channelId for internal use. */
export type CommentsOEmbedInput = {
  /** ID of the channel making the request. */
  channelId: Scalars['ChannelId']['input'];
  /** The maximum height of the embedded resource (in pixels). */
  maxheight?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum width of the embedded resource (in pixels). */
  maxwidth?: InputMaybe<Scalars['Int']['input']>;
  /** The URL to retrieve the oEmbed representation for. */
  url: Scalars['String']['input'];
};

/** The oEmbed response */
export type CommentsOEmbedResponse = {
  __typename?: 'CommentsOEmbedResponse';
  /** The oEmbed response object as specified by https://oembed.com/. */
  oEmbed: CommentOEmbed;
};

/** Represents a paginated list of comments. */
export type CommentsResults = {
  __typename?: 'CommentsResults';
  /** List of comment edges (each containing a comment and its cursor). */
  edges: Array<CommentsEdge>;
  /** Information about pagination, such as whether more results are available. */
  pageInfo: PaginationPageInfo;
};

/** Input for the comments score query */
export type CommentsScoreInput = {
  /** The channel id to fetch comments for */
  channelId: Scalars['ChannelId']['input'];
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** The score metric for comments */
export type CommentsScoreMetric = {
  __typename?: 'CommentsScoreMetric';
  /** The percentage of the value for the given metric */
  percentage: Scalars['Int']['output'];
  /** The score value of the metric */
  value: Scalars['Int']['output'];
};

/**
 * The response for the comments score query containing the detailed score for the current week,
 * the previous week and the achievement level label for the current week.
 */
export type CommentsScoreResponse = {
  __typename?: 'CommentsScoreResponse';
  /**
   * An achievement level based on the current week score.
   * The potential values are: 'bronze', 'Newcomer', 'Responder', 'Conversationalist', 'EngagementPro', 'CommunityLeader'
   */
  currentAchievementLevel: Scalars['String']['output'];
  /** The score of comments for the current week */
  currentWeekScore: CommentScoreDetailed;
  /** The score of comments for the previous week */
  previousWeekScore: CommentScoreDetailed;
};

/** Fields and direction that can be used to sort comments. */
export type CommentsSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: CommentSortableKey;
};

export type CommonError = {
  __typename?: 'CommonError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CommonMutationError = MutationResponse & {
  __typename?: 'CommonMutationError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CommonMutationResponse = MutationResponse & {
  __typename?: 'CommonMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Common properties for all post metadata types */
export type CommonPostMetadata = {
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

export type CommonTrackingProperties = {
  __typename?: 'CommonTrackingProperties';
  atEventBillingCycle: BillingInterval;
  atEventBillingGateway: BillingGateway;
  atEventBillingPlan: Scalars['String']['output'];
  atEventBillingState: BillingState;
  atEventChannelQty: Scalars['Int']['output'];
  atEventIsNewBuffer: Scalars['Boolean']['output'];
};

/** Input for the completeEmailVerification mutation */
export type CompleteEmailVerificationInput = {
  /** JWT for new email to be verified, as a string */
  emailVerificationJWT: Scalars['String']['input'];
};

/** completeEmailVerification response payload */
export type CompleteEmailVerificationPayload = CompleteEmailVerificationSuccess | UnexpectedError;

/** success response for completeEmailVerification mutation */
export type CompleteEmailVerificationSuccess = {
  __typename?: 'CompleteEmailVerificationSuccess';
  /** Action which was triggered to start complete email verification */
  action: Scalars['String']['output'];
};

/** Input for the completeLoginVerification mutation */
export type CompleteLoginVerificationInput = {
  /** JWT to be verified, as a string */
  loginVerificationJWT: Scalars['String']['input'];
};

/**
 * Channel information returned from the service with connection availability.
 * TODO: create a base interface to avoid duplication with type Channel for common fields
 */
export type ConnectableChannel = {
  __typename?: 'ConnectableChannel';
  /** The avatar URL of the channel */
  avatar: Scalars['String']['output'];
  /** The connection availability of the channel */
  connectionAvailability: ConnectionAvailability;
  /** The display name of the channel - nullable (reason?) */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if the channel is locked - Locked channels can't be used for posting.
   * A channel can be locked when the organization downgrades and reduces the channel quantity of their plan.
   */
  isLocked: Scalars['Boolean']['output'];
  /**
   * Metadata about the location of the business associated with the channel. Only available for Facebook and GPB
   * @deprecated Use metadata instead
   */
  locationData?: Maybe<LocationData>;
  /** The name of the channel - the handle name, username, etc. */
  name: Scalars['String']['output'];
  /** The instance of mastodon of the channel */
  serverUrl?: Maybe<Scalars['String']['output']>;
  /** Represents the external ID of the channel on social network API */
  serviceId: Scalars['String']['output'];
  /** The type of the channel - Page, Profile, Business, Group, Account, etc. */
  type: ChannelType;
};

/** A service that can be connected to an Organization */
export type ConnectableService = {
  __typename?: 'ConnectableService';
  /** The target audience whose content that this service is intended for */
  audience?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of status */
  canConnect: Scalars['Boolean']['output'];
  /** Categories that define how the service should be grouped, this is used for filtering between grouped services */
  categories: Array<ChannelCategory>;
  /** The types of content that can be shared to this service */
  contentTypes: Array<ContentType>;
  /** Descriptive points about the service and its offerings (e.g what the service is used for) */
  description: Array<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of serviceStatus */
  isNew: Scalars['Boolean']['output'];
  /** Support links related to connecting this service */
  links?: Maybe<Array<HelpCenterLink>>;
  /** @deprecated all services belong to a single product */
  products: Array<Product>;
  /** The corresponding service that is being connected */
  service: Service;
  /** A remote URL representing the service logo */
  serviceIconUrl: Scalars['String']['output'];
  /** Global status for the service, defining it's availability within the Buffer product */
  serviceStatus: ServiceStatus;
  /** Other services that are similar to this one (such as similar content types being shared) */
  similarNetworks?: Maybe<Array<Service>>;
  /** Social proof (such as statistic) that demonstrate the success of this service */
  socialProof?: Maybe<Scalars['String']['output']>;
  /** Organization-level status for the service, defining it's availability for the current Organization */
  status: ChannelConnectionStatus;
  /** The subtitle, which will generally consist of the channel types or service offerings */
  subtitle: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  /** The title represents the name of the service being connected */
  title: Scalars['String']['output'];
  /** The type of channels that can be connected via this service */
  types: Array<ChannelType>;
};

/** The error response for connectable services */
export type ConnectableServicesError = {
  __typename?: 'ConnectableServicesError';
  cause: Scalars['String']['output'];
  userFriendlyMessage: Scalars['String']['output'];
};

/**
 * The input provided when requesting connectable services.
 * Note: This will be made non-optional soon, please migrate to provide it
 */
export type ConnectableServicesInput = {
  /**
   * The client the services are being connected from
   * Note: This will be made non-optional soon, please migrate to provide it
   */
  client?: InputMaybe<ClientPlatform>;
  /**
   * The organization ID that is to be connecting the services
   * Note: This will be made non-optional soon, please migrate to provide it
   */
  organization?: InputMaybe<Scalars['ID']['input']>;
};

/** The payload returned when requesting connectable services */
export type ConnectableServicesPayload = ConnectableServicesError | ConnectableServicesResponse;

/** The success response for connectable services */
export type ConnectableServicesResponse = {
  __typename?: 'ConnectableServicesResponse';
  /**
   * A list of services for connection.
   * Not all of these will be available for connection - use the ConnectableService to determine which services
   * can be connected by the Organization.
   */
  services: Array<ConnectableService>;
};

/** Connected App */
export type ConnectedApp = {
  __typename?: 'ConnectedApp';
  /** The id of the connectedApp. */
  clientId: Scalars['ID']['output'];
  /** The date and time when the connected app was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the connected app. */
  description: Scalars['String']['output'];
  /** The name of the connected app. */
  name: Scalars['String']['output'];
  /** The id of the user that has granted access to the app. */
  userId: Scalars['ID']['output'];
  /** The website URL of the connected app. */
  website: Scalars['String']['output'];
};

/**
 * Represents whether a channel can be connected or not.
 * - Available: can be connected (or stolen from the organization that owns it now).
 * - Unavailable: can not be connected because it's owned by an organization that we can't steal it from.
 * - Already connected: the current organization owns this channel already.
 */
export enum ConnectionAvailability {
  AlreadyConnected = 'alreadyConnected',
  Available = 'available',
  Unavailable = 'unavailable'
}

/** The connection status of a service */
export enum ConnectionStatus {
  /** The service is available for connection and should be shown in the UI */
  Available = 'available',
  /** The service cannot be connected. It should still be shown in the UI, using the message from ChannelConnectionStatus to communicate why it is unavailable when the service is clicked. */
  Disabled = 'disabled',
  /**
   * The service is not available for connection and should not be shown to the user.
   * This would be due to the user not being on the split, or not having the entitlement to that service.
   */
  Unavailable = 'unavailable'
}

/** The type of content feed */
export enum ContentFeedType {
  /** News search */
  NewsSearch = 'NewsSearch',
  /** RSS or Atom feed */
  RssAtom = 'RSSAtom'
}

/** Input Types */
export type ContentGenerationInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  previousGeneration?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
  variations?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContentType {
  Analytics = 'analytics',
  AudienceInsights = 'audience_insights',
  Engagement = 'engagement',
  Image = 'image',
  LinkTracking = 'link_tracking',
  PageAnalytics = 'page_analytics',
  Pdf = 'pdf',
  PostAnalytics = 'post_analytics',
  Reels = 'reels',
  Shorts = 'shorts',
  Stories = 'stories',
  Text = 'text',
  Threads = 'threads',
  Video = 'video'
}

/** Input for converting custom channels, like Bluesky or FB Group */
export type ConvertCustomChannelInput = {
  /** Avatar of this channel */
  avatar: Scalars['String']['input'];
  /** ChannelId for the channel being converted */
  channelId: Scalars['ID']['input'];
  /** Display name for this channel */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Name for this channel */
  name: Scalars['String']['input'];
  /** Organization this channel will be connected to */
  organizationId: Scalars['ID']['input'];
  /** Service to convert to */
  service: ChannelThirdPartyService;
  /** ServiceId for the channelConnection that we convert to */
  serviceId: Scalars['String']['input'];
  /** Timezone used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Channel type to convert to */
  type: ChannelType;
};

/** Payload for convertCustomChannel mutation */
export type ConvertCustomChannelPayload = ConvertCustomChannelResponse | CustomChannelError;

/** The response for custom channel conversion */
export type ConvertCustomChannelResponse = {
  __typename?: 'ConvertCustomChannelResponse';
  /** Converted channel */
  channel: Channel;
};

/** Common error type to be used whenever no custom Error type needs to be created */
export type CoreWebAppCommonError = CoreWebAppError & {
  __typename?: 'CoreWebAppCommonError';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/** Base error interface used to implement custom error types */
export type CoreWebAppError = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/** Base mutation response interface used to implement custom mutation response types */
export type CoreWebAppMutationResponse = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type Counters = {
  __typename?: 'Counters';
  labelsCount?: Maybe<Array<Maybe<LabelCount>>>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalPendingComments?: Maybe<Scalars['Int']['output']>;
};

/** Bluesky-specific metadata for custom channel creation */
export type CreateBlueskyMetadata = {
  /** Bluesky account App Password */
  appPassword: Scalars['String']['input'];
  /** Should follow Buffer official profile on Bluesky */
  followBuffer: Scalars['Boolean']['input'];
  /** Bluesky account Handle (username) */
  handle: Scalars['String']['input'];
  /**
   * The server to be used for connection
   * @deprecated extracted from passed handle
   */
  server?: InputMaybe<Scalars['String']['input']>;
};

/** Input for createChannelGroup mutation */
export type CreateChannelGroupInput = {
  /** The account for which the user creates the Channel Group */
  accountId: Scalars['AccountId']['input'];
  /** The channels to be added to the group */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The name of the channel group */
  name: Scalars['String']['input'];
  /** The organization for which the user creates the Channel Group */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors */
export type CreateChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Input parameters required to create a new Checkout session */
export type CreateCheckoutSessionInput = {
  /** The attribution for the subscription */
  attribution?: InputMaybe<AttributionInput>;
  /** The interval of the plan to create the checkout session for */
  interval: BillingInterval;
  /** The ID of the organization for which to create the checkout session */
  organizationId: Scalars['OrganizationId']['input'];
  /** The plan to create the checkout session for */
  plan: ObPlanId;
  /** The quantity of the plan to create the checkout session for */
  quantity: Scalars['Int']['input'];
  /** The redirect URL for the checkout session */
  redirectUrl: Scalars['String']['input'];
};

/** Union type representing either a successful response with a checkout session URL or a billing error */
export type CreateCheckoutSessionPayload = BillingError | CreateCheckoutSessionResponse;

/** Response type for creating a Stripe Checkout session */
export type CreateCheckoutSessionResponse = {
  __typename?: 'CreateCheckoutSessionResponse';
  /** The url returned by Stripe as a redirect for success, failed, or cancelled session */
  redirectUrl: Scalars['String']['output'];
};

/** Channel-specific metadata for custom channel creation */
export type CreateCustomChannelMetadata = {
  /** Bluesky-specific metadata */
  blueskyMetadata?: InputMaybe<CreateBlueskyMetadata>;
  /** FB Group-specific metadata */
  facebookGroupMetadata?: InputMaybe<CreateFacebookGroupMetadata>;
  /** Instagram Personal Profiles-specific metada */
  instagramPersonalProfileMetadata?: InputMaybe<CreateInstagramPersonalProfileMetadata>;
};

/** Input for creating a custom channel */
export type CreateCustomChannelSingleInput = {
  /** Channel-specific metadata to use during creation */
  customChannelMetadata: CreateCustomChannelMetadata;
  /** Organization ID for channel connection */
  organizationId: Scalars['OrganizationId']['input'];
  /** Service for custom channel connection */
  service: ChannelThirdPartyService;
  /** Timezone to be used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Channel type for custom channel connection */
  type: ChannelType;
};

/** Input for creating custom channels, like Bluesky or FB Group */
export type CreateCustomChannelsInput = {
  /** List of channels to create */
  channels: Array<CreateCustomChannelSingleInput>;
};

/** Payload for createCustomChannels mutation */
export type CreateCustomChannelsPayload = CreateCustomChannelsResponse | CustomChannelError;

/** The response for custom channel connection */
export type CreateCustomChannelsResponse = {
  __typename?: 'CreateCustomChannelsResponse';
  /** Created channels */
  channels: Array<Channel>;
};

/** Input parameters required to create a new Customer Portal session */
export type CreateCustomerPortalSessionInput = {
  /** The ID of the organization for which to create the portal session */
  organizationId: Scalars['OrganizationId']['input'];
  /** The URL where the customer will be redirected after they complete their session in the portal */
  returnURL: Scalars['String']['input'];
};

/** Union type representing either a successful response with a portal URL or a billing error */
export type CreateCustomerPortalSessionPayload = BillingError | CreateCustomerPortalSessionResponse;

/** Response type for creating a Stripe Customer Portal session */
export type CreateCustomerPortalSessionResponse = {
  __typename?: 'CreateCustomerPortalSessionResponse';
  /**
   * The customer session url returned by Stripe.
   * This URL provides direct access to the Stripe Customer Portal where users can manage their billing settings.
   */
  customerPortalSessionUrl: Scalars['String']['output'];
};

/** Facebook Group-specific metadata for custom channel creation */
export type CreateFacebookGroupMetadata = {
  /** Avatar URL of this FB Group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this FB Group */
  name: Scalars['String']['input'];
  /** URL to FB Group's page */
  url: Scalars['String']['input'];
};

/** Input for creating a new failed post error. */
export type CreateFailedPostErrorInput = {
  /** Localized link to further information, if any. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Localized link text to display. */
  linkText?: InputMaybe<LocalizedTextInput>;
  /** The patterns that should be matched for this error. */
  patterns: Array<Scalars['String']['input']>;
  /** The position of the error message in the list of error messages. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The service that this error is associated with. */
  service?: InputMaybe<Service>;
  /** Localized text for the error message. */
  text: LocalizedTextInput;
};

/** Union type representing either a successful creation of a failed post error or an error */
export type CreateFailedPostErrorPayload = CreateFailedPostErrorSuccess | InvalidInputError | UnauthorizedError | UnexpectedError;

/** Payload for successfully creating a failed post error. */
export type CreateFailedPostErrorSuccess = {
  __typename?: 'CreateFailedPostErrorSuccess';
  /** The failed post error that was created. */
  failedPostError: FailedPostError;
};

/** Input for createFeedCollection mutation */
export type CreateFeedCollectionInput = {
  /**
   * Feeds to subscribe to in this feed
   * @deprecated Use moveFeed mutation to manage feed associations
   */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
  /** The name of the feed collection. */
  name: Scalars['String']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * Input for createFeed mutation
 * Contains feed creation details to connect
 */
export type CreateFeedInput = {
  /** The collection the feed should be stored in. If null, the feed will be a top level feed. */
  collectionId?: InputMaybe<Scalars['FeedCollectionId']['input']>;
  /** Input for creating a news search feed */
  newsSearch?: InputMaybe<NewsSearchFeedCreation>;
  /** The organization that the feed will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Insert the feed after the feed with the given id. If null, the feed will be inserted at the start of the collection. */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
  /** Input for creating an RSS/Atom feed */
  rssAtom?: InputMaybe<RssAtomFeedCreationInput>;
};

/** Input type for creating an idea group. */
export type CreateIdeaGroupInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Union type representing possible payloads for creating an idea group. */
export type CreateIdeaGroupPayload = IdeaGroup | InvalidInputError | UnauthorizedError | UnexpectedError;

/** createIdea input type */
export type CreateIdeaInput = {
  /** Content and metadata for the new idea */
  content: IdeaContentInput;
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Group placement (null for unassigned group) */
  group?: InputMaybe<IdeaGroupInput>;
  /** Organization ID that will own the idea */
  organizationId: Scalars['ID']['input'];
  /** Template ID used to create the idea */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** createIdea response (including errors) */
export type CreateIdeaPayload = Idea | IdeaResponse | InvalidInputError | LimitReachedError | UnauthorizedError | UnexpectedError;

/** Instagram Personal Profile-specific metadata for custom channel creation */
export type CreateInstagramPersonalProfileMetadata = {
  /** Avatar URL for this channel */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this IG Profile */
  name: Scalars['String']['input'];
};

/** All possible response types that can be returned by updateFeedCollection or createFeedCollection mutation. */
export type CreateOrUpdateFeedCollectionPayload = FeedCollectionActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** All possible response types that can be returned by updateFeedCollection or createFeedCollection mutation. */
export type CreateOrUpdateFeedPayload = FeedActionSuccess | FeedConnectionError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Create post's request input. */
export type CreatePostInput = {
  /** If this post was created with the help of AI */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** assets */
  assets?: InputMaybe<AssetsInput>;
  /** Channel's Id for which we want to create the post */
  channelId: Scalars['ChannelId']['input'];
  /** Is set when the Post is generated from a Draft */
  draftId?: InputMaybe<Scalars['DraftId']['input']>;
  /** Date when the post is scheduled to be published */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Is set when the Post is generated from an Idea */
  ideaId?: InputMaybe<Scalars['IdeaId']['input']>;
  /** Metadata of the post which differs based on the social network/service */
  metadata?: InputMaybe<PostInputMetaData>;
  /** How the post is being scheduled. */
  mode: ShareMode;
  /** Scheduling type to indicate notification publishing or automatic publishing */
  schedulingType: SchedulingType;
  /** source where the composer was initiated from, used for tracking. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** List of tag IDs */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /** Text content of the Post */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for adding a new saved reply. */
export type CreateSavedReplyInput = {
  /** The organization that owns this saved reply. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The saved reply to create. */
  savedReply: SavedReplyToCreateInput;
};

/**
 * Response type for the createSavedReply mutation.
 * It can return either success or an error.
 */
export type CreateSavedReplyPayload = DuplicateError | InvalidInputError | LimitReachedError | NotFoundError | SavedReplyActionSuccess | UnauthorizedError | UnexpectedError;

/** Input to pass when creating a Tag. */
export type CreateTagInput = {
  /** The Organization id to add tags on */
  organizationId: Scalars['OrganizationId']['input'];
  /** The tag to create */
  tag: TagToCreateInput;
};

/** Create tag request response payload. */
export type CreateTagPayload = DuplicateError | InvalidInputError | LimitReachedError | NotFoundError | RestProxyError | TagActionSuccess | UnauthorizedError | UnexpectedError;

export type CredentialsForChannelsError = {
  __typename?: 'CredentialsForChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** An enum representing the type of error that occurred. */
  errorType: ChannelAuthorizationErrorType;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type CredentialsForChannelsInput = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  redirectUri: Scalars['String']['input'];
  service: Service;
};

export type CredentialsForChannelsPayload = CredentialsForChannelsError | CredentialsForChannelsResponse;

export type CredentialsForChannelsResponse = {
  __typename?: 'CredentialsForChannelsResponse';
  connectableChannels: Array<Maybe<ConnectableChannel>>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type CustomChannelCreateInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  service: ChannelThirdPartyService;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: ChannelType;
  url: Scalars['String']['input'];
};

/** Error thrown for custom channel mutations */
export type CustomChannelError = MutationError & {
  __typename?: 'CustomChannelError';
  /** An error message of the issue */
  message: Scalars['String']['output'];
};

export type CustomChannelUpdateInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChannelUpdatePayload = CustomChannelUpdateResponse | CustomChannelsError;

export type CustomChannelUpdateResponse = {
  __typename?: 'CustomChannelUpdateResponse';
  channel: Channel;
};

export type CustomChannelsCreatePayload = CustomChannelsCreateResponse | CustomChannelsError;

export type CustomChannelsCreateResponse = {
  __typename?: 'CustomChannelsCreateResponse';
  channels: Array<Channel>;
};

/** Error thrown for custom channel mutations */
export type CustomChannelsError = {
  __typename?: 'CustomChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

/**
 * Custom Link
 *
 * This type represents a custom link in the shop grid.
 */
export type CustomLink = {
  __typename?: 'CustomLink';
  /** Date of the creation of the link */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the link */
  id: Scalars['ShopGridLinkId']['output'];
  /** Text of the link */
  text: Scalars['String']['output'];
  /** Date of the last update of the link */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the link */
  url: Scalars['URL']['output'];
};

/** Deprecated in favor of Billing type. */
export type Customer = {
  __typename?: 'Customer';
  billing?: Maybe<CustomerBilling>;
  created: Scalars['Int']['output'];
  customerIsPausedWithCoupon: Scalars['Boolean']['output'];
  delinquent: Scalars['Boolean']['output'];
  hasMoreInvoices: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invoices?: Maybe<Array<Maybe<LegacyInvoice>>>;
  name: Scalars['String']['output'];
  products: Subscriptionv2;
};

/** Deprecated in favor of Billing type. */
export type CustomerBilling = {
  __typename?: 'CustomerBilling';
  card?: Maybe<CreditCard>;
};

/** Comparator for filtering by date */
export type DateTimeComparator = {
  /**
   * Include results with dates equal to or before
   * the specified date
   */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Include results with dates equal to or after
   * the specified date
   */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Day = {
  campaigns?: Maybe<Array<PublishingCampaign>>;
  dayName: DayName;
  dayOfMonth: Scalars['Int']['output'];
  monthName: MonthName;
  startTimestamp: Scalars['Int']['output'];
};

export enum DayName {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum DayOfWeek {
  Fri = 'fri',
  Mon = 'mon',
  Sat = 'sat',
  Sun = 'sun',
  Thu = 'thu',
  Tue = 'tue',
  Wed = 'wed'
}

/** Represents the default avatar settings of an author. */
export type DefaultAvatarSettings = {
  __typename?: 'DefaultAvatarSettings';
  /** The consistent text color for the specific author the default avatar (HEX code). */
  backgroundColor: Scalars['String']['output'];
  /** The letter of the author. */
  letter: Scalars['String']['output'];
  /** The consistent text color for the specific author of the default avatar (HEX code). */
  textColor: Scalars['String']['output'];
};

/** input for deleteAccount mutation */
export type DeleteAccountInput = {
  /** Account id of account to delete. */
  accountId: Scalars['AccountId']['input'];
};

/** deleteAccount response payload. */
export type DeleteAccountPayload = DeleteAccountSuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** success response for deleteAccount mutation */
export type DeleteAccountSuccess = MutationSuccess & {
  __typename?: 'DeleteAccountSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for deleteAdminComment mutation */
export type DeleteAdminCommentInput = {
  /** ID of the account that will have the comment delete */
  accountId: Scalars['AccountId']['input'];
};

/** deleteAdminComment response payload */
export type DeleteAdminCommentPayload = EmptySuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for deleteChannelGroup mutation */
export type DeleteChannelGroupInput = {
  /** The id of the channel group */
  id: Scalars['ChannelGroupId']['input'];
};

/** Mutation Response: Success and errors */
export type DeleteChannelGroupPayload = DeleteChannelGroupSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response for deleteChannelGroup mutation */
export type DeleteChannelGroupSuccess = {
  __typename?: 'DeleteChannelGroupSuccess';
  /** The id of the deleted channel group */
  id: Scalars['ChannelGroupId']['output'];
};

export type DeleteEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['input'];
};

export type DeleteEntityNotePayload = CoreWebAppCommonError | DeleteEntityNoteResponse;

export type DeleteEntityNoteResponse = {
  __typename?: 'DeleteEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Input for deleting a failed post error. */
export type DeleteFailedPostErrorInput = {
  /** The ID of the failed post error to delete. */
  id: Scalars['ErrorMessageId']['input'];
};

/** Union type representing either a successful deletion of a failed post error or an error */
export type DeleteFailedPostErrorPayload = DeleteFailedPostErrorSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Payload for successfully deleting a failed post error. */
export type DeleteFailedPostErrorSuccess = {
  __typename?: 'DeleteFailedPostErrorSuccess';
  /** The ID of the failed post error that was deleted. */
  deletedId: Scalars['ErrorMessageId']['output'];
};

/** Input for deleting a feed collection */
export type DeleteFeedCollectionInput = {
  /** The ids of the feeds to delete. */
  feedCollectionId: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** All possible response types that can be returned by deleteFeedCollection mutation. */
export type DeleteFeedCollectionPayload = FeedCollectionDeleteSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for deleting a feed */
export type DeleteFeedInput = {
  /** The feed to delete */
  id: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for feed deletion */
export type DeleteFeedPayload = DeleteFeedResponse | UnexpectedError;

/** Response for deleting a feed */
export type DeleteFeedResponse = {
  __typename?: 'DeleteFeedResponse';
  /** The ID of the deleted feed */
  id: Scalars['FeedId']['output'];
};

/** Input type for deleting an idea group. */
export type DeleteIdeaGroupInput = {
  id: Scalars['ID']['input'];
};

/** Union type representing possible payloads for deleting an idea group. */
export type DeleteIdeaGroupPayload = DeleteIdeaGroupResponse | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response type for deleting an idea group. */
export type DeleteIdeaGroupResponse = {
  __typename?: 'DeleteIdeaGroupResponse';
  updatedIdeas: Array<Idea>;
};

/** Input to pass when deleting a note from a post */
export type DeleteNoteFromPostInput = {
  /** The id of note to delete */
  noteId: Scalars['NoteId']['input'];
  /** The id of post */
  postId: Scalars['PostId']['input'];
};

/** Delete note request response payload. */
export type DeleteNoteFromPostPayload = DeleteNoteFromPostSuccess | InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response */
export type DeleteNoteFromPostSuccess = {
  __typename?: 'DeleteNoteFromPostSuccess';
  /** the full up-to-date post from after the note was deleted */
  post: Post;
};

export type DeletePostInput = {
  postId: Scalars['String']['input'];
};

/** deletePostV2 mutation deletes a post by id. */
export type DeletePostInputV2 = {
  /** Post id to delete. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by deletePostV2 mutation. */
export type DeletePostResult = DeletePostSuccess | NotFoundError | RestProxyError | UnauthorizedError | UnexpectedError;

/** deletePostV2 success response returns the post id that was deleted. */
export type DeletePostSuccess = {
  __typename?: 'DeletePostSuccess';
  /** Post id that was delete. */
  id: Scalars['PostId']['output'];
};

/** Input type for deleting a saved reply. */
export type DeleteSavedReplyInput = {
  /** Id of the saved reply to delete. */
  id: Scalars['SavedReplyId']['input'];
};

/**
 * Response type for the deleteSavedReply mutation.
 * It can return either success or an error.
 */
export type DeleteSavedReplyPayload = DeleteSavedReplySuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful response for deleting a saved reply. */
export type DeleteSavedReplySuccess = {
  __typename?: 'DeleteSavedReplySuccess';
  /** Id of the deleted saved reply. */
  id: Scalars['SavedReplyId']['output'];
};

/** Input for the mutation to delete a shop grid custom link */
export type DeleteShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The ID of the custom link to be deleted */
  id: Scalars['ShopGridLinkId']['input'];
};

/** Success response returns the full up-to-date tag from after deleting a tab. */
export type DeleteTagActionSuccess = {
  __typename?: 'DeleteTagActionSuccess';
  /** Id of the deleted tag. */
  id: Scalars['TagId']['output'];
};

/** Input to pass when deleting a Tag. */
export type DeleteTagInput = {
  /** The id of tag to delete */
  id: Scalars['TagId']['input'];
};

/** Delete tag request response payload. */
export type DeleteTagPayload = DeleteTagActionSuccess | InvalidInputError | NotFoundError | RestProxyError | UnauthorizedError | UnexpectedError;

export type Discount = {
  __typename?: 'Discount';
  duration: DiscountDuration;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: DiscountType;
  value: Scalars['Float']['output'];
};

export enum DiscountDuration {
  Forever = 'forever',
  Once = 'once',
  Repeating = 'repeating'
}

export enum DiscountType {
  Amount = 'amount',
  Percent = 'percent'
}

/** Input type for dismissing all comments for a channel. */
export type DismissAllCommentsByChannelIdInput = {
  /** Id of the channel whose comments should be dismissed. */
  channelId: Scalars['ChannelId']['input'];
};

/** Input type for dismissing all comments for a  organization. */
export type DismissAllCommentsByOrganizationIdInput = {
  /** Id of the organization whose comments should be dismissed. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Input type for dismissing all comments for a post. */
export type DismissAllCommentsByPostIdInput = {
  /** Id of the post whose comments should be dismissed. */
  postId: Scalars['PostId']['input'];
};

/** Input type for dismissing all comments for a list of channel. */
export type DismissAllCommentsForChannelsInput = {
  /** List of channel ids whose comments should be dismissed. */
  channelIds: Array<Scalars['ChannelId']['input']>;
};

/** Mutation Response for Dismissing all comments for a list of channels */
export type DismissAllCommentsForChannelsPayload = DismissAllCommentsForChannelsSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response for a list of channels. */
export type DismissAllCommentsForChannelsSuccess = {
  __typename?: 'DismissAllCommentsForChannelsSuccess';
  /** The list of channels with their comments dismissed or failed to be dismissed. */
  channels?: Maybe<Array<DismissedChannelCommentsPayload>>;
};

/** Mutation Response: Success and errors */
export type DismissAllCommentsPayload = DismissAllCommentsSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response. */
export type DismissAllCommentsSuccess = {
  __typename?: 'DismissAllCommentsSuccess';
  /** The number of comments that were dismissed or enqueued */
  affectedCommentCount: Scalars['Int']['output'];
  /** The operation status: processed or enqueued. */
  status: DismissAllStatus;
};

/** Successful dismiss response. We're using an enum to make room to different statuses in the future. */
export enum DismissAllStatus {
  /** The operation was enqueeued and will be processed asynchronously. */
  Enqueued = 'enqueued',
  /** The operation was completed successfully and the comments were dismissed. */
  Processed = 'processed'
}

export type DismissBannerError = {
  __typename?: 'DismissBannerError';
  cause: Scalars['String']['output'];
};

export type DismissBannerPayload = DismissBannerError | DismissBannerResponse;

export type DismissBannerResponse = {
  __typename?: 'DismissBannerResponse';
  success: Scalars['Boolean']['output'];
};

/**
 * Input type for the `dismissComment` mutation.
 * Defines the comment being dismissed.
 */
export type DismissCommentInput = {
  /** ID of the comment being dismissed. */
  commentId: Scalars['CommentId']['input'];
};

/** Mutation Response: Success and errors */
export type DismissCommentPayload = DismissCommentSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response. */
export type DismissCommentSuccess = {
  __typename?: 'DismissCommentSuccess';
  /** The comment that was successfully dismissed. */
  comment: CommentData;
};

/** Payload for a dismissed channel comments. */
export type DismissedChannelCommentsPayload = {
  __typename?: 'DismissedChannelCommentsPayload';
  /** The id of the channel. */
  id: Scalars['ChannelId']['output'];
  /** The status of the operation. */
  status: DismissedChannelCommentsPayloadStatus;
};

/** Enum for the status of the operation for a channel related to the dismissal of comments. */
export enum DismissedChannelCommentsPayloadStatus {
  /** The operation has failed for the channel. */
  Error = 'error',
  /** The operation was completed successfully and the comments were dismissed for the channel. */
  Success = 'success'
}

export type DismissedObject = {
  __typename?: 'DismissedObject';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
};

export type DismissedObjectInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
};

/** Document asset */
export type DocumentAsset = Asset & {
  __typename?: 'DocumentAsset';
  /** Document specific metadata */
  document: DocumentMetadata;
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Document asset */
export type DocumentAssetInput = {
  /** Document thumbnail URL */
  thumbnailUrl: Scalars['String']['input'];
  /** Document title */
  title: Scalars['String']['input'];
  /** Document URL */
  url: Scalars['String']['input'];
};

/** Document metadata */
export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  /** Document fileSize in bytes */
  filesize?: Maybe<Scalars['Int']['output']>;
  /** Number of pages in the document */
  numPages: Scalars['Int']['output'];
  /** URLs to the static thumbnails of the document pages */
  thumbnails: Array<Scalars['String']['output']>;
};

/** Drop post's request input. */
export type DropPostInput = {
  /** New dueAt date */
  dueAt: Scalars['DateTime']['input'];
  /** ID of post to update */
  id: Scalars['PostId']['input'];
  /** By default true so it would pin to slot. */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Drop post's request response payload. */
export type DropPostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Error returned when a unique constraint is violated */
export type DuplicateError = MutationError & {
  __typename?: 'DuplicateError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type EditEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type EditEntityNotePayload = CoreWebAppCommonError | EditEntityNoteResponse;

export type EditEntityNoteResponse = {
  __typename?: 'EditEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Edit post's request input. */
export type EditPostInput = {
  /** If this post was edited with the help of AI */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** assets */
  assets?: InputMaybe<AssetsInput>;
  /** Is set when the Post is generated from a Draft */
  draftId?: InputMaybe<Scalars['DraftId']['input']>;
  /** Date when the post is scheduled to be published */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of the post to edit */
  id: Scalars['PostId']['input'];
  /** Is set when the Post is generated from an Idea */
  ideaId?: InputMaybe<Scalars['IdeaId']['input']>;
  /** Metadata of the post which differs based on the social network/service */
  metadata?: InputMaybe<PostInputMetaData>;
  /** How the post is being scheduled. */
  mode: ShareMode;
  /** Scheduling type to indicate notification publishing or automatic publishing */
  schedulingType: SchedulingType;
  /** source where the composer was initiated from, used for tracking. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** tags */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /** Text content of the Post */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EmailNotificationPreference = {
  __typename?: 'EmailNotificationPreference';
  cioTopicId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subscribed: Scalars['Boolean']['output'];
};

export type EmailNotificationPreferenceError = {
  __typename?: 'EmailNotificationPreferenceError';
  message: Scalars['String']['output'];
};

export type EmailNotificationPreferenceInput = {
  id: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};

export type EmailNotificationPreferencePayload = EmailNotificationPreferenceError | EmailNotificationPreferencesResponse;

export type EmailNotificationPreferencesResponse = {
  __typename?: 'EmailNotificationPreferencesResponse';
  preferences: Array<EmailNotificationPreference>;
};

/**
 * Empty mutation success response used when client doesn't need any data back
 * or simply needs to respond to a success or error.
 */
export type EmptySuccess = MutationSuccess & {
  __typename?: 'EmptySuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type EngageChannel = {
  __typename?: 'EngageChannel';
  backfillingComplete?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelsCount?: Maybe<Array<Maybe<LabelCount>>>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalPendingComments?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EngageOrganization = {
  __typename?: 'EngageOrganization';
  channels?: Maybe<Array<Maybe<EngageChannel>>>;
  emojis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type EngagePost = {
  __typename?: 'EngagePost';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  backfilling?: Maybe<Scalars['Boolean']['output']>;
  channelService?: Maybe<Scalars['String']['output']>;
  channelServiceId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  commentsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  dismissingAll?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGiveaway?: Maybe<Scalars['Boolean']['output']>;
  labelsCount?: Maybe<Array<Maybe<LabelCount>>>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalLikes?: Maybe<Scalars['Int']['output']>;
  totalPendingComments?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EngagementMutationResponse = MutationResponse & {
  __typename?: 'EngagementMutationResponse';
  channel?: Maybe<EngageChannel>;
  channelCounters?: Maybe<Counters>;
  code: Scalars['String']['output'];
  comment?: Maybe<Comment>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  engagedWithId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  post?: Maybe<EngagePost>;
  postCounters?: Maybe<Counters>;
  reply?: Maybe<Reply>;
  replySent?: Maybe<Reply>;
  success: Scalars['Boolean']['output'];
};

/** Representation of a feature that a user has access to. */
export enum Entitlement {
  Analytics = 'analytics',
  AnalyticsOnPosts = 'analyticsOnPosts',
  ApprovalFlow = 'approvalFlow',
  Bluesky = 'bluesky',
  Calendar = 'calendar',
  Campaigns = 'campaigns',
  ChannelGroupsInComposer = 'channelGroupsInComposer',
  ChannelSearchBar = 'channelSearchBar',
  Content = 'content',
  CustomBitly = 'customBitly',
  CustomVideoThumbnailInstagram = 'customVideoThumbnailInstagram',
  CustomizeUtmParam = 'customizeUTMParam',
  Drafts = 'drafts',
  Engagement = 'engagement',
  FinishLater = 'finishLater',
  FirstComment = 'firstComment',
  FirstCommentLinkedin = 'firstCommentLinkedin',
  HashtagManager = 'hashtagManager',
  InstagramPersonalProfile = 'instagramPersonalProfile',
  Mastodon = 'mastodon',
  MobileOverview = 'mobileOverview',
  Notes = 'notes',
  OfflinePosts = 'offlinePosts',
  Pinterest = 'pinterest',
  Publishing = 'publishing',
  SentPosts30Days = 'sentPosts30Days',
  ShareNext = 'shareNext',
  ShopGrid = 'shopGrid',
  StartPage = 'startPage',
  Stories = 'stories',
  TagUsersInImages = 'tagUsersInImages',
  Tags = 'tags',
  TeamsPanel = 'teamsPanel',
  Threads = 'threads',
  Tiktok = 'tiktok',
  TwitterImpressions = 'twitterImpressions',
  TwitterLongContent = 'twitterLongContent',
  UnlimitedUploads = 'unlimitedUploads',
  Youtube = 'youtube'
}

export enum EntityWithNotes {
  Idea = 'idea',
  Post = 'post'
}

/** Basic mutation error */
export type Error = {
  __typename?: 'Error';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ExternalServiceDomain {
  Analytics = 'analytics',
  Broadcasting = 'broadcasting',
  Engagement = 'engagement',
  Publish = 'publish'
}

export type FacebookEntity = {
  __typename?: 'FacebookEntity';
  content: Scalars['String']['output'];
  indices: Array<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Facebook metadata */
export type FacebookMetadata = {
  __typename?: 'FacebookMetadata';
  /** Metadata about the location of the business associated with the channel. Only available for Facebook and GPB */
  locationData?: Maybe<LocationData>;
};

/** Facebook post metadata */
export type FacebookPostMetadata = CommonPostMetadata & {
  __typename?: 'FacebookPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Facebook post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** Title of Facebook reel */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Facebook post metadata */
export type FacebookPostMetadataInput = {
  /** Annotations representing entities in the text */
  annotations?: InputMaybe<Array<AnnotationInputFacebook>>;
  /** Facebook post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** The channel-specific type of the post, eg, post, story, reel for Facebook */
  type: PostTypeFacebook;
};

/** Failed post error entity. */
export type FailedPostError = {
  __typename?: 'FailedPostError';
  /** ID of the failed post error. */
  id: Scalars['ErrorMessageId']['output'];
  /** A link to further information, if any. */
  link?: Maybe<Scalars['String']['output']>;
  /** The localized link text. */
  linkText?: Maybe<LocalizedText>;
  /** The patterns used to match this error. */
  patterns: Array<Scalars['String']['output']>;
  /** The position of the error in the post. */
  position: Scalars['Int']['output'];
  /** The service that this error is associated with. */
  service?: Maybe<Service>;
  /** The localized error message text. */
  text: LocalizedText;
  /** When the failed post error was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum FeatureAction {
  ExpandText = 'expandText',
  GenerateIdeas = 'generateIdeas',
  GenerateSuggestions = 'generateSuggestions',
  GenerateText = 'generateText',
  RephraseText = 'rephraseText',
  SummarizeText = 'summarizeText'
}

export type FeatureFlip = {
  __typename?: 'FeatureFlip';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum FeaturePlatform {
  Android = 'android',
  Ios = 'ios',
  Mobile = 'mobile',
  Web = 'web'
}

/**
 * A feed is a collection of feed items owned by a single organization.
 * An example of a feed is a RSS feed.
 */
export type Feed = {
  __typename?: 'Feed';
  /**
   * The collection this feed belongs to. If null, this is a top level feed
   * and does not belong to any collections
   */
  collection?: Maybe<FeedCollection>;
  /** Metadata used to connect to the feed. */
  connectionMetadata: FeedConnectionMetadata;
  /**
   * The browsable view of the feed (when applicable), eg the youtube channel,
   * News category page, Blog, etc
   */
  homepage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the feed. */
  id: Scalars['FeedId']['output'];
  /** The last time we refreshed the feed. */
  lastRefreshed: Scalars['DateTime']['output'];
  /** The name of the feed, typically defined by the feed itself. */
  name: Scalars['String']['output'];
  /** The organization that owns this feed. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Float value for ordering among sibling feeds. */
  sortPosition: Scalars['Float']['output'];
  /** The type of content feed */
  type: ContentFeedType;
};

/** Successful response following an update to an RSS feed */
export type FeedActionSuccess = {
  __typename?: 'FeedActionSuccess';
  /** Feed on which the action was successfully performed. */
  feed: Feed;
};

/** A feed collection is a collection of feeds created by a single organization. */
export type FeedCollection = {
  __typename?: 'FeedCollection';
  /**
   * The feeds in the feed collection.
   * @deprecated Use Feed.collection instead to query feed associations
   */
  feeds: Array<Feed>;
  /** The unique identifier for the feed collection. */
  id: Scalars['FeedCollectionId']['output'];
  /** The name of the feed collection. */
  name: Scalars['String']['output'];
  /** The organization that owns the feed collection. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Float value for ordering among feed collections at the same level. */
  sortPosition: Scalars['Float']['output'];
};

/** Successful response following an update to an RSS feed collection */
export type FeedCollectionActionSuccess = {
  __typename?: 'FeedCollectionActionSuccess';
  /** Feed Group on which the action was successfully performed. */
  feedCollection: FeedCollection;
};

/** Results for the feed collections query. */
export type FeedCollectionConnection = {
  __typename?: 'FeedCollectionConnection';
  /** The list of feed collections that match the query. */
  edges: Array<FeedCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** Successful response following a deletion of feed collections */
export type FeedCollectionDeleteSuccess = {
  __typename?: 'FeedCollectionDeleteSuccess';
  /** Feed Group ID which was deleted */
  feedCollectionId: Scalars['FeedCollectionId']['output'];
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type FeedCollectionEdge = {
  __typename?: 'FeedCollectionEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current feed collection in the list. */
  node: FeedCollection;
};

/** Query input to load a single feed collection */
export type FeedCollectionInput = {
  /** The feed collection ID */
  id: Scalars['FeedCollectionId']['input'];
  /** The organization ID to fetch the feed collection for */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Query input to load a list of feed collections */
export type FeedCollectionsInput = {
  /** The organization ID to fetch feed collections for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Error connecting to source feed - this is most often due to typos in RSS feeds */
export type FeedConnectionError = {
  __typename?: 'FeedConnectionError';
  /** The type of error that occured */
  error: FeedConnectionErrorType;
  /** Human readable error message */
  message: Scalars['String']['output'];
  /** Feed suggestions that the user is likely looking for */
  suggestions: Array<FeedConnectionSuggestion>;
};

/** Error type from connection attempt */
export enum FeedConnectionErrorType {
  /** Response from server was not valid atom/RSS */
  MalformedResponse = 'MalformedResponse',
  /** Server sent a 4** response, indicating the user is not allowed to access */
  NotAllowed = 'NotAllowed',
  /** The server took too long to respond */
  Timeout = 'Timeout',
  /** An uncategorized error occured */
  Unknown = 'Unknown'
}

/** Abstact union type representing RSS Feeds */
export type FeedConnectionMetadata = NewsSearchConnectionMetadata | RssFeedConnectionMetadata;

/** Feed data provided as a suggestion */
export type FeedConnectionSuggestion = {
  __typename?: 'FeedConnectionSuggestion';
  /** Metadata used to connect to the feed. */
  connectionMetadata: FeedConnectionMetadata;
  /**
   * The browsable view of the feed (when applicable), eg the youtube channel,
   * News category page, Blog, etc
   */
  homepage?: Maybe<Scalars['String']['output']>;
  /** The name of the feed, typically defined by the feed itself. */
  name: Scalars['String']['output'];
  /** The type of content feed */
  type: ContentFeedType;
};

/** Query input to load a single feed */
export type FeedInput = {
  /** The feed ID */
  id: Scalars['FeedId']['input'];
  /** The organization ID to fetch the feed for */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * An individual feed item. Feed items are shared amongst all users.
 * An example of a feed item is a news article from an RSS feed.
 */
export type FeedItem = {
  __typename?: 'FeedItem';
  /** The URL for the feed item. */
  articleUrl: Scalars['String']['output'];
  /** The date the feed item was published. */
  contentTextPreview: Scalars['String']['output'];
  /** The date the feed item was created/published. */
  createdAt: Scalars['DateTime']['output'];
  /** The feed that the item belongs to. */
  feed: Feed;
  /** The unique identifier for the feed item. */
  id: Scalars['FeedItemId']['output'];
  /** The title of the feed item. */
  title: Scalars['String']['output'];
};

/** Results for the feed contents query. */
export type FeedItemConnection = {
  __typename?: 'FeedItemConnection';
  /** The list of feed items that match the query. */
  edges: Array<FeedItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** An edge in a connection. */
export type FeedItemEdge = {
  __typename?: 'FeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeedItem;
};

/** Query input to load feed items */
export type FeedItemsFiltersInput = {
  /** The feed collection ID. When set, it will return feed items for the given feed collection */
  feedCollectionIds?: InputMaybe<Array<Scalars['FeedCollectionId']['input']>>;
  /** The feed IDs. When set, it will return feed items for the given feeds. */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
};

/** Input to fetch feed items */
export type FeedItemsInput = {
  /** The filters to apply to the feed items query */
  filter?: InputMaybe<FeedItemsFiltersInput>;
  /** The Organization id to fetch feed items for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for feed move operations */
export type FeedMoveUpdatesPayload = FeedMoveUpdatesResponse | UnexpectedError;

/** Response containing updated feeds and collections after a move operation */
export type FeedMoveUpdatesResponse = {
  __typename?: 'FeedMoveUpdatesResponse';
  /** Feed collections that have updated due to move */
  updatedFeedCollections: Array<FeedCollection>;
  /** Feeds that have updated due to move */
  updatedFeeds: Array<Feed>;
};

/** Query input to load a list of feeds */
export type FeedsInput = {
  /** The organization ID to fetch feeds for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type FilterBy = {
  by: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Input parameters for generating hashtags based on a post's content */
export type FreeToolHashtagGeneratorTemplateInput = {
  /** Content of a post to generate hashtags for */
  content: Scalars['String']['input'];
  /** The service to generate hashtags for. Defaults to instagram */
  service: Service;
};

export type From = {
  __typename?: 'From';
  isChannel?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type GatewayDetails = {
  __typename?: 'GatewayDetails';
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** This is available only on the paid plans and will have the values android, apple and web when the plan is purchased via the play_store, app_store or web (stripe) respectively. */
  gatewayPlatform?: Maybe<BillingGatewayPlatform>;
  gatewayType: BillingGateway;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Main input for generating templated completions */
export type GenerateTemplatedCompletionInput = {
  /**
   * Token, required for free tools, to validate usage of API via
   * Free tools
   */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional call-to-action text to include in the completion */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Parameters for the selected template */
  freeToolHashtagGenerator?: InputMaybe<FreeToolHashtagGeneratorTemplateInput>;
  /** Marketing id to be used when using completions via free tools */
  marketingId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization requesting the completion */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Selected template for completion generation */
  template: GenerateTemplatedCompletionTemplate;
  /** Number of different variations to generate */
  variations?: InputMaybe<Scalars['Int']['input']>;
};

/** Union type for possible completion mutation responses */
export type GenerateTemplatedCompletionPayload = GenerateTemplatedCompletionSuccess | LimitReachedError | UnexpectedError;

/** Successful completion generation response */
export type GenerateTemplatedCompletionSuccess = {
  __typename?: 'GenerateTemplatedCompletionSuccess';
  /** Array of generated completion suggestions */
  suggestions: Array<GenerateTemplatedCompletionSuggestion>;
};

/** Individual completion suggestion container */
export type GenerateTemplatedCompletionSuggestion = {
  __typename?: 'GenerateTemplatedCompletionSuggestion';
  /** Generated completion text content */
  content: Scalars['String']['output'];
};

/** Available templates for AI text completion generation */
export enum GenerateTemplatedCompletionTemplate {
  /** Generates a list of hashtags based on a post's content */
  FreeToolHashtagGenerator = 'freeToolHashtagGenerator'
}

export type GenericSubscription = {
  interval: BillingInterval;
  trial?: Maybe<Trial>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Input for getAccessTokenForChannel query */
export type GetAccessTokensForChannelInput = {
  /** ID of channel */
  channelId: Scalars['ChannelId']['input'];
  /** TFA code to verify. */
  tfaCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * JWT token to verify instead of TFA code. This token is used to allow advocates a short window of time
   * to perform sensitive actions without needing to enter a TFA code again.
   */
  tfaToken?: InputMaybe<Scalars['String']['input']>;
};

/** getAccessTokenForChannel response payload. */
export type GetAccessTokensForChannelPayload = AccessTokens | NotFoundError | UnauthorizedError | UnexpectedError | UnsupportedChannelError;

export type GoogleBusinessData = {
  __typename?: 'GoogleBusinessData';
  code?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String']['output'];
  start_date?: Maybe<Scalars['Int']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Metadata for a GBP post that is an event */
export type GoogleBusinessEventMetaData = {
  __typename?: 'GoogleBusinessEventMetaData';
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** End date of the event */
  endDate: Scalars['DateTime']['output'];
  /**
   * End time of the event
   * @deprecated get time from the endDate
   */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Indicate whether the event has a start or end time. */
  isFullDayEvent: Scalars['Boolean']['output'];
  /** Link to the action */
  link?: Maybe<Scalars['String']['output']>;
  /** Start date of the event */
  startDate: Scalars['DateTime']['output'];
  /**
   * Start time of the event
   * @deprecated get time from the startDate
   */
  startTime?: Maybe<Scalars['String']['output']>;
  /** Title of the event */
  title: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an event */
export type GoogleBusinessEventMetaDataInput = {
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** End date of the event */
  endDate: Scalars['DateTime']['input'];
  /** Indicate whether the event has a start or end time. */
  isFullDayEvent: Scalars['Boolean']['input'];
  /** Link to the action */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the event */
  startDate: Scalars['DateTime']['input'];
  /** Title of the event */
  title: Scalars['String']['input'];
};

/** Google Business metadata */
export type GoogleBusinessMetadata = {
  __typename?: 'GoogleBusinessMetadata';
  /** Metadata about the location of the business associated with the channel. Only available for Facebook and GPB */
  locationData?: Maybe<LocationData>;
};

/** Metadata for a GBP post that is an offer */
export type GoogleBusinessOfferMetaData = {
  __typename?: 'GoogleBusinessOfferMetaData';
  /** Coupon code for the offer */
  code?: Maybe<Scalars['String']['output']>;
  /** End date of the offer */
  endDate: Scalars['DateTime']['output'];
  /** Link to the offer */
  link?: Maybe<Scalars['String']['output']>;
  /** Start date of the offer */
  startDate: Scalars['DateTime']['output'];
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Title of the offer */
  title: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an offer */
export type GoogleBusinessOfferMetaDataInput = {
  /** Coupon code for the offer */
  code?: InputMaybe<Scalars['String']['input']>;
  /** End date of the offer */
  endDate: Scalars['DateTime']['input'];
  /** Link to the offer */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the offer */
  startDate: Scalars['DateTime']['input'];
  /** Terms and Conditions */
  terms?: InputMaybe<Scalars['String']['input']>;
  /** Title of the offer */
  title: Scalars['String']['input'];
};

/** List of possible types for GBP cta */
export enum GoogleBusinessPostActionType {
  Book = 'book',
  Call = 'call',
  LearnMore = 'learn_more',
  None = 'none',
  Order = 'order',
  Shop = 'shop',
  Signup = 'signup'
}

/** GoogleBusiness Metadata details */
export type GoogleBusinessPostDetails = GoogleBusinessEventMetaData | GoogleBusinessOfferMetaData | GoogleBusinessWhatsNewMetaData;

/**
 * Google Business Profile post metadata
 * @deprecated: pending proposal for specific GBP post types: update, offer and event metadata types
 */
export type GoogleBusinessPostMetadata = CommonPostMetadata & {
  __typename?: 'GoogleBusinessPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Details of the metadata */
  details?: Maybe<GoogleBusinessPostDetails>;
  /** Title if available in the given GBP post type: event and offer */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/**
 * Google Business Profile post metadata
 * @deprecated: pending proposal for specific GBP post types: update, offer and event metadata types
 */
export type GoogleBusinessPostMetadataInput = {
  /** Details of the Event metadata */
  detailsEvent?: InputMaybe<GoogleBusinessEventMetaDataInput>;
  /** Details of the Offer metadata */
  detailsOffer?: InputMaybe<GoogleBusinessOfferMetaDataInput>;
  /** Details of the Whats new metadata */
  detailsWhatsNew?: InputMaybe<GoogleBusinessWhatsNewMetaDataInput>;
  /** Title if available in the given GBP post type: event and offer */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The channel-specific type of the post, eg, post, offer, event for Google Business Profile */
  type: PostTypeGoogleBusiness;
};

/** Metadata for a GBP post of type Whats new */
export type GoogleBusinessWhatsNewMetaData = {
  __typename?: 'GoogleBusinessWhatsNewMetaData';
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** Link to the action */
  link?: Maybe<Scalars['String']['output']>;
};

/** Metadata for a GBP post of type Whats new */
export type GoogleBusinessWhatsNewMetaDataInput = {
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** Link to the action */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type HealthStatus = {
  __typename?: 'HealthStatus';
  ok: Scalars['Boolean']['output'];
};

export type HellonextSsoMutationResponse = Error | HellonextSsoResponse | UnverifiedEmailAddressError;

export type HellonextSsoResponse = {
  __typename?: 'HellonextSsoResponse';
  ssoToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type HelpCenterLink = {
  __typename?: 'HelpCenterLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HexColor = {
  __typename?: 'HexColor';
  value?: Maybe<Scalars['String']['output']>;
};

/** Ideas are the main entity in the create space */
export type Idea = {
  __typename?: 'Idea';
  /** The actual content and metadata of the idea */
  content: IdeaContent;
  /** Unix timestamp of when the idea was created */
  createdAt: Scalars['Int']['output'];
  /** ID of the group this idea belongs to (if any) */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the idea */
  id: Scalars['ID']['output'];
  /** ID of the organization that owns this idea */
  organizationId: Scalars['ID']['output'];
  /** Numerical position for ordering within a group */
  position?: Maybe<Scalars['Float']['output']>;
  /** Unix timestamp of when the idea was last modified */
  updatedAt: Scalars['Int']['output'];
};

/** Content of an idea */
export type IdeaContent = {
  __typename?: 'IdeaContent';
  /** Indicates whether AI tools were used in creating this idea */
  aiAssisted: Scalars['Boolean']['output'];
  /** DateTime set by user associated with the idea - this often reflects a target publish date. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** List of media items attached to the idea */
  media?: Maybe<Array<IdeaMedia>>;
  /** Services tagged by the user - this is typically used to annotate ideas with their target services */
  services: Array<Service>;
  /** Tags used to categorize and organize the idea */
  tags: Array<PublishingTag>;
  /** Main body text or description of the idea */
  text?: Maybe<Scalars['String']['output']>;
  /** Title or headline of the idea */
  title?: Maybe<Scalars['String']['output']>;
};

/** content input for creating/updating an idea */
export type IdeaContentInput = {
  /** Whether AI tools were used in creation */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target date for the idea, often used for planning publish schedules */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of media items to attach */
  media?: InputMaybe<Array<IdeaMediaInput>>;
  /** Services associated with the idea for targeting specific platforms */
  services?: InputMaybe<Array<Service>>;
  /** Tags to categorize the idea */
  tags?: InputMaybe<Array<TagInput>>;
  /** Main body text or description */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Title or headline of the idea */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IdeaCreationInput = {
  content: IdeaContentInput;
  cta?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['String']['input'];
  /** @deprecated Use input.cta instead */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination type for Ideas */
export type IdeaEdge = {
  __typename?: 'IdeaEdge';
  /** Opaque cursor for pagination, used to fetch subsequent pages */
  cursor: Scalars['String']['output'];
  /** The idea object */
  node: Idea;
};

/** Idea groups are used to organize ideas in the board */
export type IdeaGroup = {
  __typename?: 'IdeaGroup';
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** idea group input for create/update */
export type IdeaGroupInput = {
  /** Target group ID (null for unassigned group) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of idea to place after (null for top position) */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for retrieving idea groups by organization ID. */
export type IdeaGroupsInput = {
  organizationId: Scalars['ID']['input'];
};

export type IdeaIdInput = {
  id: Scalars['String']['input'];
};

/** Media attached to an idea */
export type IdeaMedia = {
  __typename?: 'IdeaMedia';
  /** Alternative text description for accessibility */
  alt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the media in Buffer's upload system */
  id: Scalars['ID']['output'];
  /** File size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Source platform information for the media */
  source?: Maybe<IdeaMediaSource>;
  /** URL to a smaller version of the media for preview purposes */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Type of media (e.g., image, video, gif) */
  type: MediaType;
  /** Direct URL to access the media file */
  url: Scalars['String']['output'];
};

export type IdeaMediaInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The upload id */
  id: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<IdeaMediaSourceInput>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  type: MediaType;
  url: Scalars['String']['input'];
};

/** Media source for the idea, e.g. Unsplash, Gifphy, etc. */
export type IdeaMediaSource = {
  __typename?: 'IdeaMediaSource';
  /** Name of the content creator/author */
  author?: Maybe<Scalars['String']['output']>;
  /** URL to the author's profile on the source platform */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier from the source platform */
  id?: Maybe<Scalars['String']['output']>;
  /** Name of the media source platform (e.g., 'Unsplash', 'Giphy') */
  name: Scalars['String']['output'];
};

export type IdeaMediaSourceInput = {
  /** for unsplash only */
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type IdeaMutationPayload = CoreWebAppCommonError | IdeaMutationSuccess;

export type IdeaMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeaMutationSuccess';
  code: Scalars['String']['output'];
  /** The created ideas */
  idea: Idea;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IdeaPayload = CoreWebAppCommonError | Idea;

/** createIdea response type */
export type IdeaResponse = {
  __typename?: 'IdeaResponse';
  /** The affected idea */
  idea?: Maybe<Idea>;
  /** If true, the client should refresh the ideas list because other ideas might have been moved */
  refreshIdeas: Scalars['Boolean']['output'];
};

export type IdeaUpdateInput = {
  content: IdeaContentInput;
  cta?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
};

export type IdeasCount = {
  __typename?: 'IdeasCount';
  count: Scalars['Int']['output'];
};

export type IdeasCountByTag = {
  __typename?: 'IdeasCountByTag';
  count: Scalars['Int']['output'];
  tagId: Scalars['String']['output'];
};

export type IdeasCountByTagInput = {
  organizationId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type IdeasCountByTags = {
  __typename?: 'IdeasCountByTags';
  counts: Array<IdeasCountByTag>;
};

export type IdeasCountByTagsPayload = CoreWebAppCommonError | IdeasCountByTags;

export type IdeasCountPayload = CoreWebAppCommonError | IdeasCount;

export type IdeasDeletionInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type IdeasDeletionPayload = CoreWebAppCommonError | IdeasDeletionSuccess;

export type IdeasDeletionSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeasDeletionSuccess';
  code: Scalars['String']['output'];
  /** The deleted ideas */
  ideas: Array<Idea>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** @deprecated: Use IdeasListInputV2 */
export type IdeasListInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterBy>;
  first: Scalars['Int']['input'];
  order?: InputMaybe<OrderBy>;
  organizationId: Scalars['String']['input'];
};

/** Input to filter ideas */
export type IdeasListInputV2 = {
  /**
   * Legacy filter argument - deprecated in favor of tags
   * @deprecated Use the tags filter input
   */
  filter?: InputMaybe<FilterBy>;
  /** Filter by idea groups: null means no filtering, null ID in array includes unassigned ideas */
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The organization ID to fetch ideas from */
  organizationId: Scalars['ID']['input'];
  /** Filter by tags: null means no filtering, null ID in array includes untagged ideas */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Image = {
  __typename?: 'Image';
  author?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  regularUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** Image asset */
export type ImageAsset = Asset & {
  __typename?: 'ImageAsset';
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** Image specific metadata */
  image: ImageMetadata;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Image asset */
export type ImageAssetInput = {
  /** Image specific metadata */
  metadata?: InputMaybe<ImageMetadataInput>;
  /** URL to the static thumbnail of the asset */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the file source */
  url: Scalars['String']['input'];
};

/** Image dimensions */
export type ImageDimensionsInput = {
  /** Image height in pixels */
  height: Scalars['Int']['input'];
  /** Image width in pixels */
  width: Scalars['Int']['input'];
};

/** Image metadata */
export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  /** Alternative text for accessibility */
  altText: Scalars['String']['output'];
  /** Animated thumbnail URL */
  animatedThumbnail?: Maybe<Scalars['String']['output']>;
  /** Image height in pixels */
  height: Scalars['Int']['output'];
  /** Is the image animated? */
  isAnimated: Scalars['Boolean']['output'];
  /** User tags in the image */
  userTags?: Maybe<Array<UserTag>>;
  /** Image width in pixels */
  width: Scalars['Int']['output'];
};

/** Image metadata */
export type ImageMetadataInput = {
  /** Alternative text for accessibility */
  altText: Scalars['String']['input'];
  /** Animated thumbnail URL */
  animatedThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** Image dimensions */
  dimensions?: InputMaybe<ImageDimensionsInput>;
  /** User tags in the image */
  userTags?: InputMaybe<Array<UserTagInput>>;
};

export type ImageResultInfo = {
  __typename?: 'ImageResultInfo';
  count: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  query?: Maybe<Scalars['String']['output']>;
};

export type ImageSearchError = MutationBasicError & {
  __typename?: 'ImageSearchError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ImageSearchPayload = ImageSearchError | ImageSearchResponse;

export type ImageSearchResponse = {
  __typename?: 'ImageSearchResponse';
  images: Array<Maybe<Image>>;
  info: ImageResultInfo;
};

export type ImpersonationResponse = Error | Response;

/** input for initiateEmailUpdateRequest mutation */
export type InitiateEmailUpdateRequestInput = {
  /** Account id to change email address. */
  accountId: Scalars['AccountId']['input'];
  /** New email address to set. */
  newEmail: Scalars['String']['input'];
};

/** initiateEmailUpdateRequest response payload. */
export type InitiateEmailUpdateRequestPayload = InitiateEmailUpdateRequestSuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** success response for setPasswordForAccount mutation */
export type InitiateEmailUpdateRequestSuccess = MutationSuccess & {
  __typename?: 'InitiateEmailUpdateRequestSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updateEmail mutation */
export type InitiateUpdateEmailInput = {
  /** Account id of account to update email of. */
  accountId: Scalars['AccountId']['input'];
  /** Indicate whether it is a backup email */
  isBackupEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** New email to update Account with */
  newEmail: Scalars['String']['input'];
  /** Password for Account to verify if we allow updating the email */
  password: Scalars['String']['input'];
};

/** updateEmail response payload */
export type InitiateUpdateEmailPayload = EmptySuccess | InvalidInputError | NotFoundError | UnexpectedError;

export type InstagramData = {
  __typename?: 'InstagramData';
  comment_text?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String']['output'];
  service_geolocation_id?: Maybe<Scalars['String']['output']>;
  service_geolocation_name?: Maybe<Scalars['String']['output']>;
};

/** Instagram Geolocation */
export type InstagramGeolocation = {
  __typename?: 'InstagramGeolocation';
  /** The id of this location */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of this location */
  text?: Maybe<Scalars['String']['output']>;
};

/** Instagram Geolocation */
export type InstagramGeolocationInput = {
  /** The id of this location */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of this location */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Instagram metadata */
export type InstagramMetadata = {
  __typename?: 'InstagramMetadata';
  /**
   * Indicates if we should default to reminder for Instagram
   * Source: field resolver: profile.default_to_reminders
   */
  defaultToReminders: Scalars['Boolean']['output'];
};

/** Instagram post metadata */
export type InstagramPostMetadata = CommonPostMetadata & {
  __typename?: 'InstagramPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Instagram post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Geolocation of the post */
  geolocation?: Maybe<InstagramGeolocation>;
  /** Shop Grid link for the post */
  link?: Maybe<Scalars['String']['output']>;
  /** Indicates whether post should be shared to feed */
  shouldShareToFeed: Scalars['Boolean']['output'];
  /** Sticker fields for reminder-based publishing */
  stickerFields?: Maybe<InstagramStickerFields>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Instagram post metadata */
export type InstagramPostMetadataInput = {
  /** Instagram post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Geolocation of the post */
  geolocation?: InputMaybe<InstagramGeolocationInput>;
  /** Shop Grid link for the post */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether post should be shared to feed */
  shouldShareToFeed: Scalars['Boolean']['input'];
  /** Sticker fields for reminder-based publishing */
  stickerFields?: InputMaybe<InstagramStickerFieldsInput>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/**
 * Instagram fields for reminder-based publishing. Upon the reminder for publishing, the user
 * is prompted to copy and paste these fields into the Instagram app to complete the post.
 */
export type InstagramStickerFields = {
  __typename?: 'InstagramStickerFields';
  /** Placeholder text for the post's music */
  music?: Maybe<Scalars['String']['output']>;
  /** Additional field for any other post content */
  other?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the post's linked products */
  products?: Maybe<Scalars['String']['output']>;
  /** Text for the Story or Reel */
  text?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the post's topics (Reels only) */
  topics?: Maybe<Scalars['String']['output']>;
};

/**
 * Instagram fields for reminder-based publishing. Upon the reminder for publishing, the user
 * is prompted to copy and paste these fields into the Instagram app to complete the post.
 */
export type InstagramStickerFieldsInput = {
  /** Placeholder text for the post's music */
  music?: InputMaybe<Scalars['String']['input']>;
  /** Additional field for any other post content */
  other?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the post's linked products */
  products?: InputMaybe<Scalars['String']['input']>;
  /** Text for the Story or Reel */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the post's topics (Reels only) */
  topics?: InputMaybe<Scalars['String']['input']>;
};

export enum IntervalSize {
  OneHour = 'oneHour',
  ThirtyMinutes = 'thirtyMinutes',
  TwoHours = 'twoHours'
}

/** Error returned when the input is invalid */
export type InvalidInputError = MutationError & {
  __typename?: 'InvalidInputError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  chargeId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: InvoiceStatus;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<Maybe<InvoiceNode>>;
  pageInfo: PageInfo;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  amountTax?: Maybe<Scalars['Float']['output']>;
  amountWithoutTax?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type InvoiceNode = {
  __typename?: 'InvoiceNode';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export enum InvoiceStatus {
  Open = 'open',
  Paid = 'paid'
}

export type LabelCount = {
  __typename?: 'LabelCount';
  count?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** The last reply to the comment */
export type LastReply = {
  __typename?: 'LastReply';
  /** Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** Information about the author of the comment. */
  author: CommentAuthor;
  /** Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp when this comment was created on the third-party service. It could be undefined
   *   if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Deprecated in favor of Billing type. */
export type LegacyDiscount = {
  __typename?: 'LegacyDiscount';
  discount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Deprecated in favor of Billing type. */
export type LegacyInvoice = {
  __typename?: 'LegacyInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Int']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LifetimeConnectedChannelCount = {
  __typename?: 'LifetimeConnectedChannelCount';
  service?: Maybe<Service>;
  serviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Error returned when the limit is reached */
export type LimitReachedError = MutationError & {
  __typename?: 'LimitReachedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Link attached to the post */
export type LinkAssetInput = {
  /** Description of the link */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Thumbnail URL of the link */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the link */
  title?: InputMaybe<Scalars['String']['input']>;
  /** URL to the link */
  url: Scalars['String']['input'];
};

/** Link attachment */
export type LinkAttachment = ScrapedLink & {
  __typename?: 'LinkAttachment';
  /** Full URL that the link asset has been built from */
  expandedUrl?: Maybe<Scalars['String']['output']>;
  /** Description for the scraped link */
  text: Scalars['String']['output'];
  /** Selected thumbnail for this link preview */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Thumbnails of media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** Title for the link attachment */
  title: Scalars['String']['output'];
  /** URL that the link asset has been built from */
  url: Scalars['String']['output'];
};

/** Link attachment */
export type LinkAttachmentInput = {
  /** URL that the link asset has been built from */
  url: Scalars['String']['input'];
};

export type LinkInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input to configure link shortening domain */
export type LinkShortenerConfigInput = {
  /**
   * The domain of the link shortening service. Either buff.ly, dub.co,
   * or a user defined shortener based on an integration
   */
  domain: Scalars['String']['input'];
  /** The human readable name of the shortener */
  name: Scalars['String']['input'];
};

/** Link Shortening Configuration */
export type LinkShorteningConfig = {
  __typename?: 'LinkShorteningConfig';
  /**
   * Domain of the link shortener - eg buff.ly, dub.co,
   * or the user's custom domain.
   */
  domain: Scalars['String']['output'];
  /**
   * Human readable string to describe the link shortening
   * service.
   */
  name: Scalars['String']['output'];
};

/** Input to configure link shortening */
export type LinkShorteningSettingsInput = {
  /** Channel to update settings for */
  channelId: Scalars['ChannelId']['input'];
  /**
   * Configuration for the link shortener service. Leave blank
   * if shortening is not enabled
   */
  config?: InputMaybe<LinkShortenerConfigInput>;
  /** Setting to control if user links should be shortened or not */
  isEnabled: Scalars['Boolean']['input'];
  /** Organization to update settings for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type LinkedInAnnotation = {
  __typename?: 'LinkedInAnnotation';
  entity: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  length: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  localizedName: Scalars['String']['output'];
  start: Scalars['Int']['output'];
  vanityName: Scalars['String']['output'];
};

/** LinkedIn metadata */
export type LinkedInMetadata = {
  __typename?: 'LinkedInMetadata';
  /** Property parsed from scopes indicating whether the client should show the LinkedIn analytics refresh banner */
  shouldShowLinkedinAnalyticsRefreshBanner: Scalars['Boolean']['output'];
};

/** LinkedIn post metadata */
export type LinkedInPostMetadata = CommonPostMetadata & {
  __typename?: 'LinkedInPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** LinkedIn post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** LinkedIn post metadata */
export type LinkedInPostMetadataInput = {
  /** Annotations representing entities in the text */
  annotations?: InputMaybe<Array<AnnotationInputLinkedIn>>;
  /** LinkedIn post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
};

export type LinkedinData = {
  __typename?: 'LinkedinData';
  comment_text?: Maybe<Scalars['String']['output']>;
};

/** Union type representing either a successful listing of failed post errors or an error */
export type ListFailedPostErrorsPayload = ListFailedPostErrorsSuccess | UnauthorizedError | UnexpectedError;

/** Success response for listing all failed post errors. */
export type ListFailedPostErrorsSuccess = {
  __typename?: 'ListFailedPostErrorsSuccess';
  /** List of all failed post errors. */
  failedPostErrors: Array<Maybe<FailedPostError>>;
};

/** Localized text for multiple languages. */
export type LocalizedText = {
  __typename?: 'LocalizedText';
  /** Localized text in English (required). */
  en: Scalars['String']['output'];
  /** Localized text in Spanish (optional). Will default to English if not provided. */
  es?: Maybe<Scalars['String']['output']>;
};

/** Localized text input for multiple languages. */
export type LocalizedTextInput = {
  /** Localized text for English (required). */
  en: Scalars['String']['input'];
  /** Localized text for Spanish (optional). Will default to English if not provided. */
  es?: InputMaybe<Scalars['String']['input']>;
};

/** Location data about the channel */
export type LocationData = {
  __typename?: 'LocationData';
  /** Google Account Id of the business */
  googleAccountId?: Maybe<Scalars['String']['output']>;
  /** Location of the business associated with the channel */
  location?: Maybe<Scalars['String']['output']>;
  /** Link to the map */
  mapsLink?: Maybe<Scalars['String']['output']>;
};

export type LocationDataInput = {
  googleAccountId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapsLink?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPayload = {
  __typename?: 'LocationPayload';
  country?: Maybe<Scalars['String']['output']>;
};

/** completeLoginVerification response payload */
export type LoginVerificationResponsePayload = EmptySuccess | UnexpectedError;

export type MpBilling = Billing & {
  __typename?: 'MPBilling';
  /** Describes the billing address of the customer */
  address?: Maybe<Address>;
  /** Any credit (negative balance) or debit (positive balance) a customer might have */
  balance: Scalars['Float']['output'];
  /** This URL is used to redirect the user to the appropriate billing page, when the OB plan selector is triggered. */
  billingRedirectUrl: Scalars['String']['output'];
  canAccessAnalytics: Scalars['Boolean']['output'];
  canAccessEngagement: Scalars['Boolean']['output'];
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  /** Describes any discount coupon a customer might have */
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  /** Describes whether the customer is eligible for automatic tax collection in Stripe */
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Describes whether the customer's subscription is eligible for automatic tax collection in Stripe */
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  subscriptions: Array<MpSubscription>;
  /** Describes tax details for the Stripe customer */
  taxDetails?: Maybe<TaxDetails>;
  /** Describes customer's tax exemption status */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** Describes tax ids customer might have */
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type MpSubscription = GenericSubscription & {
  __typename?: 'MPSubscription';
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /** The UTC DateTime of the subscription period end */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: Scalars['String']['output'];
  product: Product;
  trial?: Maybe<Trial>;
};

export type MarkNoteAuthorAsDeletedForOrganizationError = {
  __typename?: 'MarkNoteAuthorAsDeletedForOrganizationError';
  cause: Scalars['String']['output'];
};

export type MarkNoteAuthorAsDeletedForOrganizationResponse = MarkNoteAuthorAsDeletedForOrganizationError | MarkNoteAuthorAsDeletedForOrganizationSuccessResponse;

export type MarkNoteAuthorAsDeletedForOrganizationSuccessResponse = {
  __typename?: 'MarkNoteAuthorAsDeletedForOrganizationSuccessResponse';
  success: Scalars['Boolean']['output'];
};

/** Mastodon metadata */
export type MastodonMetadata = {
  __typename?: 'MastodonMetadata';
  /** The instance of mastodon of the channel */
  serverUrl: Scalars['String']['output'];
};

/** Mastodon post metadata */
export type MastodonPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'MastodonPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Spoiler text hiding the root text of this post */
  spoilerText?: Maybe<Scalars['String']['output']>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Mastodon post metadata */
export type MastodonPostMetadataInput = {
  /** Spoiler text hiding the root text of this post */
  spoilerText?: InputMaybe<Scalars['String']['input']>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

export type MediaInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum MediaType {
  Document = 'document',
  Gif = 'gif',
  Image = 'image',
  Link = 'link',
  Unsupported = 'unsupported',
  Video = 'video'
}

/** Represents the members connection edge. Later, we can add the list of members with the page info to follow our connection edge pattern. */
export type MemberConnection = {
  __typename?: 'MemberConnection';
  /** The total count of team members counting the org owner and team members from the Publish DB. */
  totalCount: Scalars['Int']['output'];
};

export enum MigrationMarketingFeature {
  AdvancedInstagramFeatures = 'advancedInstagramFeatures',
  BestTimeToPost = 'bestTimeToPost',
  CampaignAnalytics = 'campaignAnalytics',
  ComprehensiveAnalytics = 'comprehensiveAnalytics',
  CustomisableReports = 'customisableReports',
  EngagementTools = 'engagementTools',
  HashtagManager = 'hashtagManager',
  OrganicAndBoostedPosts = 'organicAndBoostedPosts',
  PerChannelPricing = 'perChannelPricing',
  PublishingTools = 'publishingTools'
}

export type MigrationMarketingFeaturesCopy = {
  __typename?: 'MigrationMarketingFeaturesCopy';
  id: MigrationMarketingFeature;
  tagline: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MigrationPlan = {
  __typename?: 'MigrationPlan';
  interval: BillingInterval;
  name: Scalars['String']['output'];
  /** The UTC DateTime of the MP subscription period end. Suggested plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  supportedFeatures: Array<Maybe<MigrationMarketingFeature>>;
};

export type MigrationSummary = {
  __typename?: 'MigrationSummary';
  baseMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  basePlanPrice?: Maybe<Scalars['Float']['output']>;
  channelCount?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  migrationPreview?: Maybe<PlanMigrationPreview>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export enum MonthName {
  April = 'April',
  August = 'August',
  December = 'December',
  February = 'February',
  January = 'January',
  July = 'July',
  June = 'June',
  March = 'March',
  May = 'May',
  November = 'November',
  October = 'October',
  September = 'September'
}

/** Input for moving a feed collection */
export type MoveFeedCollectionInput = {
  /** Feed Collection that is being moved */
  id: Scalars['FeedCollectionId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Feed or FeedCollection the feed should come after. If null, it will be placed at the start */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for moving a feed */
export type MoveFeedInput = {
  /** FeedCollection the Feed should be stored in */
  collectionId?: InputMaybe<Scalars['FeedCollectionId']['input']>;
  /** Feed that is being moved */
  id: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Feed or FeedCollection the feed should come after. If null, it will be placed at the start */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for moving an idea group. */
export type MoveIdeaGroupInput = {
  id: Scalars['ID']['input'];
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** Union type representing possible payloads for moving an idea group. */
export type MoveIdeaGroupPayload = InvalidInputError | MoveIdeaGroupResponse | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response type for moving an idea group. */
export type MoveIdeaGroupResponse = {
  __typename?: 'MoveIdeaGroupResponse';
  ideaGroups: Array<IdeaGroup>;
};

/** moveIdea input type */
export type MoveIdeaInput = {
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Target group ID (null moves to unassigned) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the idea to move */
  ideaId: Scalars['ID']['input'];
  /** ID of the idea to place this idea after (null places at top) */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** moveIdea response (including errors) */
export type MoveIdeaPayload = MoveIdeaResponse | UnexpectedError;

/** moveIdea response type */
export type MoveIdeaResponse = {
  __typename?: 'MoveIdeaResponse';
  /** List of ideas that were affected by the move operation */
  updatedIdeas: Array<Idea>;
};

/** All possible response types that can be returned by movePostToDraftsV2 mutation. */
export type MovePostToDraftsResult = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** movePostToDraftsV2 mutation moves a post to drafts by id. */
export type MovePostToDraftsV2Input = {
  /** Post id to move to drafts. */
  id: Scalars['PostId']['input'];
};

/** List of post Mutation operations */
export type Mutation = {
  __typename?: 'Mutation';
  accountCompleteEmailVerification: AccountCompleteEmailVerification;
  accountInitiateEmailVerification: AccountInitiateEmailVerificationPayload;
  accountRemove: AccountRemovePayload;
  accountSetAvatar: Scalars['Boolean']['output'];
  accountSetCurrentOrganization: Scalars['Boolean']['output'];
  accountSetSettings: AccountSetSettingsPayload;
  accountSuspend: AccountSuspendResponse;
  accountUnsuspend: AccountUnsuspendResponse;
  /**
   * Changes account role for a given account. Can be either "customer" or "admin",
   * with "admin" only being set for Buffer employees.
   */
  accountUpdateRole: AccountUpdateRoleResponse;
  addBlock?: Maybe<BlockMutationResponse>;
  addBlocks?: Maybe<BlockMutationResponse>;
  addChildBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use the new addNoteToPost mutation */
  addEntityNote: AddEntityNotePayload;
  /** Add a note on a post */
  addNoteToPost: AddNoteToPostPayload;
  addOrUpdateDismissedObject: AddOrUpdateDismissedObjectPayload;
  addOrganizationToBetaProgram: MutationBasicPayload;
  /** Schedule the post to the next available slot. */
  addPostToQueue: AddPostToQueuePayload;
  /** Add Shop Grid Custom link */
  addShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Approve post request. */
  approvePost: ApprovePostPayload;
  /** @deprecated deprecated in favor of channelsConnectionRefresh */
  authorizeChannels: AuthorizeChannelsPayload;
  /**
   * Backfills channel analytics, posts and post analytics, were applicable.
   * It takes care of triggering both the new ingestion pipeline (buffer-mono) and
   * the legacy one (buffer-analytics).
   */
  backfillChannelPostsAndAnalytics: BackfillChannelPostsAndAnalyticsPayload;
  /** @deprecated Use `backfillChannelPostsAndAnalytics` instead. */
  backfillChannelUpdates: BackfillChannelUpdatesResponse;
  /**
   * Backfill natively posted updates for the grid preview.
   * Accessible only for internal clients, and rate-limited mutation.
   */
  backfillUpdatesForGrid: BackfillUpdatesForGridPayload;
  banStartPagesForOrg?: Maybe<StartPageMutationResponse>;
  /** @deprecated Use the createCheckoutSession mutation instead */
  billingCreateCheckoutSession: BillingCreateCheckoutSessionPayload;
  /** @deprecated Use the createCustomerPortalSession mutation instead */
  billingCreateCustomerPortalSession: BillingCreateCustomerPortalSessionPayload;
  /** @deprecated This endpoint has been deprecated */
  billingCreateSetupIntent: BillingCreatedSetupIntentPayload;
  billingIncreaseSubscriptionQuantityByChannelIds: BillingIncreaseSubscriptionQuantityByChannelIdsPayload;
  billingMigrateToBufferViaHub: BillingMigrateToOneBufferPayload;
  billingMigrateToOneBuffer: BillingMigrateToOneBufferPayload;
  billingStartTrial: BillingStartTrialPayload;
  /** @deprecated This endpoint has been deprecated */
  billingUpdateCustomerPaymentMethod: BillingUpdateCustomerPaymentMethodPayload;
  billingUpdateSubscriptionPlan: BillingUpdateSubscriptionPlanPayload;
  billingUpdateSubscriptionQuantity: BillingUpdateSubscriptionQuantityPayload;
  /** Cancel a trial for an organization. */
  cancelTrial: CancelTrialPayload;
  /** List the channels from a service */
  channelConnectionList: ChannelConnectionListPayload;
  /** Reconnect the channels of a service */
  channelConnectionRefresh: ChannelConnectionRefreshPayload;
  channelCreateOrUpdateNativeChannel: ChannelMutationResponse;
  channelStoreTemporaryCredentials: ChannelStoreTemporaryCredentialsResponse;
  channelUpdateLockedStatus: ChannelUpdateLockedStatusResponse;
  /** @deprecated deprecated in favor of authorizeChannels > channelsConnectionRefresh */
  channelsAuthorization: ChannelAuthorizationPayload;
  /** @deprecated deprecated in favor of channelsConnectWithResponse */
  channelsConnect?: Maybe<Scalars['Boolean']['output']>;
  channelsConnectWithResponse: ChannelsConnectPayload;
  /** @deprecated deprecated in favor of channelConnectionList */
  channelsForConnection: CredentialsForChannelsPayload;
  channelsLock?: Maybe<Scalars['Boolean']['output']>;
  channelsLockAllForOrganization?: Maybe<Array<Channel>>;
  /** Recalculate channel lock states for an organization */
  channelsLockForOrganization?: Maybe<Array<Channel>>;
  channelsRemove?: Maybe<Scalars['Boolean']['output']>;
  channelsSetRecommendations: ChannelsSetRecommendationsPayload;
  channelsUpdateCredentials: ChannelsUpdateCredentialsResponse;
  /** Verify an email update by verifying the JWT */
  completeEmailVerification: CompleteEmailVerificationPayload;
  /** Verify a suspicious login attempt by verifying the JWT */
  completeLoginVerification: LoginVerificationResponsePayload;
  /** Convert custom channel to API-enabled channel (e.g. IG Personal Profile to IG Business) */
  convertCustomChannel: ConvertCustomChannelPayload;
  /** Create a new channel group */
  createChannelGroup: CreateChannelGroupPayload;
  /**
   * Creates a new Stripe Checkout session for creating a subscription.
   * Returns either a success response with a checkout session URL or a billing error.
   */
  createCheckoutSession: CreateCheckoutSessionPayload;
  /** Connect a custom channel (e.g. FB Group or Bluesky) */
  createCustomChannels: CreateCustomChannelsPayload;
  /**
   * Creates a new Stripe Customer Portal session for managing billing settings.
   * Returns either a success response with a portal URL or a billing error.
   */
  createCustomerPortalSession: CreateCustomerPortalSessionPayload;
  /** Mutation to create a new failed post error. */
  createFailedPostError: CreateFailedPostErrorPayload;
  /** Create a new feed */
  createFeed: CreateOrUpdateFeedPayload;
  /** Add a create a feed collection */
  createFeedCollection: CreateOrUpdateFeedCollectionPayload;
  /** Create a new idea with the given content and metadata */
  createIdea: CreateIdeaPayload;
  /** Creates a new idea group with the provided input parameters. */
  createIdeaGroup: CreateIdeaGroupPayload;
  /** Create post for channel */
  createPost: PostActionPayload;
  /** Mutation for adding a saved reply */
  createSavedReply: CreateSavedReplyPayload;
  createStartPage?: Maybe<StartPageMutationResponse>;
  /** Create a new tag for the organization. */
  createTag: CreateTagPayload;
  /** @deprecated deprecated in favor of updateCustomChannel */
  customChannelUpdate: CustomChannelUpdatePayload;
  /** @deprecated deprecated in favor of createCustomChannels */
  customChannelsCreate: CustomChannelsCreatePayload;
  /** Delete an account (by a Buffer Admin) */
  deleteAccount: DeleteAccountPayload;
  /** Delete an internal comment from an account */
  deleteAdminComment: DeleteAdminCommentPayload;
  deleteBlock?: Maybe<BlocksMutationResponse>;
  /** Delete a channel group */
  deleteChannelGroup: DeleteChannelGroupPayload;
  /** @deprecated Use the new deleteNoteFromPost mutation */
  deleteEntityNote: DeleteEntityNotePayload;
  /** Mutation to delete a failed post error. */
  deleteFailedPostError: DeleteFailedPostErrorPayload;
  /** Delete a feed */
  deleteFeed: DeleteFeedPayload;
  /** Delete a feed collection */
  deleteFeedCollection: DeleteFeedCollectionPayload;
  /** Deletes an existing idea group based on the provided input parameters. */
  deleteIdeaGroup: DeleteIdeaGroupPayload;
  /** Delete a note from a post */
  deleteNoteFromPost: DeleteNoteFromPostPayload;
  /** @deprecated Use the new deletePostV2 mutation */
  deletePost: PostDeletionPayload;
  /** Delete a post by id. */
  deletePostV2: DeletePostResult;
  /** Deletes an existing saved reply. */
  deleteSavedReply: DeleteSavedReplyPayload;
  /** Delete Shop Grid Custom link */
  deleteShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Delete a tag for the organization. */
  deleteTag: DeleteTagPayload;
  /** Mutation for dismissing all comments for a given channel */
  dismissAllCommentsByChannelId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given organization */
  dismissAllCommentsByOrganizationId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given post */
  dismissAllCommentsByPostId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given channel */
  dismissAllCommentsForChannels: DismissAllCommentsForChannelsPayload;
  dismissBanner: DismissBannerPayload;
  /** Dismisses a comment, marking it as read or no longer relevant. */
  dismissComment: DismissCommentPayload;
  /** Update post dueAt date. We named it drop because it is called when a user drop a post on an empty slot during drag-and-drop. */
  dropPost: DropPostPayload;
  editBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use the new updateNoteOnPost mutation */
  editEntityNote: EditEntityNotePayload;
  /** Edit post for channel */
  editPost: PostActionPayload;
  emailNotificationPreferences: EmailNotificationPreferencePayload;
  engageDismiss?: Maybe<EngagementMutationResponse>;
  engageDismissAll?: Maybe<CommonMutationResponse>;
  engageHideMarkAsReadModal?: Maybe<CommonMutationResponse>;
  engageReply?: Maybe<EngagementMutationResponse>;
  engageUnDismiss?: Maybe<EngagementMutationResponse>;
  /**
   * Exchange a Publish access token for a JWT. Used by legacy clients wishing to communicate with the API gateway.
   * [See this document for more information](https://www.notion.so/buffer/Exchanging-an-Access-Token-for-a-JWT-28d4f5dd3ec9401194f1490bc336ce17).
   */
  exchangeAccessTokenForJwt: Scalars['String']['output'];
  exchangeGoogleTokenForBufferAdminJwt: Scalars['String']['output'];
  expandPost?: Maybe<TextGenerationResponse>;
  expandText?: Maybe<TextGenerationResponse>;
  generateHellonextSsoTokenForAccount: HellonextSsoMutationResponse;
  generateIdeas?: Maybe<TextGenerationResponse>;
  generatePost?: Maybe<TextGenerationResponse>;
  /**
   * Generates AI text completions based on pre-defined templates.
   * Returns either successful completion suggestions or an error.
   */
  generateTemplatedCompletion: GenerateTemplatedCompletionPayload;
  generateText?: Maybe<TextGenerationResponse>;
  getAuthorizationJwt: Scalars['String']['output'];
  hideOrShowBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use createIdea */
  ideaCreate: IdeaMutationPayload;
  /** @deprecated Use updateIdea */
  ideaUpdate: IdeaMutationPayload;
  ideasRemove: IdeasDeletionPayload;
  /** Initiate request flow for updating an account's email address */
  initiateEmailUpdateRequest: InitiateEmailUpdateRequestPayload;
  /** Update Account email */
  initiateUpdateEmail: InitiateUpdateEmailPayload;
  markNoteAuthorAsDeletedForOrganization: MarkNoteAuthorAsDeletedForOrganizationResponse;
  /** Move a feed to a new position and/or collection */
  moveFeed: FeedMoveUpdatesPayload;
  /** Move a feed collection to a new position */
  moveFeedCollection: FeedMoveUpdatesPayload;
  /** Move an idea to a new position within or between groups */
  moveIdea: MoveIdeaPayload;
  /** Moves an existing idea group within the organization based on the provided input parameters. */
  moveIdeaGroup: MoveIdeaGroupPayload;
  /** @deprecated Use the new movePostToDraftsV2 mutation */
  movePostToDrafts: PostUpdatedPayload;
  /** Move a post to drafts by id. */
  movePostToDraftsV2: MovePostToDraftsResult;
  /**
   * Optimizes a channel's posting schedule using Buffer's best time to post recommendations
   * This mutation applies Buffer's intelligent scheduling recommendations, with options
   * to either add to or override the existing schedule.
   */
  optimizePostingSchedule: OptimizePostingSchedulePayload;
  /** Reorders a channel for an account by placing it after another channel */
  orderChannelForAccount: OrderChannelForAccountPayload;
  organizationSetName?: Maybe<Scalars['Boolean']['output']>;
  /** Publish a post now without adding it to the queue. */
  publishPostNow: PublishPostNowPayload;
  publishStartPage?: Maybe<StartPageMutationResponse>;
  reOrderBlock?: Maybe<BlocksMutationResponse>;
  /** Refresh a feed */
  refreshFeed: RefreshFeedPayload;
  /** Refresh a feed collection */
  refreshFeedCollection: RefreshFeedCollectionPayload;
  refundCharge: Refund;
  /** Reject approval request. */
  rejectPost: RejectPostPayload;
  /** Delete an account by a user from the account */
  removeAccount: RemoveAccountPayload;
  /** Removes feature flip from account in DB */
  removeLegacyGlobalFeatureFlip: RemoveLegacyGlobalFeatureFlipPayload;
  removeOrganizationFromBetaProgram: MutationBasicPayload;
  /** Remove the scheduled time from a post. */
  removePostScheduledTime: RemovePostScheduledTimePayload;
  removeSubscriptionSchedule: RemoveSubscriptionSchedulePayload;
  removeTagFromIdea: IdeaMutationPayload;
  removeTagFromIdeas: TagActionInIdeasPayload;
  /** Reorder the post, moving it from it's current position to another. */
  reorderPosts: ReorderPostsPayload;
  rephrasePost?: Maybe<TextGenerationResponse>;
  rephraseText?: Maybe<TextGenerationResponse>;
  /** Replies to a comment with a text */
  replyToComment: ReplyToCommentPayload;
  /** Request post approval. */
  requestPostApproval: RequestPostApprovalPayload;
  /** Revert approval request. */
  revertPostApprovalRequest: RevertPostApprovalRequestPayload;
  /** Revoke access to a connectedApp */
  revokeAccessConnectedApp: RevokeAccessConnectedAppPayload;
  saveStartPageName?: Maybe<StartPageMutationResponse>;
  saveTheme?: Maybe<StartPageMutationResponse>;
  /** Schedule a post to a specific time. */
  schedulePost: SchedulePostPayload;
  /** Send test notification */
  sendTestNotification: SendTestNotificationPayload;
  /** Set password for account by id */
  setPasswordForAccount: SetPasswordForAccountPayload;
  /** Set posting schedule for Channel by id */
  setPostingScheduleForChannel: SetPostingScheduleForChannelPayload;
  startImpersonation: ImpersonationResponse;
  stopImpersonation: ImpersonationResponse;
  summarizePost?: Maybe<TextGenerationResponse>;
  summarizeText?: Maybe<TextGenerationResponse>;
  /** Swap posts in queue - It is called when a user drags a post and drops it on a slot containing another post. */
  swapPostsInQueue: SwapPostsInQueuePayload;
  /** Swap Shop Grid Custom links */
  swapShopGridCustomLinks: ShopGridCustomLinksMutationPayload;
  trackExternalServiceUsageForChannel: TrackExternalServiceUsageResponse;
  trackExternalServiceUsageForOrganization: TrackExternalServiceUsageResponse;
  /** Track Onboarding Survey being completed and the last answers for questions in db */
  trackOnboardingSurveyCompleted: TrackActionOnboardingSurveyPayload;
  /** Track Onboarding Survey being skipped in db */
  trackOnboardingSurveySkipped: TrackActionOnboardingSurveyPayload;
  /** Track Onboarding Survey being viewed in db */
  trackOnboardingSurveyViewed: TrackActionOnboardingSurveyPayload;
  /** Transfer the ownership of an organization to a new account. */
  transferOrganizationOwnership: TransferOrganizationOwnershipPayload;
  /** Confirm Two Factor Authentication */
  twoFactorConfirm: TwoFactorConfirmPayload;
  /** Disable Two Factor Authentication */
  twoFactorDisable: TwoFactorDisablePayload;
  /**
   * Disable Two Factor Authentication for an account
   * This is used for Buffer Admin to disable Two Factor Authentication for an account
   */
  twoFactorDisableByAccountId: TwoFactorDisablePayload;
  /** Requests a One-Time Password for Two Factor Authentication */
  twoFactorRequestOneTimePassword: TwoFactorRequestOneTimePasswordPayload;
  /** Set up Two Factor Authentication */
  twoFactorSetup: TwoFactorSetupPayload;
  unPublishStartPage?: Maybe<StartPageMutationResponse>;
  /** Undismisses a comment, marking it as unreplied, meaning it needs attention. */
  undismissComment: UndismissCommentPayload;
  /** update the avatar url for an account */
  updateAccountAvatar: UpdateAccountAvatarPayload;
  /** update the name of an account with the name provided */
  updateAccountName: UpdateAccountNamePayload;
  /** Update account preferences */
  updateAccountPreferences: UpdateAccountPreferencesPayload;
  /** Update account timezone */
  updateAccountTimezone: UpdateAccountTimezonePayload;
  /** Create or edit an internal comment that will be displayed in User Hub */
  updateAdminComment: UpdateAdminCommentPayload;
  /**
   * Temporary mutation to update the last updated at timestamps for analytics
   * This will be called by the Analyze workers. This will be removed once
   * the Analyze workers are migrated to monorepo or deprecated.
   */
  updateAnalyticsLastUpdatedAtByIngestionType: ChannelAnalyticsLastUpdateAtPayload;
  /** Update a channel group */
  updateChannelGroup: UpdateChannelGroupPayload;
  /** Update posting goal for Channel by id */
  updateChannelPostingGoal: UpdateChannelPostingGoalPayload;
  /** Update custom channel data */
  updateCustomChannel: UpdateCustomChannelPayload;
  /** Update custom links colors for a channel */
  updateCustomLinksColors: UpdateCustomLinksColorsPayload;
  /** Mutation to update an existing failed post error. */
  updateFailedPostError: UpdateFailedPostErrorPayload;
  updateFeatureTokenUsageForOrganization: OrganizationFeatureUsageUpdateResponse;
  /** Update a feed collection */
  updateFeedCollection: CreateOrUpdateFeedCollectionPayload;
  /** Update an existing idea with new content and metadata */
  updateIdea: UpdateIdeaPayload;
  /** Updates an existing idea group with the provided input parameters. */
  updateIdeaGroup: UpdateIdeaGroupPayload;
  /** Update lastActivityAt for a channel by id */
  updateLastActivityAtForChannel: UpdateLastActivityAtForChannelPayload;
  /** Update settings for a channel */
  updateLinkShorteningSettings: ChannelLinkShorteningPayload;
  /** Updates a note on a post and returns the result */
  updateNoteOnPost: UpdateNoteOnPostPayload;
  /** Update Account password */
  updatePassword: UpdatePasswordPayload;
  /** @todo: change response to use the generic PostUpdatedPayload */
  updatePostDueAt: UpdatePostDueAtMutationResponse;
  /** Assign tags to a post. Can also be used to remove all tags by passing an empty array. */
  updatePostTags: UpdatePostTagsPayload;
  /** Modifies an existing saved reply. */
  updateSavedReply: UpdateSavedReplyPayload;
  /** Update Shop Grid Custom link */
  updateShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Update Shop Grid Post link */
  updateShopGridPostLink: UpdateShopGridPostLinkPayload;
  /** Update account start of week preference */
  updateStartOfWeekPreference: UpdateStartOfWeekPreferencePayload;
  /** Update a tag for the organization. */
  updateTag: UpdateTagPayload;
  updateTagInIdeas: TagActionInIdeasPayload;
  /** Update account time format preference */
  updateTimeFormatPreference: UpdateTimeFormatPreferencePayload;
  /** Update timezone for Channel by id */
  updateTimezoneForChannel: UpdateTimezoneForChannelPayload;
  /**
   * Create a feed if it does not yet exist
   * @deprecated Use createFeed mutation instead
   */
  upsertFeed: CreateOrUpdateFeedPayload;
  /** Verify account by checking the password in DB */
  verifyPassword: VerifyPasswordPayload;
  /** Verify TFA code for account */
  verifyTfaCode: VerifyTfaCodePayload;
  voteForFeatureOnFeatureOS: VoteForFeatureMutationResponse;
};


/** List of post Mutation operations */
export type MutationAccountCompleteEmailVerificationArgs = {
  emailVerificationJWT: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAccountInitiateEmailVerificationArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountSetAvatarArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountSetCurrentOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountSetSettingsArgs = {
  settings: SettingsInput;
};


/** List of post Mutation operations */
export type MutationAccountSuspendArgs = {
  accountId: Scalars['String']['input'];
  shouldForceOperation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountUnsuspendArgs = {
  accountId: Scalars['String']['input'];
  shouldForceOperation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountUpdateRoleArgs = {
  accountRole: AccountUpdateRoleInput;
};


/** List of post Mutation operations */
export type MutationAddBlockArgs = {
  config?: InputMaybe<BlockConfigInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddBlocksArgs = {
  config?: InputMaybe<Array<InputMaybe<BlockConfigInput>>>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddChildBlockArgs = {
  accountId: Scalars['String']['input'];
  config?: InputMaybe<ChildBlockConfigInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddEntityNoteArgs = {
  input: AddEntityNoteInput;
};


/** List of post Mutation operations */
export type MutationAddNoteToPostArgs = {
  input: AddNoteToPostInput;
};


/** List of post Mutation operations */
export type MutationAddOrUpdateDismissedObjectArgs = {
  dismissedObject: DismissedObjectInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddOrganizationToBetaProgramArgs = {
  bufferAdminAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddPostToQueueArgs = {
  input: AddPostToQueueInput;
};


/** List of post Mutation operations */
export type MutationAddShopGridCustomLinkArgs = {
  input: AddShopGridCustomLinkInput;
};


/** List of post Mutation operations */
export type MutationApprovePostArgs = {
  input: ApprovePostInput;
};


/** List of post Mutation operations */
export type MutationAuthorizeChannelsArgs = {
  channelAuthorization: ChannelAuthorizationInput;
};


/** List of post Mutation operations */
export type MutationBackfillChannelPostsAndAnalyticsArgs = {
  input: ChannelBackfillInput;
};


/** List of post Mutation operations */
export type MutationBackfillChannelUpdatesArgs = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBackfillUpdatesForGridArgs = {
  input: BackfillUpdatesForGridInput;
};


/** List of post Mutation operations */
export type MutationBanStartPagesForOrgArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBillingCreateCheckoutSessionArgs = {
  attribution?: InputMaybe<AttributionInput>;
  currentURL?: InputMaybe<Scalars['String']['input']>;
  interval: BillingInterval;
  organizationId: Scalars['String']['input'];
  plan: ObPlanId;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shouldCollectAutomaticTax?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingCreateCustomerPortalSessionArgs = {
  organizationId: Scalars['String']['input'];
  returnURL?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingCreateSetupIntentArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingIncreaseSubscriptionQuantityByChannelIdsArgs = {
  attribution?: InputMaybe<AttributionInput>;
  channelIds: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBillingMigrateToBufferViaHubArgs = {
  interval: BillingInterval;
  organizationId: Scalars['String']['input'];
  plan: ObPlanId;
  quantity: Scalars['Int']['input'];
};


/** List of post Mutation operations */
export type MutationBillingMigrateToOneBufferArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBillingStartTrialArgs = {
  attribution?: InputMaybe<AttributionInput>;
  interval?: InputMaybe<BillingInterval>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
};


/** List of post Mutation operations */
export type MutationBillingUpdateCustomerPaymentMethodArgs = {
  attribution?: InputMaybe<AttributionInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingUpdateSubscriptionPlanArgs = {
  attribution?: InputMaybe<AttributionInput>;
  interval?: InputMaybe<BillingInterval>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingUpdateSubscriptionQuantityArgs = {
  attribution?: InputMaybe<AttributionInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Mutation operations */
export type MutationCancelTrialArgs = {
  input: CancelTrialInput;
};


/** List of post Mutation operations */
export type MutationChannelConnectionListArgs = {
  input: ChannelConnectionListInput;
};


/** List of post Mutation operations */
export type MutationChannelConnectionRefreshArgs = {
  input: ChannelConnectionRefreshInput;
};


/** List of post Mutation operations */
export type MutationChannelCreateOrUpdateNativeChannelArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  channel: NativeChannelInput;
};


/** List of post Mutation operations */
export type MutationChannelStoreTemporaryCredentialsArgs = {
  channelConnections?: InputMaybe<Array<ChannelConnectionInput>>;
};


/** List of post Mutation operations */
export type MutationChannelUpdateLockedStatusArgs = {
  input: ChannelUpdateLockedStatusInput;
};


/** List of post Mutation operations */
export type MutationChannelsAuthorizationArgs = {
  channelAuthorization: ChannelAuthorizationInput;
};


/** List of post Mutation operations */
export type MutationChannelsConnectArgs = {
  channels?: InputMaybe<Array<ChannelWithCredentialsInput>>;
};


/** List of post Mutation operations */
export type MutationChannelsConnectWithResponseArgs = {
  channels?: InputMaybe<Array<ChannelWithCredentialsInput>>;
};


/** List of post Mutation operations */
export type MutationChannelsForConnectionArgs = {
  credentialsForChannels: CredentialsForChannelsInput;
};


/** List of post Mutation operations */
export type MutationChannelsLockArgs = {
  channelIdsToLock?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIdsToUnlock?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationChannelsLockAllForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationChannelsLockForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationChannelsRemoveArgs = {
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** List of post Mutation operations */
export type MutationChannelsSetRecommendationsArgs = {
  channels: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationChannelsUpdateCredentialsArgs = {
  channelsUpdatedCredentials: ChannelUpdateCredentialsInput;
};


/** List of post Mutation operations */
export type MutationCompleteEmailVerificationArgs = {
  input: CompleteEmailVerificationInput;
};


/** List of post Mutation operations */
export type MutationCompleteLoginVerificationArgs = {
  input: CompleteLoginVerificationInput;
};


/** List of post Mutation operations */
export type MutationConvertCustomChannelArgs = {
  input: ConvertCustomChannelInput;
};


/** List of post Mutation operations */
export type MutationCreateChannelGroupArgs = {
  input: CreateChannelGroupInput;
};


/** List of post Mutation operations */
export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


/** List of post Mutation operations */
export type MutationCreateCustomChannelsArgs = {
  input: CreateCustomChannelsInput;
};


/** List of post Mutation operations */
export type MutationCreateCustomerPortalSessionArgs = {
  input: CreateCustomerPortalSessionInput;
};


/** List of post Mutation operations */
export type MutationCreateFailedPostErrorArgs = {
  input: CreateFailedPostErrorInput;
};


/** List of post Mutation operations */
export type MutationCreateFeedArgs = {
  input: CreateFeedInput;
};


/** List of post Mutation operations */
export type MutationCreateFeedCollectionArgs = {
  input: CreateFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationCreateIdeaArgs = {
  input: CreateIdeaInput;
};


/** List of post Mutation operations */
export type MutationCreateIdeaGroupArgs = {
  input: CreateIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


/** List of post Mutation operations */
export type MutationCreateSavedReplyArgs = {
  input: CreateSavedReplyInput;
};


/** List of post Mutation operations */
export type MutationCreateStartPageArgs = {
  config?: InputMaybe<StartPageConfigInput>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/** List of post Mutation operations */
export type MutationCustomChannelUpdateArgs = {
  channel: CustomChannelUpdateInput;
};


/** List of post Mutation operations */
export type MutationCustomChannelsCreateArgs = {
  channels?: InputMaybe<Array<CustomChannelCreateInput>>;
};


/** List of post Mutation operations */
export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


/** List of post Mutation operations */
export type MutationDeleteAdminCommentArgs = {
  input: DeleteAdminCommentInput;
};


/** List of post Mutation operations */
export type MutationDeleteBlockArgs = {
  blockId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationDeleteChannelGroupArgs = {
  input: DeleteChannelGroupInput;
};


/** List of post Mutation operations */
export type MutationDeleteEntityNoteArgs = {
  input: DeleteEntityNoteInput;
};


/** List of post Mutation operations */
export type MutationDeleteFailedPostErrorArgs = {
  input: DeleteFailedPostErrorInput;
};


/** List of post Mutation operations */
export type MutationDeleteFeedArgs = {
  input: DeleteFeedInput;
};


/** List of post Mutation operations */
export type MutationDeleteFeedCollectionArgs = {
  input: DeleteFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationDeleteIdeaGroupArgs = {
  input: DeleteIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationDeleteNoteFromPostArgs = {
  input: DeleteNoteFromPostInput;
};


/** List of post Mutation operations */
export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


/** List of post Mutation operations */
export type MutationDeletePostV2Args = {
  input: DeletePostInputV2;
};


/** List of post Mutation operations */
export type MutationDeleteSavedReplyArgs = {
  input: DeleteSavedReplyInput;
};


/** List of post Mutation operations */
export type MutationDeleteShopGridCustomLinkArgs = {
  input: DeleteShopGridCustomLinkInput;
};


/** List of post Mutation operations */
export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsByChannelIdArgs = {
  input: DismissAllCommentsByChannelIdInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsByOrganizationIdArgs = {
  input: DismissAllCommentsByOrganizationIdInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsByPostIdArgs = {
  input: DismissAllCommentsByPostIdInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsForChannelsArgs = {
  input: DismissAllCommentsForChannelsInput;
};


/** List of post Mutation operations */
export type MutationDismissBannerArgs = {
  banner: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationDismissCommentArgs = {
  input: DismissCommentInput;
};


/** List of post Mutation operations */
export type MutationDropPostArgs = {
  input: DropPostInput;
};


/** List of post Mutation operations */
export type MutationEditBlockArgs = {
  blockId: Scalars['String']['input'];
  data?: InputMaybe<BlockDataInput>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEditEntityNoteArgs = {
  input: EditEntityNoteInput;
};


/** List of post Mutation operations */
export type MutationEditPostArgs = {
  input: EditPostInput;
};


/** List of post Mutation operations */
export type MutationEmailNotificationPreferencesArgs = {
  input: Array<EmailNotificationPreferenceInput>;
};


/** List of post Mutation operations */
export type MutationEngageDismissArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEngageDismissAllArgs = {
  targetId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEngageReplyArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEngageUnDismissArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationExchangeGoogleTokenForBufferAdminJwtArgs = {
  googleToken?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationExpandPostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationExpandTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGenerateHellonextSsoTokenForAccountArgs = {
  accountId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGenerateIdeasArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGeneratePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGenerateTemplatedCompletionArgs = {
  input: GenerateTemplatedCompletionInput;
};


/** List of post Mutation operations */
export type MutationGenerateTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGetAuthorizationJwtArgs = {
  product?: InputMaybe<Product>;
};


/** List of post Mutation operations */
export type MutationHideOrShowBlockArgs = {
  blockId: Scalars['String']['input'];
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationIdeaCreateArgs = {
  input: IdeaCreationInput;
};


/** List of post Mutation operations */
export type MutationIdeaUpdateArgs = {
  input: IdeaUpdateInput;
};


/** List of post Mutation operations */
export type MutationIdeasRemoveArgs = {
  input: IdeasDeletionInput;
};


/** List of post Mutation operations */
export type MutationInitiateEmailUpdateRequestArgs = {
  input: InitiateEmailUpdateRequestInput;
};


/** List of post Mutation operations */
export type MutationInitiateUpdateEmailArgs = {
  input: InitiateUpdateEmailInput;
};


/** List of post Mutation operations */
export type MutationMarkNoteAuthorAsDeletedForOrganizationArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationMoveFeedArgs = {
  input: MoveFeedInput;
};


/** List of post Mutation operations */
export type MutationMoveFeedCollectionArgs = {
  input: MoveFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationMoveIdeaArgs = {
  input: MoveIdeaInput;
};


/** List of post Mutation operations */
export type MutationMoveIdeaGroupArgs = {
  input: MoveIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationMovePostToDraftsArgs = {
  input: PostIdInput;
};


/** List of post Mutation operations */
export type MutationMovePostToDraftsV2Args = {
  input: MovePostToDraftsV2Input;
};


/** List of post Mutation operations */
export type MutationOptimizePostingScheduleArgs = {
  input: OptimizePostingScheduleInput;
};


/** List of post Mutation operations */
export type MutationOrderChannelForAccountArgs = {
  input: OrderChannelForAccountInput;
};


/** List of post Mutation operations */
export type MutationOrganizationSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationPublishPostNowArgs = {
  input: PublishPostNowInput;
};


/** List of post Mutation operations */
export type MutationPublishStartPageArgs = {
  data?: InputMaybe<PublishStartPageInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationReOrderBlockArgs = {
  blockId: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationRefreshFeedArgs = {
  input: RefreshFeedInput;
};


/** List of post Mutation operations */
export type MutationRefreshFeedCollectionArgs = {
  input: RefreshFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationRefundChargeArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationRejectPostArgs = {
  input: RejectPostInput;
};


/** List of post Mutation operations */
export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};


/** List of post Mutation operations */
export type MutationRemoveLegacyGlobalFeatureFlipArgs = {
  input: RemoveLegacyGlobalFeatureFlipInput;
};


/** List of post Mutation operations */
export type MutationRemoveOrganizationFromBetaProgramArgs = {
  bufferAdminAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationRemovePostScheduledTimeArgs = {
  input: RemovePostScheduledTimeInput;
};


/** List of post Mutation operations */
export type MutationRemoveSubscriptionScheduleArgs = {
  organizationId: Scalars['OrganizationId']['input'];
};


/** List of post Mutation operations */
export type MutationRemoveTagFromIdeaArgs = {
  input: TagRemovalFromIdeaInput;
};


/** List of post Mutation operations */
export type MutationRemoveTagFromIdeasArgs = {
  input: TagRemovalFromIdeasInput;
};


/** List of post Mutation operations */
export type MutationReorderPostsArgs = {
  input: ReorderPostsInput;
};


/** List of post Mutation operations */
export type MutationRephrasePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationRephraseTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationReplyToCommentArgs = {
  input: ReplyToCommentInput;
};


/** List of post Mutation operations */
export type MutationRequestPostApprovalArgs = {
  input: RequestPostApprovalInput;
};


/** List of post Mutation operations */
export type MutationRevertPostApprovalRequestArgs = {
  input: RevertPostApprovalRequestInput;
};


/** List of post Mutation operations */
export type MutationRevokeAccessConnectedAppArgs = {
  input: RevokeAccessConnectedAppInput;
};


/** List of post Mutation operations */
export type MutationSaveStartPageNameArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationSaveThemeArgs = {
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  theme?: InputMaybe<StartPageThemeInput>;
};


/** List of post Mutation operations */
export type MutationSchedulePostArgs = {
  input: SchedulePostInput;
};


/** List of post Mutation operations */
export type MutationSetPasswordForAccountArgs = {
  input: SetPasswordForAccountInput;
};


/** List of post Mutation operations */
export type MutationSetPostingScheduleForChannelArgs = {
  input: SetPostingScheduleForChannelInput;
};


/** List of post Mutation operations */
export type MutationStartImpersonationArgs = {
  input: StartImpersonationInput;
};


/** List of post Mutation operations */
export type MutationStopImpersonationArgs = {
  input: StopImpersonationInput;
};


/** List of post Mutation operations */
export type MutationSummarizePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationSummarizeTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationSwapPostsInQueueArgs = {
  input: SwapPostsInQueueInput;
};


/** List of post Mutation operations */
export type MutationSwapShopGridCustomLinksArgs = {
  input: SwapShopGridCustomLinksInput;
};


/** List of post Mutation operations */
export type MutationTrackExternalServiceUsageForChannelArgs = {
  action: Scalars['String']['input'];
  channelServiceId: Scalars['String']['input'];
  domain: ExternalServiceDomain;
  endpoint: Scalars['String']['input'];
  service: ChannelThirdPartyService;
  source: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationTrackExternalServiceUsageForOrganizationArgs = {
  action: Scalars['String']['input'];
  domain: ExternalServiceDomain;
  endpoint: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  service: ChannelThirdPartyService;
  source: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationTrackOnboardingSurveyCompletedArgs = {
  input: OnboardingSurveyCompletedInput;
};


/** List of post Mutation operations */
export type MutationTrackOnboardingSurveySkippedArgs = {
  input: OnboardingSurveyActionInput;
};


/** List of post Mutation operations */
export type MutationTrackOnboardingSurveyViewedArgs = {
  input: OnboardingSurveyActionInput;
};


/** List of post Mutation operations */
export type MutationTransferOrganizationOwnershipArgs = {
  input: TransferOrganizationOwnershipInput;
};


/** List of post Mutation operations */
export type MutationTwoFactorConfirmArgs = {
  input: TwoFactorConfirmInput;
};


/** List of post Mutation operations */
export type MutationTwoFactorDisableByAccountIdArgs = {
  input: TwoFactorDisableByAccountIdInput;
};


/** List of post Mutation operations */
export type MutationTwoFactorSetupArgs = {
  input: TwoFactorSetupInput;
};


/** List of post Mutation operations */
export type MutationUnPublishStartPageArgs = {
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationUndismissCommentArgs = {
  input: UndismissCommentInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountAvatarArgs = {
  input: UpdateAccountAvatarInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountNameArgs = {
  input: UpdateAccountNameInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountPreferencesArgs = {
  input: UpdateAccountPreferencesInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountTimezoneArgs = {
  input: UpdateAccountTimezoneInput;
};


/** List of post Mutation operations */
export type MutationUpdateAdminCommentArgs = {
  input: UpdateAdminCommentInput;
};


/** List of post Mutation operations */
export type MutationUpdateAnalyticsLastUpdatedAtByIngestionTypeArgs = {
  input: AnalyticsLastUpdatedAtInput;
};


/** List of post Mutation operations */
export type MutationUpdateChannelGroupArgs = {
  input: UpdateChannelGroupInput;
};


/** List of post Mutation operations */
export type MutationUpdateChannelPostingGoalArgs = {
  input: UpdateChannelPostingGoalInput;
};


/** List of post Mutation operations */
export type MutationUpdateCustomChannelArgs = {
  input: UpdateCustomChannelInput;
};


/** List of post Mutation operations */
export type MutationUpdateCustomLinksColorsArgs = {
  input: UpdateCustomLinksColorsInput;
};


/** List of post Mutation operations */
export type MutationUpdateFailedPostErrorArgs = {
  input: UpdateFailedPostErrorInput;
};


/** List of post Mutation operations */
export type MutationUpdateFeatureTokenUsageForOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  tokenUsageInput?: InputMaybe<TokenUsageInput>;
};


/** List of post Mutation operations */
export type MutationUpdateFeedCollectionArgs = {
  input: UpdateFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationUpdateIdeaArgs = {
  input: UpdateIdeaInput;
};


/** List of post Mutation operations */
export type MutationUpdateIdeaGroupArgs = {
  input: UpdateIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationUpdateLastActivityAtForChannelArgs = {
  input: UpdateLastActivityAtForChannelInput;
};


/** List of post Mutation operations */
export type MutationUpdateLinkShorteningSettingsArgs = {
  input: LinkShorteningSettingsInput;
};


/** List of post Mutation operations */
export type MutationUpdateNoteOnPostArgs = {
  input: UpdateNoteOnPostInput;
};


/** List of post Mutation operations */
export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


/** List of post Mutation operations */
export type MutationUpdatePostDueAtArgs = {
  input: UpdatePostDueAtInput;
};


/** List of post Mutation operations */
export type MutationUpdatePostTagsArgs = {
  input: UpdatePostTagsInput;
};


/** List of post Mutation operations */
export type MutationUpdateSavedReplyArgs = {
  input: UpdateSavedReplyInput;
};


/** List of post Mutation operations */
export type MutationUpdateShopGridCustomLinkArgs = {
  input: UpdateShopGridCustomLinkInput;
};


/** List of post Mutation operations */
export type MutationUpdateShopGridPostLinkArgs = {
  input: UpdateShopGridPostLinkInput;
};


/** List of post Mutation operations */
export type MutationUpdateStartOfWeekPreferenceArgs = {
  input: UpdateStartOfWeekPreferenceInput;
};


/** List of post Mutation operations */
export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** List of post Mutation operations */
export type MutationUpdateTagInIdeasArgs = {
  input: UpdateTagInIdeasInput;
};


/** List of post Mutation operations */
export type MutationUpdateTimeFormatPreferenceArgs = {
  input: UpdateTimeFormatPreferenceInput;
};


/** List of post Mutation operations */
export type MutationUpdateTimezoneForChannelArgs = {
  input: UpdateTimezoneForChannelInput;
};


/** List of post Mutation operations */
export type MutationUpsertFeedArgs = {
  input: CreateFeedInput;
};


/** List of post Mutation operations */
export type MutationVerifyPasswordArgs = {
  input: VerifyPasswordInput;
};


/** List of post Mutation operations */
export type MutationVerifyTfaCodeArgs = {
  input: VerifyTfaCodeInput;
};


/** List of post Mutation operations */
export type MutationVoteForFeatureOnFeatureOsArgs = {
  accountId: Scalars['String']['input'];
  featureId: Scalars['Int']['input'];
};

export type MutationBasicError = {
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type MutationBasicPayload = BasicError | MutationBasicResponse;

export type MutationBasicResponse = {
  __typename?: 'MutationBasicResponse';
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

/** Base Mutation Error type */
export type MutationError = {
  /** Error message */
  message: Scalars['String']['output'];
};

export type MutationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Base Mutation Success type
 * Used when we have a success response with no data, we return this type with empty string
 */
export type MutationSuccess = {
  /**
   * The value is alwaus an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type NativeChannelInput = {
  avatar: Scalars['String']['input'];
  /** channelId is only necessary for update operation: omitting the channeId will result in channel creation */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  service: ChannelNativeService;
  type: ChannelType;
};

/** Connection metadata for RSS feeds */
export type NewsSearchConnectionMetadata = {
  __typename?: 'NewsSearchConnectionMetadata';
  /** Search query */
  query?: Maybe<Scalars['String']['output']>;
};

/** Create a live news search feed by query string */
export type NewsSearchFeedCreation = {
  /** The query string to use for news search */
  query: Scalars['String']['input'];
};

/** Error returned when the resource is not found */
export type NotFoundError = MutationError & {
  __typename?: 'NotFoundError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Note entity */
export type Note = {
  __typename?: 'Note';
  /** The allowed actions a user can perform on the note. */
  allowedActions: Array<NoteAction>;
  /** The author of the note - null if the user is deleted or left the organization. */
  author: Author;
  /** The date and time when the note was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the note. */
  id: Scalars['NoteId']['output'];
  /** The content of the note. */
  text: Scalars['String']['output'];
  /** The type of the note. */
  type: NoteType;
  /** The date and time when the note was last edited. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** List of possible actions that can be performed on a note */
export enum NoteAction {
  /** The user can delete the note. */
  DeleteNote = 'deleteNote',
  /** The user can update the note. */
  UpdateNote = 'updateNote'
}

export type NoteAuthor = {
  __typename?: 'NoteAuthor';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** The type of a note. */
export enum NoteType {
  /** A note that was generated by our AI system. */
  AiGenerated = 'aiGenerated',
  /** A note that was generated by our internal system. Can be used for approval flows notifications or other automated processes. */
  BufferGenerated = 'bufferGenerated',
  /** A note that was manually written by a user. */
  UserGenerated = 'userGenerated'
}

/** List of possible statuses for a notification */
export enum NotificationStatus {
  MarkedAsPublished = 'markedAsPublished',
  Notified = 'notified'
}

export type ObBilling = Billing & {
  __typename?: 'OBBilling';
  /** Describes the billing address of the customer */
  address?: Maybe<Address>;
  /** Any credit (negative balance) or debit (positive balance) a customer might have */
  balance: Scalars['Float']['output'];
  canAccessAnalytics: Scalars['Boolean']['output'];
  canAccessEngagement: Scalars['Boolean']['output'];
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  canStartTrial: Scalars['Boolean']['output'];
  changePlanOptions: Array<Maybe<ObPlanOption>>;
  channelSlotDetails: ChannelSlotDetails;
  /** Describes any discount coupon a customer might have */
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  generateContentTokensLeft: Scalars['Int']['output'];
  hasNeverBeenPayingCustomer: Scalars['Boolean']['output'];
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  /** Describes whether the customer is eligible for automatic tax collection in Stripe */
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Describes whether the customer's subscription is eligible for automatic tax collection in Stripe */
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  /** A set of price details that support tiers, used to calculate the total cost on the client. Non-tiered plans will only contain one PricingTier */
  pricingTiers: Array<PricingTier>;
  /** The amount of channels that can be refunded */
  refundableChannels: Scalars['Int']['output'];
  subscription: ObSubscription;
  /** Describes tax details for the Stripe customer */
  taxDetails?: Maybe<TaxDetails>;
  /** Describes customer's tax exemption status */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** Describes tax ids customer might have */
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type ObPlan = {
  __typename?: 'OBPlan';
  id: ObPlanId;
  interval: BillingInterval;
  limits: PlanLimits;
  name: Scalars['String']['output'];
  prices: PlanPrices;
};

export enum ObPlanId {
  Agency = 'agency',
  Essentials = 'essentials',
  Free = 'free',
  Team = 'team'
}

export type ObPlanOption = {
  __typename?: 'OBPlanOption';
  /** A message that displays the savings between, yearly and monthly. e.g. 'Save $24/year' when monthly plan selected or 'Saving $24/year' when yearly plan selected. For Free plans the value is empty string '' */
  absoluteSavings: Scalars['String']['output'];
  basePrice: Scalars['Float']['output'];
  /** A set of values per plan option to be used for calculating the 'Slot Based' price on the client side. */
  channelSlotDetails?: Maybe<ChannelSlotDetails>;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * A message that will be displayed when the subscription is to be canceled at the period end.
   * e.g. Your plan was recently changed to Free. You can continue using the Essentials plan features until the end of your billing cycle on April 24, 2021.
   */
  downgradedMessage: Scalars['String']['output'];
  highlights: Array<Maybe<Scalars['String']['output']>>;
  highlightsHeading: Scalars['String']['output'];
  isCurrentPlan: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  planId: ObPlanId;
  planInterval: BillingInterval;
  planName: Scalars['String']['output'];
  priceNote: Scalars['String']['output'];
  /** A set of price details that support tiers, used to calculate the total cost on the client. Non-tiered plans will only contain one PricingTierÏ */
  pricingTiers: Array<PricingTier>;
  summary: ObPlanOptionSummary;
  totalPrice: Scalars['Float']['output'];
};

export type ObPlanOptionSummary = {
  __typename?: 'OBPlanOptionSummary';
  details: Array<Maybe<Scalars['String']['output']>>;
};

export type ObSubscription = GenericSubscription & {
  __typename?: 'OBSubscription';
  /** The UTC DateTime of the cancelation */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of the its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /**
   * Indicates whether the customer's current subscription payment is past due. Used by the frontend to display a past due banner to the customer.
   * This field is not for the purpose of determining subscription status (see the Billing interface instead)
   */
  isPaymentPastDue?: Maybe<Scalars['Boolean']['output']>;
  /** The UTC DateTime of the subscription period end. Free plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: ObPlan;
  quantity: Scalars['Int']['output'];
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdate>;
  trial?: Maybe<Trial>;
};

/** The oEmbed response object as specified by https://oembed.com/. */
export type OEmbedRich = {
  __typename?: 'OEmbedRich';
  /** The name of the author/owner of the resource. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** A URL for the author/owner of the resource. */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Suggested cache lifetime for the resource (in seconds). */
  cacheAge?: Maybe<Scalars['Int']['output']>;
  /**
   * The height of the embedded resource in pixels.
   * Regarding the specification this field should be mandatory but Threads at least
   * is not sending us this field, so we'll keep optional by now.
   */
  height?: Maybe<Scalars['Int']['output']>;
  /** The HTML required to embed the resource. */
  html: Scalars['String']['output'];
  /** The name of the resource provider. */
  providerName?: Maybe<Scalars['String']['output']>;
  /** The URL of the resource provider. */
  providerUrl?: Maybe<Scalars['String']['output']>;
  /** The height of the thumbnail image in pixels. */
  thumbnailHeight?: Maybe<Scalars['Int']['output']>;
  /** A URL to a thumbnail image representing the resource. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The width of the thumbnail image in pixels. */
  thumbnailWidth?: Maybe<Scalars['Int']['output']>;
  /** A text title, describing the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of content. Always "rich". */
  type: Scalars['String']['output'];
  /** The oEmbed version number. Currently, only "1.0" is supported. */
  version: Scalars['String']['output'];
  /** The width of the embedded resource in pixels. */
  width: Scalars['Int']['output'];
};

/** Onboarding Survey Input Type for tracking an action */
export type OnboardingSurveyActionInput = {
  /** organizationId of the organization that the survey is being taken for */
  organizationId: Scalars['OrganizationId']['input'];
  /** surveyId of the survey that is being tracked */
  surveyId: Scalars['String']['input'];
};

/** Onboarding Survey Action Taken */
export type OnboardingSurveyActionTaken = {
  __typename?: 'OnboardingSurveyActionTaken';
  /** action that was taken */
  action: OnboardingSurveyActionTakenType;
  /** timestamp when the action was taken */
  date: Scalars['String']['output'];
};

/** Onboarding Survey: 3 different types of actions can be taken */
export enum OnboardingSurveyActionTakenType {
  Completed = 'completed',
  Skipped = 'skipped',
  Viewed = 'viewed'
}

export type OnboardingSurveyCompletedInput = {
  /** organizationId of the organization that the survey has been completed */
  organizationId: Scalars['OrganizationId']['input'];
  /** answers to the survey questions */
  questions: Array<OnboardingSurveyQuestionInput>;
  /** surveyId of the survey that is being taken */
  surveyId: Scalars['String']['input'];
};

/** OnboardingSurveyQuestion Input Type */
export type OnboardingSurveyQuestionInput = {
  /** answer options for the question */
  answers: Array<Scalars['String']['input']>;
  /** questionId of the question */
  questionId: Scalars['String']['input'];
};

/** Input parameters for optimizing a channel's posting schedule with Buffer's recommendations */
export type OptimizePostingScheduleInput = {
  /** The ID of the channel to optimize the schedule for */
  channelId: Scalars['ChannelId']['input'];
  /** The number of posts per week to target */
  postsPerWeek: Scalars['Int']['input'];
  /** How to apply recommendations to the existing schedule (override or add) */
  updateMode: OptimizeScheduleMode;
};

/** The result of optimizing a posting schedule */
export type OptimizePostingSchedulePayload = InvalidInputError | NotFoundError | OptimizePostingScheduleResponse | UnauthorizedError | UnexpectedError;

/** Response for successful schedule optimization */
export type OptimizePostingScheduleResponse = {
  __typename?: 'OptimizePostingScheduleResponse';
  /** The updated posting schedule */
  postingSchedule: Array<Maybe<ScheduleV2>>;
};

/** The mode for updating the posting schedule: override or add */
export enum OptimizeScheduleMode {
  Add = 'add',
  Override = 'override'
}

/** Input Types */
export type OrderBy = {
  by: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Input for ordering a channel for an account */
export type OrderChannelForAccountInput = {
  /**
   * ID of the channel after which the target channel should be positioned.
   * If set to null, the channel to order will go to the first position of the list
   */
  afterChannelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** ID of the channel to be ordered */
  channelId: Scalars['ChannelId']['input'];
  /** ID of the organization to be ordered */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Possible responses when ordering a channel for an account */
export type OrderChannelForAccountPayload = EmptySuccess | NotFoundError | UnexpectedError;

/** Organization is a representation of a Buffer Organization. */
export type Organization = {
  __typename?: 'Organization';
  billing: Billing;
  billingNotifications: BillingNotificationSet;
  canMigrateToBufferViaHub?: Maybe<CanMigrateToOneBuffer>;
  canMigrateToOneBuffer: CanMigrateToOneBuffer;
  channelCount: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of field 'limits' */
  channelLimit: Scalars['Int']['output'];
  /**
   * Fetch all channels for the account taking in account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using AccountOrganization.channels, Organization.channels or Query.channels instead
   */
  channels: Array<Channel>;
  commonTrackingProperties?: Maybe<CommonTrackingProperties>;
  contactAccountId: Scalars['String']['output'];
  dismissedObjects?: Maybe<Array<Maybe<DismissedObject>>>;
  entitlements: Array<Maybe<Entitlement>>;
  id: Scalars['ID']['output'];
  /** Is the organization enrolled in the alpha program? */
  isAlphaEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the organization enrolled in the beta program? */
  isBetaEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOneBufferOrganization: Scalars['Boolean']['output'];
  lifetimeConnectedChannelsCount?: Maybe<Array<Maybe<LifetimeConnectedChannelCount>>>;
  limits: OrganizationLimits;
  members: MemberConnection;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  shouldShowTeamMemberOrganizationDowngradedBanner: Scalars['Boolean']['output'];
  /** Fetch all accounts that can be new owners for this organization */
  validNewOwners: Array<Account>;
};


/** Organization is a representation of a Buffer Organization. */
export type OrganizationChannelsArgs = {
  input?: InputMaybe<OrganizationChannelsInput>;
  product?: InputMaybe<Product>;
};

/** Input for the channels field on Account */
export type OrganizationChannelsInput = {
  /** Query's filter. */
  filter?: InputMaybe<ChannelsFiltersInput>;
};

export type OrganizationFeatureUsageUpdateResponse = Error | Response;

/** Allow retrieving a specific AccountOrganization */
export type OrganizationFilterInput = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationIdInput = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationLimits = {
  __typename?: 'OrganizationLimits';
  channels: Scalars['Int']['output'];
  generateContent: Scalars['Int']['output'];
  ideaGroups: Scalars['Int']['output'];
  ideas: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  savedReplies: Scalars['Int']['output'];
  scheduledPosts: Scalars['Int']['output'];
  scheduledStoriesPerChannel: Scalars['Int']['output'];
  scheduledThreadsPerChannel: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
};

export type OrganizationReferralCodeResponse = {
  __typename?: 'OrganizationReferralCodeResponse';
  referralCode: Scalars['String']['output'];
};

export type OrganizationsInput = {
  ids: Array<Scalars['OrganizationId']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

/** @drepecated: Use PaginatedIdeasV2 */
export type PaginatedIdeasList = {
  __typename?: 'PaginatedIdeasList';
  edges: Array<Maybe<IdeaEdge>>;
  pageInfo: PaginationPageInfo;
};

/** @drepecated: Use PaginatedIdeasV2 */
export type PaginatedIdeasPayload = CoreWebAppCommonError | PaginatedIdeasList;

/** Pagination connection for Ideas */
export type PaginatedIdeasV2 = {
  __typename?: 'PaginatedIdeasV2';
  /** List of idea edges containing the ideas and their cursors */
  edges: Array<IdeaEdge>;
  /** Pagination metadata including hasNextPage and endCursor */
  pageInfo: PaginationPageInfo;
};

export type PaginatedPosts = {
  __typename?: 'PaginatedPosts';
  edges?: Maybe<Array<PublishingPostEdge>>;
  pageInfo: PostPageInfo;
};

export type PaginatedPostsResponse = {
  __typename?: 'PaginatedPostsResponse';
  edges?: Maybe<Array<Maybe<PostEdge>>>;
  pageInfo?: Maybe<PaginationPageInfo>;
};

/** Information to aid in pagination. */
export type PaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  /** The last cursor in the list. It can be used to fetch the next page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When set to true, it means there is a next page available. */
  hasNextPage: Scalars['Boolean']['output'];
  /** When set to true, it means there is a previous page available. Will always return false for now as we only support forward pagination. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The first cursor in the list. It can be used to fetch the previous page. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The payment details for the customer's current subscription on their current billing gateway */
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** The credit card information for the customer, if applicable */
  creditCard?: Maybe<CreditCard>;
  /** Whether the customer has payment details stored in the billing gateway */
  hasPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  /** The payment method used by the customer to pay for their current subscription */
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

/** A Pinterest board */
export type PinterestBoard = {
  __typename?: 'PinterestBoard';
  /** The board avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The board description */
  description?: Maybe<Scalars['String']['output']>;
  /** The board name */
  name: Scalars['String']['output'];
  /** The ID of the service */
  serviceId: Scalars['String']['output'];
  /** The board URL */
  url: Scalars['String']['output'];
};

export type PinterestData = {
  __typename?: 'PinterestData';
  is_repin?: Maybe<Scalars['Boolean']['output']>;
};

/** Pinterest metadata */
export type PinterestMetadata = {
  __typename?: 'PinterestMetadata';
  /** The list of boards the user has on Pinterest */
  boards: Array<PinterestBoard>;
};

/** Pinterest post metadata */
export type PinterestPostMetadata = CommonPostMetadata & {
  __typename?: 'PinterestPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The board the Pin is saved to */
  board?: Maybe<PinterestBoard>;
  /** The title of the Pin */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
  /** The Pin destination link */
  url?: Maybe<Scalars['String']['output']>;
};

/** Pinterest post metadata */
export type PinterestPostMetadataInput = {
  /**
   * The board ID of the Pin, can be obtained when fetching the channel details with the following query:
   * ```
   * query GetChannelWithSubprofiles {
   *   channel(input: { id: "[CHANNEL_ID_HERE]" }) {
   *     metadata {
   *       ... on PinterestMetadata {
   *         boards {
   *           serviceId
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   */
  boardServiceId: Scalars['String']['input'];
  /** The title of the Pin */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The Pin destination link */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceholderIdeasCreatedPayload = CoreWebAppCommonError | PlaceholderIdeasMutationSuccess;

/** Query / Mutation responses */
export type PlaceholderIdeasMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'PlaceholderIdeasMutationSuccess';
  code: Scalars['String']['output'];
  /** The created ideas */
  ideas: Array<Idea>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PlanLimits = {
  __typename?: 'PlanLimits';
  channels: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  scheduledPosts: Scalars['Int']['output'];
};

export type PlanMigrationPreview = {
  __typename?: 'PlanMigrationPreview';
  chargeAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  intervalAmount?: Maybe<Scalars['Float']['output']>;
};

export type PlanMigrationPreviewDetails = {
  __typename?: 'PlanMigrationPreviewDetails';
  currentPlan: MigrationPlan;
  migrationSummary?: Maybe<MigrationSummary>;
  planFeatures: Array<Maybe<MigrationMarketingFeaturesCopy>>;
  suggestedPlan: MigrationPlan;
};

export type PlanMigrationPreviewResponse = {
  __typename?: 'PlanMigrationPreviewResponse';
  preview?: Maybe<PlanMigrationPreviewDetails>;
  showPreview: Scalars['Boolean']['output'];
};

export type PlanPrices = {
  __typename?: 'PlanPrices';
  /**
   * Describes the monthly amount of a Plan, in dollars, without the quantity multipliers and any customer or subscription discounts.
   * This value differs from the "upcomingInvoiceAmount" that describes the exact amount that the customer is paying.
   */
  baseMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Describes Plan amount, in dollars, without the quantity multipliers and any customer or subscription discounts.
   * This value differs from the "upcomingInvoiceAmount" that describes the exact amount that the customer is paying.
   */
  basePlanPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The amount of channels up to that are covered by the flat Fee.
   * Used for tiered pricing plans only.
   */
  channelTierUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The monthly channel price a customer pays for every channel above the channelTierUnit.
   * Used for tiered pricing plans only.
   */
  monthlyChannelPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The monthly amount (calculated as monthly for yearly subscriptions as well) a customer pays, irrelevant to the amount of channels connected.
   * Used for tiered pricing plans only.
   */
  monthlyFlatFee?: Maybe<Scalars['Float']['output']>;
};

/** Post entity */
export type Post = {
  __typename?: 'Post';
  /** actions */
  allowedActions: Array<PostAction>;
  /** assets */
  assets: Array<Asset>;
  /** Represents the user who created the post */
  author?: Maybe<Author>;
  /** channel */
  channel: Channel;
  /** channel ID (faster than resolving the channnel.id) */
  channelId: Scalars['ChannelId']['output'];
  /** channel service (faster than resolving the channnel.service) */
  channelService: Service;
  /** Date when the post was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date when the post is scheduled to be published */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** error */
  error?: Maybe<PostPublishingError>;
  /** The external URL of the post at the destination service */
  externalLink?: Maybe<Scalars['String']['output']>;
  /** ObjectId of the post */
  id: Scalars['PostId']['output'];
  /** Is set when the Post is generated from an Idea */
  ideaId?: Maybe<Scalars['IdeaId']['output']>;
  /** Indicates whether time to publish was manually selected by the user */
  isCustomScheduled: Scalars['Boolean']['output'];
  /** flags */
  isPinned: Scalars['Boolean']['output'];
  /**
   * Metadata of the post which differs based on the social network/service
   * @see post.metadata.graphql
   */
  metadata?: Maybe<PostMetadata>;
  /** Metrics for the sent post. If post is not yet sent, this field will be null */
  metrics?: Maybe<Array<PostMetric>>;
  /** Metrics for the sent post. If post is not yet sent, this field will be null */
  metricsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** notes */
  notes: Array<Note>;
  /** notificationStatus: notified or markedAsPublished */
  notificationStatus?: Maybe<NotificationStatus>;
  /** Scheduling type can be null if the post was created natively on the social network without using notification publishing or automatic publishing */
  schedulingType?: Maybe<SchedulingType>;
  /** Date when the post is published */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the post was shared via publish now action */
  sharedNow: Scalars['Boolean']['output'];
  /** status */
  status: PostStatus;
  /** tags - sorted by name in ascending order */
  tags: Array<Tag>;
  /** Text content of the Post */
  text: Scalars['String']['output'];
  /** Date when the post was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Indicates if the post is created from Buffer or the API */
  via: PostVia;
};

/** List of possible actions that can be performed on a Post */
export enum PostAction {
  AddPostNote = 'addPostNote',
  AddPostToQueue = 'addPostToQueue',
  ApprovePost = 'approvePost',
  CopyPostLink = 'copyPostLink',
  DeletePost = 'deletePost',
  DuplicatePost = 'duplicatePost',
  MovePostToDraft = 'movePostToDraft',
  PublishPostNext = 'publishPostNext',
  PublishPostNow = 'publishPostNow',
  RejectPost = 'rejectPost',
  RemovePostScheduledTime = 'removePostScheduledTime',
  RequestPostApproval = 'requestPostApproval',
  RevertPostApprovalRequest = 'revertPostApprovalRequest',
  SharePostLink = 'sharePostLink',
  UpdatePost = 'updatePost',
  UpdatePostSchedule = 'updatePostSchedule',
  UpdatePostTags = 'updatePostTags',
  UpdateShopGridLink = 'updateShopGridLink',
  ViewPost = 'viewPost'
}

/** Create post's request response payload. */
export type PostActionPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Success response returns the full up-to-date post from after the action was performed. */
export type PostActionSuccess = {
  __typename?: 'PostActionSuccess';
  /** Post on which the action was successfully performed. */
  post: Post;
};

/** Filters for the posts count query */
export type PostCountsFiltersInput = {
  /** When set, it will filter posts by channel */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** When set, it will filter posts by status */
  status?: InputMaybe<Array<PostStatus>>;
  /** When set, it will filter posts by tag */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
};

/** Input for the posts count query */
export type PostCountsInput = {
  /** The filters to apply to the posts query */
  filter?: InputMaybe<PostCountsFiltersInput>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the post counts query */
export type PostCountsResponse = {
  __typename?: 'PostCountsResponse';
  /** The list of counts for the given organization */
  counts: Array<PostsCount>;
};

export type PostDeletionPayload = PostDeletionResponse | PublishingError;

export type PostDeletionResponse = {
  __typename?: 'PostDeletionResponse';
  postId: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EngagePost>;
};

export type PostFiltersInput = {
  /** The channel(s) ids to fetch posts for */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate?: InputMaybe<Scalars['Int']['input']>;
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate?: InputMaybe<Scalars['Int']['input']>;
  /** The status of posts to return */
  status?: InputMaybe<Array<PublishingPostStatus>>;
  /** The tag(s) ids of posts to return */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PostIdInput = {
  postId: Scalars['String']['input'];
};

/** Input for the post query */
export type PostInput = {
  /** The ID of the post to be retrieved */
  id: Scalars['PostId']['input'];
};

/** Metadata of the post which differs based on the social network/service */
export type PostInputMetaData = {
  /** Metadata for Bluesky post */
  bluesky?: InputMaybe<BlueskyPostMetadataInput>;
  /** Metadata for Facebook post */
  facebook?: InputMaybe<FacebookPostMetadataInput>;
  /** Metadata for Google Business Profile post */
  google?: InputMaybe<GoogleBusinessPostMetadataInput>;
  /** Metadata for Instagram post */
  instagram?: InputMaybe<InstagramPostMetadataInput>;
  /** Metadata for LinkedIn post */
  linkedin?: InputMaybe<LinkedInPostMetadataInput>;
  /** Metadata for Mastodon post */
  mastodon?: InputMaybe<MastodonPostMetadataInput>;
  /** Metadata for Pinterest post */
  pinterest?: InputMaybe<PinterestPostMetadataInput>;
  /** Metadata for Start Page post */
  startPage?: InputMaybe<StartPagePostMetadataInput>;
  /** Metadata for Threads post */
  threads?: InputMaybe<ThreadsPostMetadataInput>;
  /** Metadata for Twitter post */
  twitter?: InputMaybe<TwitterPostMetadataInput>;
  /** Metadata for Youtube post */
  youtube?: InputMaybe<YoutubePostMetadataInput>;
};

/** Post metadata union type. Contains all possible types of post metadata. */
export type PostMetadata = BlueskyPostMetadata | FacebookPostMetadata | GoogleBusinessPostMetadata | InstagramPostMetadata | LinkedInPostMetadata | MastodonPostMetadata | PinterestPostMetadata | StartPagePostMetadata | ThreadsPostMetadata | TiktokPostMetadata | TwitterPostMetadata | YoutubePostMetadata;

/** Post metric */
export type PostMetric = {
  __typename?: 'PostMetric';
  /** The metric description */
  description: Scalars['String']['output'];
  /** The displayble metric name */
  displayName: Scalars['String']['output'];
  /** The metric name */
  name: Scalars['String']['output'];
  /** The metric value returning null if not in the DB */
  nullableValue?: Maybe<Scalars['Float']['output']>;
  /** The metric type */
  type: PostMetricType;
  /** The metric unit of the value */
  unit: PostMetricUnit;
  /** The metric value */
  value: Scalars['Float']['output'];
};

export type PostMetricLegacy = {
  __typename?: 'PostMetricLegacy';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type PostMetricObject = {
  __typename?: 'PostMetricObject';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values?: Maybe<Array<PostMetricLegacy>>;
};

/** List of possible metrics available for a Post. Some services may have different metrics (e.g., Instagram has likes, comments, shares but Twitter has retweets, likes) */
export enum PostMetricType {
  Clicks = 'clicks',
  Comments = 'comments',
  EngagementRate = 'engagementRate',
  Favorites = 'favorites',
  Impressions = 'impressions',
  Likes = 'likes',
  LinkClicks = 'link_clicks',
  /** deprecated */
  Other = 'other',
  Quotes = 'quotes',
  Reach = 'reach',
  Reactions = 'reactions',
  Reblogs = 'reblogs',
  Repins = 'repins',
  Replies = 'replies',
  Reposts = 'reposts',
  Retweets = 'retweets',
  Saves = 'saves',
  Shares = 'shares',
  TotalTimeWatched = 'totalTimeWatched',
  Viewers = 'viewers',
  Views = 'views'
}

/** The unit representing the value of a PostMetric */
export enum PostMetricUnit {
  Count = 'count',
  Percentage = 'percentage'
}

export type PostNotFound = CoreWebAppMutationResponse & {
  __typename?: 'PostNotFound';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The ID of the post that could not be found */
  postId: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostNotUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostNotUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The ID of the post that could not be found */
  postId: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostPageInfo = {
  __typename?: 'PostPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Post publishing error */
export type PostPublishingError = {
  __typename?: 'PostPublishingError';
  /** Error message to display */
  message: Scalars['String']['output'];
  /** Link to a help center article to help resolve the error */
  supportUrl?: Maybe<Scalars['String']['output']>;
};

/** Represents the number of posts for a service during some span of time */
export type PostServiceCount = {
  __typename?: 'PostServiceCount';
  hasAutoApprovedDrafts: Scalars['Boolean']['output'];
  hasDraftsAwaitingApproval: Scalars['Boolean']['output'];
  service: Service;
  value: Scalars['Int']['output'];
};

/** Sort order of post results. List multiple to create tie-breaking order. */
export type PostSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: PostSortableKey;
};

/** Key of collection to use for sorting */
export enum PostSortableKey {
  /**
   * Sort by the post's createdAt field.
   * Created at is the date when the post was created.
   */
  CreatedAt = 'createdAt',
  /**
   * Sort by the post's dueAt field.
   * Due at is the date when the post is scheduled to be published.
   */
  DueAt = 'dueAt'
}

export type PostStatistics = {
  __typename?: 'PostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  favorites?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  linkClicks?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  quotes?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  reach_twitter?: Maybe<Scalars['Int']['output']>;
  reactions?: Maybe<Scalars['Int']['output']>;
  repins?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Scalars['Int']['output']>;
  reposts?: Maybe<Scalars['Int']['output']>;
  reshares?: Maybe<Scalars['Int']['output']>;
  retweets?: Maybe<Scalars['Int']['output']>;
  saves?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostStatisticsV2 = PostMetricLegacy | PostMetricObject;

/** List of possible statuses for a Post */
export enum PostStatus {
  Draft = 'draft',
  Error = 'error',
  NeedsApproval = 'needs_approval',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent'
}

/** List of possible types for a Post. Some services may have different types (e.g., Instagram has story, reel, post but Twitter has only post) */
export enum PostType {
  Carousel = 'carousel',
  Event = 'event',
  Offer = 'offer',
  Post = 'post',
  Reel = 'reel',
  Short = 'short',
  Story = 'story',
  WhatsNew = 'whats_new'
}

/** List of specific post types available for Facebook */
export enum PostTypeFacebook {
  Post = 'post',
  Reel = 'reel',
  Story = 'story'
}

/** List of specific post types available for Google Business profiles */
export enum PostTypeGoogleBusiness {
  Event = 'event',
  Offer = 'offer',
  WhatsNew = 'whats_new'
}

export type PostUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The updated post */
  post: PublishingPost;
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostUpdatedPayload = CoreWebAppCommonError | PostNotFound | PostNotUpdated | PostUpdated;

/** List of possible ways to create a Post */
export enum PostVia {
  Api = 'api',
  Buffer = 'buffer',
  Network = 'network'
}

/** Represents a posting goal for a channel, including target, progress, and status information. */
export type PostingGoal = {
  __typename?: 'PostingGoal';
  /** The target number of posts for this goal. */
  goal: Scalars['Int']['output'];
  /** The end date of the period for this posting goal. */
  periodEnd: Scalars['DateTime']['output'];
  /** The start date of the period for this posting goal. */
  periodStart: Scalars['DateTime']['output'];
  /** The number of posts that are scheduled to be sent for this goal. */
  scheduledCount: Scalars['Int']['output'];
  /** The number of posts that have been sent (published or ingested) for this goal. */
  sentCount: Scalars['Int']['output'];
  /** The current status of the posting goal. */
  status: PostingGoalStatus;
};

/** PostingGoalStatus is used to track the status of a posting goal. */
export enum PostingGoalStatus {
  AtRisk = 'AtRisk',
  Hit = 'Hit',
  OnTrack = 'OnTrack'
}

export type PostingSchedule = {
  __typename?: 'PostingSchedule';
  schedules: Array<Schedule>;
};

/** Counts for a given channel */
export type PostsCount = {
  __typename?: 'PostsCount';
  /** The channel the counts are for */
  channelId: Scalars['ChannelId']['output'];
  /** The count of posts matching the filters and channel */
  count: Scalars['Int']['output'];
  /**
   * This field is used by the BE to limit the results in the DB query
   * when the query fails due to a time out.
   * BE will return the used limit to the FE and the FE will have to handle it
   * to get the remaining data.
   */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type PostsEdge = {
  __typename?: 'PostsEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current post in the list. */
  node: Post;
};

export type PostsFilter = {
  by?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filter to apply to the posts query */
export type PostsFiltersInput = {
  /** When set, it will filter posts by channel */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** When set, it will filter posts by the date they were created */
  createdAt?: InputMaybe<DateTimeComparator>;
  /** When set, it will filter posts by their scheduled posting date */
  dueAt?: InputMaybe<DateTimeComparator>;
  /**
   * When set, it will return posts with createdAt or dueAt date before endDate
   * @deprecated Use field specific filters instead (e.g. dueAt, createdAt, sentAt)
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * When set, it will return posts with createdAt or dueAt date after startDate
   * @deprecated Use field specific filters instead (e.g. dueAt, createdAt, sentAt)
   */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** When set, it will filter posts by status */
  status?: InputMaybe<Array<PostStatus>>;
  /** When set, it will filter posts by tag */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
};

/** Input for the posts query */
export type PostsInput = {
  /** The filters to apply to the posts query */
  filter?: InputMaybe<PostsFiltersInput>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['OrganizationId']['input'];
  /** The sort to apply to the posts results */
  sort?: InputMaybe<Array<PostSortInput>>;
};

export type PostsLegacyInput = {
  /** The cursor to start returning posts from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The filters to apply to the posts query */
  filters?: InputMaybe<PostFiltersInput>;
  /** The amount of posts to return */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['ID']['input'];
};

/** Results for the posts query. */
export type PostsResults = {
  __typename?: 'PostsResults';
  /** The list of posts that match the query. */
  edges?: Maybe<Array<PostsEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
  /**
   * The total number of posts that match the query.
   * @deprecated Use postsCount instead
   */
  totalCount: Scalars['Int']['output'];
};

/** Account preferences */
export type Preferences = {
  __typename?: 'Preferences';
  defaultScheduleOption: ScheduleOption;
  startOfWeek?: Maybe<Scalars['String']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
};

export type PricingTier = {
  __typename?: 'PricingTier';
  /** Fixed amount for the tier, if applicable. */
  flatFee: Scalars['Float']['output'];
  /** The price that a customer will pay for each unit (e.g. channel) within this tier */
  unitPrice: Scalars['Float']['output'];
  /** The upper bound for this tier. */
  upperBound: Scalars['Int']['output'];
};

/** Buffer products, buffer is used as all producs */
export enum Product {
  Analyze = 'analyze',
  Buffer = 'buffer',
  Comments = 'comments',
  Engage = 'engage',
  Publish = 'publish',
  StartPage = 'startPage'
}

export type ProductLink = {
  __typename?: 'ProductLink';
  name: Product;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** publishPostNow mutation publish now a post by id. */
export type PublishPostNowInput = {
  /** Post id to publish now. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by publishPostNow mutation. */
export type PublishPostNowPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError | VideoProcessingError;

export type PublishStartPageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type PublishingCampaign = {
  __typename?: 'PublishingCampaign';
  color: HexColor;
  endDate?: Maybe<Scalars['Int']['output']>;
  /** Human readable date of campaign. E.g., 'Oct 11-13' */
  formattedDateRange?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Int']['output']>;
};

export type PublishingChannel = {
  __typename?: 'PublishingChannel';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationData?: Maybe<ChannelLocationData>;
  serverUrl?: Maybe<Scalars['String']['output']>;
  service: Service;
  timezone?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type PublishingError = {
  __typename?: 'PublishingError';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A code to describe the status eg 200 for success, 404 for not found */
  code?: Maybe<Scalars['String']['output']>;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type PublishingNote = {
  __typename?: 'PublishingNote';
  author: NoteAuthor;
  createdAt: Scalars['Int']['output'];
  editedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: NoteType;
};

export type PublishingPost = {
  __typename?: 'PublishingPost';
  /** LinkedIn mentions, referred to as annotations */
  annotations?: Maybe<Array<LinkedInAnnotation>>;
  /** Attachments such as retweet, link, etc. for this post */
  attachments?: Maybe<Array<Maybe<PublishingPostAttachment>>>;
  /** The author of the post */
  author: Author;
  /** The campaign this post is associated with */
  campaign?: Maybe<PublishingCampaign>;
  /** The channel to which this post will be (or is) published */
  channel: PublishingChannel;
  /** Channel specific data */
  channelData?: Maybe<ChannelData>;
  /** Id of the user who created the post */
  createdBy: Scalars['ID']['output'];
  /** The unix timestamp of when the post was (or will be) sent */
  dueAt?: Maybe<Scalars['Int']['output']>;
  /** Facebook mentions, referred to as entities */
  entities?: Maybe<Array<FacebookEntity>>;
  /** Details of the post error, if present */
  error?: Maybe<PublishingPostError>;
  /** A human readable timestamp of when the post is (or will be) sent, e.g., '2:10 PM' or '14:10' */
  formattedTime?: Maybe<Scalars['String']['output']>;
  /** The location for the post */
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  /** Flag to check if the post was created via Blueprints */
  isBlueprint?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this post is (or was) scheduled for a specific date and time */
  isCustomScheduled: Scalars['Boolean']['output'];
  /** Whether this post is (or was) specifically scheduled into one of the channel's schedule time slots */
  isPinned: Scalars['Boolean']['output'];
  /** Is the profile queue paused */
  isQueuePaused: Scalars['Boolean']['output'];
  /** Whether this post is (or will be) sent as an Instagram reminder */
  isReminder: Scalars['Boolean']['output'];
  /** Whether this post is a retweet */
  isRetweet: Scalars['Boolean']['output'];
  /** Media items (images, videos) attached to this post */
  media?: Maybe<Array<PublishingPostMedia>>;
  /** Whether a post needs approval before being scheduled */
  needsApproval?: Maybe<Scalars['Boolean']['output']>;
  /** The list of notes added to the post */
  notes?: Maybe<Array<Maybe<PublishingNote>>>;
  /** The direct URL to the post */
  serviceLink?: Maybe<Scalars['String']['output']>;
  /** Pinterest source url */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Post analytics */
  statistics?: Maybe<PostStatistics>;
  /** Post analytics V2 - supports filtering of Premium analytics */
  statisticsV2: Array<PostStatisticsV2>;
  /** The current state of the post */
  status: PublishingPostStatus;
  /** The subprofile is currently only used for Pinterest Boards */
  subprofile?: Maybe<PublishingSubprofile>;
  /** Attachments such as retweet, link, etc. for this post */
  tags: Array<PublishingTag>;
  /** The text content of the post */
  text?: Maybe<Scalars['String']['output']>;
  /** Number of threaded updates, including the parent update */
  threadCount?: Maybe<Scalars['Int']['output']>;
  /** The post title, this is currently only used for Pinterest */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of post, always 'post' for now, but could be 'story' in a future version */
  type: PublishingPostType;
  /** Type of the update (e.g. Reel or Feed for IG) */
  updateType?: Maybe<Scalars['String']['output']>;
  /** Source of the post */
  via?: Maybe<Scalars['String']['output']>;
};

export type PublishingPostAttachment = PublishingPostDestinationUrl | PublishingPostFirstComment | PublishingPostLink | PublishingPostRetweet;

export type PublishingPostDestinationUrl = {
  __typename?: 'PublishingPostDestinationUrl';
  url: Scalars['String']['output'];
};

export type PublishingPostEdge = {
  __typename?: 'PublishingPostEdge';
  cursor: Scalars['String']['output'];
  node: PublishingPost;
};

export type PublishingPostError = {
  __typename?: 'PublishingPostError';
  actionType?: Maybe<PublishingPostErrorAction>;
  code?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rawError?: Maybe<Scalars['String']['output']>;
};

export enum PublishingPostErrorAction {
  Refresh = 'refresh',
  Verify = 'verify'
}

export type PublishingPostFirstComment = {
  __typename?: 'PublishingPostFirstComment';
  text: Scalars['String']['output'];
};

export type PublishingPostLink = {
  __typename?: 'PublishingPostLink';
  description?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PublishingPostMedia = {
  __typename?: 'PublishingPostMedia';
  original: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: MediaType;
};

export type PublishingPostRetweet = {
  __typename?: 'PublishingPostRetweet';
  accountName: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  /** The unix timestamp of when the tweet was sent to retweets */
  sentAt: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  /** The tweet url */
  url: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum PublishingPostStatus {
  Draft = 'draft',
  Error = 'error',
  Pending = 'pending',
  PendingApproval = 'pending_approval',
  PendingTiktok = 'pending_tiktok',
  Scheduled = 'scheduled',
  Sent = 'sent'
}

export enum PublishingPostType {
  Draft = 'draft',
  Post = 'post',
  Story = 'story'
}

/** Represents the publishing status of a comment. */
export type PublishingStatus = {
  __typename?: 'PublishingStatus';
  /** Error message, if the reply failed and the status is Error */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The current status of the reply (e.g. error, published, processing). */
  status: CommentEngagementStatusTypes;
};

export type PublishingSubprofile = {
  __typename?: 'PublishingSubprofile';
  avatar?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['ID']['output'];
  createdAt: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShared: Scalars['Boolean']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  service: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type PublishingTag = {
  __typename?: 'PublishingTag';
  /** Hex color for tag e.g #F523F1 */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PusherAuth = {
  __typename?: 'PusherAuth';
  auth?: Maybe<Scalars['String']['output']>;
};

export type PusherAuthenticationInput = {
  organizationId: Scalars['String']['input'];
  pusherChannel: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};

/** List of post Query operations */
export type Query = {
  __typename?: 'Query';
  account: Account;
  /** Fetch a Buffer account by its associated email address */
  accountByEmail: Account;
  /** Fetch a Buffer account by its account Id */
  accountById: Account;
  /** Fetch a Buffer account by a product name and foreign key */
  accountByProductLink: Account;
  alphaFeatures: Array<AlphaFeature>;
  analyticsAnswers: AnalyticsAnswers;
  analyticsDailies: Array<Maybe<AnalyticsDaily>>;
  analyticsHashtags: Array<Maybe<AnalyticsHashtag>>;
  analyticsPosts: Array<Maybe<AnalyticsPost>>;
  analyticsPostsTotals: AnalyticsPostsTotals;
  analyticsTotals: AnalyticsTotals;
  betaFeatures: Array<BetaFeature>;
  /** Fetch a calendar for a given channel and time period */
  calendar?: Maybe<CalendarsPayload>;
  /** Fetch a single post by id */
  calendarPost?: Maybe<PublishingPost>;
  canConnectChannels?: Maybe<Array<ChannelConnectionAvailability>>;
  /** Fetches a single channel using the provided ID */
  channel: Channel;
  /** Get the authorization URL for a network. */
  channelAuthorizationInfo: ChannelAuthorizationInfoResponse;
  channelAuthorizationUrl: ChannelAuthorizationUrlPayload;
  /**
   * Fetch a channel by its channel Id
   * @deprecated Use the new channel query instead
   */
  channelById?: Maybe<Channel>;
  channelGetByServiceAndServiceId?: Maybe<Channel>;
  channelGetTemporaryCredentials: ChannelCredentials;
  /** Fetches a single channel group */
  channelGroup: ChannelGroupPayload;
  /** Fetches all channel groups for an account in the organization */
  channelGroups: ChannelGroupsPayload;
  /** Fetch all channels for the organization taking in account the current's user permissions */
  channels: Array<Channel>;
  chargeById?: Maybe<Charge>;
  checklists: ChecklistsPayload;
  /** Retrieve information for an API client based on the provided arguments (such as the client platform) */
  client: ClientPayload;
  /**
   * Returns the comments' context menaning the parent comments of the input comment, the parent of the parent and so on
   * until the root comment
   */
  commentContext: CommentContextResponse;
  /** Returns the suggestions for a given comment generated by the AI */
  commentSuggestions: CommentSuggestionsResponse;
  /**
   * Returns the comments' thread meaning the parent comments of the input comment, the parent of the parent and so on
   * until the root comment, the comment and the reply to the comment (if comment has been replied)
   */
  commentThread: CommentThreadResponse;
  /**
   * Fetches comments for the given organization and filters.
   * The results are sorted by the option in sort.
   * first and after can be set for forward pagination using Relay convention.
   * Index in DB: { organizationId: 1 , channelId: 1, status: 1, publishedAt: 1)
   */
  comments: CommentsResults;
  /** Query to fetch the counts for comments in the organization */
  commentsCounts: CommentsCountsResponse;
  /** Returns the insights for a given channelID and prompt extracted from the last comments and posts using AI */
  commentsInsights: CommentsInsightsResponse;
  /** Retrieve the oEmbed representation of a URL for a given channel. */
  commentsOEmbed?: Maybe<CommentsOEmbedResponse>;
  /** Returns the comments' score for a given channel for the current and previous week */
  commentsScore: CommentsScoreResponse;
  /** Provides a list of services, with properties based on the provided organization and client information */
  connectableServices: ConnectableServicesPayload;
  emailNotificationPreferences: EmailNotificationPreferencePayload;
  engageOrganization?: Maybe<EngageOrganization>;
  engagePost?: Maybe<EngagePost>;
  engagePosts?: Maybe<PaginatedPostsResponse>;
  engagePostsV2?: Maybe<PaginatedPostsResponse>;
  engagePusherAuthentication?: Maybe<PusherAuth>;
  engageUserSettings?: Maybe<UserSettings>;
  featureFlips?: Maybe<Array<FeatureFlip>>;
  /** Fetches a (single) feed by FeedID */
  feed?: Maybe<Feed>;
  /** Fetches a (single) feed collection by FeedCollectionID */
  feedCollection: FeedCollection;
  /** Fetches (lists) feed collections for the given organization */
  feedCollections: FeedCollectionConnection;
  /** Fetches (lists) feed items for the given feed collection */
  feedItems: FeedItemConnection;
  /** Fetches all feeds for the given organization */
  feeds: Array<Feed>;
  /** Fetches an  access token for a channel */
  getAccessTokensForChannel: GetAccessTokensForChannelPayload;
  healthStatus?: Maybe<HealthStatus>;
  idea?: Maybe<IdeaPayload>;
  /** Retrieves idea groups based on the provided input parameters. */
  ideaGroups: Array<IdeaGroup>;
  /** @deprecated Use ideasV2 */
  ideas: PaginatedIdeasPayload;
  ideasCount: IdeasCountPayload;
  ideasCountByTag: IdeasCountPayload;
  ideasCountByTags: IdeasCountByTagsPayload;
  /** Fetch a paginated list of ideas with optional filtering */
  ideasV2: PaginatedIdeasV2;
  imagesTrackDownload: MutationBasicPayload;
  invoicesByOrganization: InvoiceConnection;
  isNewRemindersEnabledForOrganization: SplitEnabledResponse;
  isSplitEnabledForOrganization: SplitEnabledResponse;
  /** Query to list all failed post errors. */
  listFailedPostErrors: ListFailedPostErrorsPayload;
  location: LocationPayload;
  organization?: Maybe<Organization>;
  /** Retrieve the Referral Code for a particular organization */
  organizationReferralCode: OrganizationReferralCodeResponse;
  organizations: Array<Maybe<Organization>>;
  /**
   * This is a new previewPlanMigration query which is focusing on the
   * Migration Hub summary only.
   */
  planMigrationSummaryViaHub: PlanMigrationPreview;
  /** Fetches a post by PostID for the given organization: first and last can be set for forward pagination using Relay convention */
  post: Post;
  /** Returns the counts by channel for the given organization */
  postCounts: PostCountsResponse;
  /** Fetches posts for the given organization: first and last can be set for forward pagination using Relay convention */
  posts: PostsResults;
  /** @deprecated Use the new posts query */
  postsLegacy: PaginatedPosts;
  previewCustomUpcomingInvoice: UpcomingInvoiceCostsPreview;
  /**
   * Querying the plan migration preview will result into a null preview
   * if the canMigrateToOneBuffer flag is false or if the account is on a Free plan
   */
  previewPlanMigration: PlanMigrationPreviewResponse;
  pusherAuthentication: PusherAuth;
  /** Get the recovery code for Two Factor Authentication */
  recoveryCode: TwoFactorRecoveryCodePayload;
  /**
   * Get an S3 pre-signed URL for the given filename and mime-type.
   * The S3 pre-signed URL can be used to directly upload the file to S3 from the client application.
   */
  s3PreSignedURL: S3PreSigneUrlResult;
  /** Get S3 signature for uploading files */
  s3Signature: S3Signature;
  s3SignedUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Get an S3 pre-signed URL for the given filename and mime-type.
   * The an S3 pre-signed URL can be used to directly upload the file to S3 from the client application.
   * @deprecated Use s3PreSignedURL instead
   */
  s3UploadPreSignedURL: S3UploadPreSigneUrlResult;
  /** Returns the saved replies for a given organization */
  savedReplies: SavedRepliesResponse;
  schedules: SchedulesPayload;
  searchImages: ImageSearchPayload;
  /**
   * Search for Threads locations that can be tagged in posts.
   * Requires at least 2 characters in the search query.
   */
  searchThreadsLocations: SearchThreadsLocationsPayload;
  /** Retrieves a list of service tags based on the provided input. */
  serviceMentions: Array<ServiceMention>;
  /** Get Shop Grid Custom Links */
  shopGridCustomLinks: ShopGridCustomLinksPayload;
  startPage?: Maybe<StartPageResponse>;
  startPageBlock?: Maybe<StartPageBlock>;
  startPageTemplates?: Maybe<StartPageTemplatesResponse>;
  startPageThemes?: Maybe<StartPageThemesResponse>;
  /** @deprecated Use `startPage`. */
  startPageV2?: Maybe<StartPageResponse>;
  startPages?: Maybe<StartPagesResponse>;
  /** Fetch all tags for the organization sorted by name in ascending order */
  tags: Array<Tag>;
  /**
   * Dummy query for testing the new BufferAdmin actor during Retool development.
   * Will be removed later.
   */
  testAdminRestrictedQuery: Scalars['String']['output'];
  upload?: Maybe<UploadPayload>;
  /**
   * Returns the weekly posting streak for the given organization.
   * Null means, the streak widget should not be shown.
   * It checks that the actor is an owner of the organization, otherwise it returns null.
   */
  weeklyPostingStreak?: Maybe<Streak>;
  /** Retrieve categories for youtube videos. Categories are hardcoded for now. */
  youtubeCategories: Array<YoutubeCategory>;
};


/** List of post Query operations */
export type QueryAccountByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryAccountByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryAccountByProductLinkArgs = {
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Product>;
};


/** List of post Query operations */
export type QueryAnalyticsAnswersArgs = {
  endDate: Scalars['Date']['input'];
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsDailiesArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsHashtagsArgs = {
  endDate: Scalars['Date']['input'];
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsPostsArgs = {
  endDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: AnalyticsOrderByField;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsPostsTotalsArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsTotalsArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryCalendarArgs = {
  input?: InputMaybe<CalendarInput>;
};


/** List of post Query operations */
export type QueryCalendarPostArgs = {
  input: CalendarPostInput;
};


/** List of post Query operations */
export type QueryCanConnectChannelsArgs = {
  channels?: InputMaybe<Array<CanConnectChannelsInput>>;
};


/** List of post Query operations */
export type QueryChannelArgs = {
  input: ChannelInput;
};


/** List of post Query operations */
export type QueryChannelAuthorizationInfoArgs = {
  input: ChannelAuthorizationInfoInput;
};


/** List of post Query operations */
export type QueryChannelAuthorizationUrlArgs = {
  channelAuthorizationUrl: ChannelAuthorizationUrlInput;
};


/** List of post Query operations */
export type QueryChannelByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryChannelGetByServiceAndServiceIdArgs = {
  service: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryChannelGetTemporaryCredentialsArgs = {
  service: Scalars['String']['input'];
  serviceId: Service;
};


/** List of post Query operations */
export type QueryChannelGroupArgs = {
  input: ChannelGroupInput;
};


/** List of post Query operations */
export type QueryChannelGroupsArgs = {
  input: ChannelGroupsInput;
};


/** List of post Query operations */
export type QueryChannelsArgs = {
  input: ChannelsInput;
};


/** List of post Query operations */
export type QueryChargeByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryChecklistsArgs = {
  input: OrganizationIdInput;
};


/** List of post Query operations */
export type QueryClientArgs = {
  input: ClientInput;
};


/** List of post Query operations */
export type QueryCommentContextArgs = {
  input: CommentContextInput;
};


/** List of post Query operations */
export type QueryCommentSuggestionsArgs = {
  input: CommentSuggestionsInput;
};


/** List of post Query operations */
export type QueryCommentThreadArgs = {
  input: CommentThreadInput;
};


/** List of post Query operations */
export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CommentsInput;
};


/** List of post Query operations */
export type QueryCommentsCountsArgs = {
  input: CommentsCountsInput;
};


/** List of post Query operations */
export type QueryCommentsInsightsArgs = {
  input: CommentsInsightsInput;
};


/** List of post Query operations */
export type QueryCommentsOEmbedArgs = {
  input: CommentsOEmbedInput;
};


/** List of post Query operations */
export type QueryCommentsScoreArgs = {
  input: CommentsScoreInput;
};


/** List of post Query operations */
export type QueryConnectableServicesArgs = {
  input?: InputMaybe<ConnectableServicesInput>;
};


/** List of post Query operations */
export type QueryEngageOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryEngagePostArgs = {
  id: Scalars['String']['input'];
  refreshMedia?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Query operations */
export type QueryEngagePostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelService: Scalars['String']['input'];
  channelServiceId: Scalars['String']['input'];
  filter?: InputMaybe<PostsFilter>;
  first: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryEngagePostsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelServiceId: Scalars['String']['input'];
  filter?: InputMaybe<PostsFilter>;
  first: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryEngagePusherAuthenticationArgs = {
  organizationId: Scalars['String']['input'];
  pusherChannel: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryFeedArgs = {
  input: FeedInput;
};


/** List of post Query operations */
export type QueryFeedCollectionArgs = {
  input: FeedCollectionInput;
};


/** List of post Query operations */
export type QueryFeedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedCollectionsInput;
};


/** List of post Query operations */
export type QueryFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedItemsInput;
};


/** List of post Query operations */
export type QueryFeedsArgs = {
  input: FeedsInput;
};


/** List of post Query operations */
export type QueryGetAccessTokensForChannelArgs = {
  input: GetAccessTokensForChannelInput;
};


/** List of post Query operations */
export type QueryIdeaArgs = {
  input: IdeaIdInput;
};


/** List of post Query operations */
export type QueryIdeaGroupsArgs = {
  input: IdeaGroupsInput;
};


/** List of post Query operations */
export type QueryIdeasArgs = {
  input: IdeasListInput;
};


/** List of post Query operations */
export type QueryIdeasCountArgs = {
  input: OrganizationIdInput;
};


/** List of post Query operations */
export type QueryIdeasCountByTagArgs = {
  input: IdeasCountByTagInput;
};


/** List of post Query operations */
export type QueryIdeasCountByTagsArgs = {
  input: OrganizationIdInput;
};


/** List of post Query operations */
export type QueryIdeasV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: IdeasListInputV2;
};


/** List of post Query operations */
export type QueryImagesTrackDownloadArgs = {
  trackUrl?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryInvoicesByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryIsNewRemindersEnabledForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryIsSplitEnabledForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryOrganizationReferralCodeArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryOrganizationsArgs = {
  input: OrganizationsInput;
};


/** List of post Query operations */
export type QueryPlanMigrationSummaryViaHubArgs = {
  interval?: InputMaybe<BillingInterval>;
  organizationId: Scalars['String']['input'];
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Query operations */
export type QueryPostArgs = {
  input: PostInput;
};


/** List of post Query operations */
export type QueryPostCountsArgs = {
  input: PostCountsInput;
};


/** List of post Query operations */
export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PostsInput;
};


/** List of post Query operations */
export type QueryPostsLegacyArgs = {
  input: PostsLegacyInput;
};


/** List of post Query operations */
export type QueryPreviewCustomUpcomingInvoiceArgs = {
  interval?: InputMaybe<BillingInterval>;
  organizationId: Scalars['String']['input'];
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Query operations */
export type QueryPreviewPlanMigrationArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryPusherAuthenticationArgs = {
  input: PusherAuthenticationInput;
};


/** List of post Query operations */
export type QueryRecoveryCodeArgs = {
  input: TwoFactorRecoveryCodeInput;
};


/** List of post Query operations */
export type QueryS3PreSignedUrlArgs = {
  input: S3PreSignedUrlInput;
};


/** List of post Query operations */
export type QueryS3SignatureArgs = {
  input: S3SignatureInput;
};


/** List of post Query operations */
export type QueryS3SignedUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryS3UploadPreSignedUrlArgs = {
  input: S3UploadPreSignedUrlInput;
};


/** List of post Query operations */
export type QuerySavedRepliesArgs = {
  input: SavedRepliesInput;
};


/** List of post Query operations */
export type QuerySchedulesArgs = {
  input: SchedulesInput;
};


/** List of post Query operations */
export type QuerySearchImagesArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QuerySearchThreadsLocationsArgs = {
  input: SearchThreadsLocationsInput;
};


/** List of post Query operations */
export type QueryServiceMentionsArgs = {
  input: ServiceMentionsInput;
};


/** List of post Query operations */
export type QueryShopGridCustomLinksArgs = {
  input: ShopGridCustomLinksInput;
};


/** List of post Query operations */
export type QueryStartPageArgs = {
  organizationId: Scalars['String']['input'];
  pageId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryStartPageBlockArgs = {
  blockId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryStartPageV2Args = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryStartPagesArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryTagsArgs = {
  input: TagsInput;
};


/** List of post Query operations */
export type QueryTestAdminRestrictedQueryArgs = {
  email: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryUploadArgs = {
  input: UploadIdInput;
};


/** List of post Query operations */
export type QueryWeeklyPostingStreakArgs = {
  input: WeeklyPostingStreakInput;
};

/** Create an RSS/Atom Feed by url */
export type RssAtomFeedCreationInput = {
  /** The url of the RSS/Atom feed */
  url: Scalars['String']['input'];
};

/** Connection metadata for RSS feeds */
export type RssFeedConnectionMetadata = {
  __typename?: 'RSSFeedConnectionMetadata';
  /** The last time we connected to the RSS feed */
  lastConnected: Scalars['DateTime']['output'];
  /** The URL of the RSS feed */
  url: Scalars['String']['output'];
};

/** Input for refreshing a single feed collection. */
export type RefreshFeedCollectionInput = {
  /** The ID of the feed collection to refresh. */
  feedCollectionId: Scalars['FeedCollectionId']['input'];
  /** The organization that the feed collection belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the refreshFeedCollection mutation. */
export type RefreshFeedCollectionPayload = FeedCollectionActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for refreshing a single feed. */
export type RefreshFeedInput = {
  /** The ID of the feed to refresh. */
  feedId: Scalars['FeedId']['input'];
  /** The organization that the feed belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the refreshFeed mutation. */
export type RefreshFeedPayload = FeedActionSuccess | FeedConnectionError | NotFoundError | UnauthorizedError | UnexpectedError;

export type Refund = {
  __typename?: 'Refund';
  id: Scalars['ID']['output'];
  status: RefundStatus;
};

export enum RefundStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

/** Reject approval request. */
export type RejectPostInput = {
  /** Post id to reject approval request. */
  id: Scalars['PostId']['input'];
};

/** Reject approval request response payload. */
export type RejectPostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the removeAccount mutation */
export type RemoveAccountInput = {
  /** The password to be used to authorize deleting account */
  password?: InputMaybe<Scalars['String']['input']>;
  /** reason for the account to be deleted */
  reason?: InputMaybe<AccountDeletedReason>;
};

/** removeAccount response payload */
export type RemoveAccountPayload = InvalidInputError | NotFoundError | RemoveAccountSuccess | UnauthorizedError | UnexpectedError;

/** success response for removeAccount mutation */
export type RemoveAccountSuccess = MutationSuccess & {
  __typename?: 'RemoveAccountSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for removeLegacyGlobalFeatureFlip mutation. */
export type RemoveLegacyGlobalFeatureFlipInput = {
  /** Account id to remove feature flip from. */
  accountId: Scalars['AccountId']['input'];
  /** Feature flip to remove. */
  featureFlip: Scalars['String']['input'];
};

/** removeLegacyGlobalFeatureFlip response payload. */
export type RemoveLegacyGlobalFeatureFlipPayload = InvalidInputError | NotFoundError | RemoveLegacyGlobalFeatureFlipSuccess | UnexpectedError;

/** removeLegacyGlobalFeatureFlip success response. */
export type RemoveLegacyGlobalFeatureFlipSuccess = MutationSuccess & {
  __typename?: 'RemoveLegacyGlobalFeatureFlipSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Remove post's scheduled time request input. */
export type RemovePostScheduledTimeInput = {
  /** ID of post to update */
  id: Scalars['PostId']['input'];
};

/** Remove post's scheduled time response payload. */
export type RemovePostScheduledTimePayload = PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

export type RemoveSubscriptionScheduleError = MutationError & {
  __typename?: 'RemoveSubscriptionScheduleError';
  message: Scalars['String']['output'];
};

export type RemoveSubscriptionSchedulePayload = RemoveSubscriptionScheduleError | RemoveSubscriptionScheduleResponse;

export type RemoveSubscriptionScheduleResponse = {
  __typename?: 'RemoveSubscriptionScheduleResponse';
  success: Scalars['Boolean']['output'];
};

/** The input for the ReorderPosts mutation. */
export type ReorderPostsInput = {
  /** Channel ID for the posts to reorder. */
  channelId: Scalars['ChannelId']['input'];
  /** Ordered collection of Post IDs. */
  ids: Array<Scalars['PostId']['input']>;
};

/** ReorderPosts response payload */
export type ReorderPostsPayload = NotFoundError | ReorderPostsSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** The ReorderPosts success response. */
export type ReorderPostsSuccess = {
  __typename?: 'ReorderPostsSuccess';
  /** Ordered collection of Post IDs. */
  ids: Array<Scalars['PostId']['output']>;
};

export type Reply = {
  __typename?: 'Reply';
  attachment?: Maybe<Attachment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Error>;
  from?: Maybe<From>;
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  needsAttention?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AllowedCommentsStatuses>;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * Input type for the `replyComment` mutation.
 * Defines the comment being replied to and the reply content.
 */
export type ReplyToCommentInput = {
  /** Id of the comment being replied to. */
  commentId: Scalars['CommentId']['input'];
  /** The content of the reply, currently only text is supported. */
  reply: ReplyToContent;
};

/** Mutation Reply To Comment Response: Success and errors */
export type ReplyToCommentPayload = InvalidInputError | NotFoundError | ReplyToCommentSuccess | UnauthorizedError | UnexpectedError;

/** Successful reply response to reply to comment */
export type ReplyToCommentSuccess = {
  __typename?: 'ReplyToCommentSuccess';
  /** The reply comment that was successfully sent to the service. */
  comment: CommentData;
};

/** The content of a reply. */
export type ReplyToContent = {
  /** The text content of the reply. */
  text: Scalars['String']['input'];
};

/** Request post approval mutation. */
export type RequestPostApprovalInput = {
  /** Post id to request approval. */
  id: Scalars['PostId']['input'];
};

/** Request post approval possible responses. */
export type RequestPostApprovalPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Basic mutation response */
export type Response = {
  __typename?: 'Response';
  success: Scalars['Boolean']['output'];
};

/** Error proxied from the REST API response */
export type RestProxyError = MutationError & {
  __typename?: 'RestProxyError';
  /** Error code from the REST API response - https://buffer.com/developers/api/errors */
  code?: Maybe<Scalars['Int']['output']>;
  /** Link to our Help center from the REST API response */
  link?: Maybe<Scalars['String']['output']>;
  /** An error message from the REST API response that we proxied here */
  message: Scalars['String']['output'];
};

/** Information about the initial Tweet that was retweeted */
export type RetweetMetadata = ScrapedLink & {
  __typename?: 'RetweetMetadata';
  /** Date when the original tweet was created */
  createdAt: Scalars['DateTime']['output'];
  /** Retweet ID */
  id: Scalars['String']['output'];
  /** Text of the original tweet */
  text: Scalars['String']['output'];
  /** Thumbnails to media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** Link to original tweet */
  url: Scalars['String']['output'];
  /** User who created the original tweet */
  user: RetweetUserMetadata;
};

/** Information about the initial Tweet that was retweeted */
export type RetweetMetadataInput = {
  /** Retweet ID */
  id: Scalars['String']['input'];
};

/** Information about the initial author of the Tweet that was retweeted */
export type RetweetUserMetadata = {
  __typename?: 'RetweetUserMetadata';
  /** Avatar of the user who created the original Tweet */
  avatar: Scalars['String']['output'];
  /** Name of the user who created the original Tweet */
  name: Scalars['String']['output'];
  /** Username of the user who created the original Tweet */
  username: Scalars['String']['output'];
};

/** Revert approval request mutation. */
export type RevertPostApprovalRequestInput = {
  /** Post id to revert approval request. */
  id: Scalars['PostId']['input'];
};

/** Revert approval request possible responses. */
export type RevertPostApprovalRequestPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the revokeAccessConnectedApp mutation */
export type RevokeAccessConnectedAppInput = {
  /** The id of the connectedApp to revoke access for. */
  clientId: Scalars['ID']['input'];
};

/** The payload for the revokeAccessConnectedApp mutation */
export type RevokeAccessConnectedAppPayload = EmptySuccess | UnexpectedError;

export enum Role {
  Admin = 'admin',
  Member = 'member'
}

/** The result of the s3PreSignedURL query */
export type S3PreSigneUrlResult = {
  __typename?: 'S3PreSigneURLResult';
  /** The URL of the asset to use after it's uploaded to S3 */
  assetUrl: Scalars['String']['output'];
  /** The bucked where the file was saved */
  bucket: Scalars['String']['output'];
  /** The name/path of the file within the bucket */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file to S3 */
  url: Scalars['String']['output'];
};

/** Input for the s3PreSignedURL query */
export type S3PreSignedUrlInput = {
  /** The full filename with the extension, e.g. puppy.png */
  fileName: Scalars['String']['input'];
  /** The mime type of the file, e.g. image/png */
  mimeType: Scalars['MimeType']['input'];
  /** The organization for which the pre-signed URL is being requested */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Whether the asset will be used in the composer or as an account/channel avatar.
   * In the backend, this will decide which S3 bucket to use.
   */
  uploadType: UploadType;
};

/** S3 signature response */
export type S3Signature = {
  __typename?: 'S3Signature';
  /** success_action_status - 201 when successful */
  actionStatus: Scalars['String']['output'];
  /** Signature algorithm */
  algorithm: Scalars['String']['output'];
  /** Base64 encoded policy */
  base64policy: Scalars['String']['output'];
  /** S3 bucket name - on prod environment it'll be the same as input, on dev it'll be suffixed with '-dev' */
  bucket: Scalars['String']['output'];
  /** AWS credentials */
  credentials: Scalars['String']['output'];
  /** Date of the signature */
  date: Scalars['String']['output'];
  /** Expiration date of the signature */
  expires: Scalars['String']['output'];
  /** AWS signature */
  signature: Scalars['String']['output'];
  /** AWS temporary security token */
  temporarySecurityToken: Scalars['String']['output'];
};

/** Input for the s3Signature query */
export type S3SignatureInput = {
  /** S3 bucket name */
  bucket: Scalars['String']['input'];
};

/** The result of the s3UploadPreSignedURL query */
export type S3UploadPreSigneUrlResult = {
  __typename?: 'S3UploadPreSigneURLResult';
  /** The URL of the asset to use after it's uploaded to S3 */
  assetUrl: Scalars['String']['output'];
  /** The bucked where the file was saved */
  bucket: Scalars['String']['output'];
  /** The name/path of the file within the bucket */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file to S3 */
  url: Scalars['String']['output'];
};

/** Input for the s3UploadPreSignedURL query */
export type S3UploadPreSignedUrlInput = {
  /** The full filename with the extension, e.g. puppy.png */
  fileName: Scalars['String']['input'];
  /** The mime type of the file, e.g. image/png */
  mimeType: Scalars['MimeType']['input'];
  /**
   * Whether the asset will be used in the composer or as an account/channel avatar.
   * In the backend, this will decide which S3 bucket to use.
   */
  uploadType: UploadType;
};

/** Input for the saved replies query */
export type SavedRepliesInput = {
  /** The organization id to fetch saved replies for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the saved replies query */
export type SavedRepliesResponse = {
  __typename?: 'SavedRepliesResponse';
  /** List of saved replies */
  savedReplies: Array<SavedReply>;
};

/**
 * Saved reply: it contains a text used to reply to a comment easily.
 * The keyboard hotkeys is used to access quickly to the saved reply.
 */
export type SavedReply = {
  __typename?: 'SavedReply';
  /** The content of the saved reply. */
  content: SavedReplyContent;
  /** The date and time when the saved reply was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional hotkeys to reply with the saved reply, i.e. Ctrl+a. */
  hotkeys?: Maybe<Array<Scalars['String']['output']>>;
  /** The id for the saved reply. */
  id: Scalars['SavedReplyId']['output'];
  /** The organization that owns this saved reply. */
  organizationId: Scalars['OrganizationId']['output'];
  /** The title of the saved reply. */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time when the saved reply was created or updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Successful response for adding a saved reply. */
export type SavedReplyActionSuccess = {
  __typename?: 'SavedReplyActionSuccess';
  /** The saved reply that was successfully created. */
  savedReply: SavedReply;
};

/**
 * The content of a saved reply.
 * Currently, only text is supported.
 * We could add other types of content in the future.
 */
export type SavedReplyContent = {
  __typename?: 'SavedReplyContent';
  /** The text content of the saved reply. */
  text: Scalars['String']['output'];
};

/**
 * The content of a saved reply to be created or updated.
 * Currently, only text is supported.
 * We could add other types of content in the future.
 */
export type SavedReplyContentInput = {
  /** The text content of the saved reply. */
  text: Scalars['String']['input'];
};

/** Input type for creating a saved reply. */
export type SavedReplyToCreateInput = {
  /** The content of the saved reply. */
  content: SavedReplyContentInput;
  /** Optional hotkeys to reply with the saved reply, i.e. Ctrl+a. */
  hotkeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the saved reply. It could be null or empty. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input type for updating a saved reply.
 * All fields are optional. The user could update only the title or the content or the hotkeys.
 */
export type SavedReplyToUpdateInput = {
  /**
   * The content we want to update. It could be optional if we want to keep the same content
   * and update the title or the hotkeys.
   */
  content?: InputMaybe<SavedReplyContentInput>;
  /**
   * Optional hotkeys to reply with the saved reply, i.e. Ctrl+a.
   *   - Omit this field to leave the existing hotkeys unchanged.
   *   - Provide an empty array `[]` to clear all hotkeys.
   *   - Provide an array of strings to replace with new hotkeys.
   */
  hotkeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the saved reply. Uses title: null to remove the title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Schedule = {
  __typename?: 'Schedule';
  day: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  times: Array<Scalars['String']['output']>;
};

export enum ScheduleOption {
  FixedTime = 'FixedTime',
  Now = 'Now',
  Prioritize = 'Prioritize',
  Queue = 'Queue'
}

/** Schedule post's request input. */
export type SchedulePostInput = {
  /** New dueAt date */
  dueAt: Scalars['DateTime']['input'];
  /** ID of post to update */
  id: Scalars['PostId']['input'];
};

/** Schedule post's request response payload. */
export type SchedulePostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** The mode for updating the posting schedule: override, add, or none */
export enum ScheduleUpdateMode {
  Add = 'add',
  None = 'none',
  Override = 'override'
}

/** The posting schedule (slots) for a day of the week */
export type ScheduleV2 = {
  __typename?: 'ScheduleV2';
  /** The day of the week: mon, tue, wed, thu, fri, sat, sun */
  day: DayOfWeek;
  /** Indicates if this days is paused in the posting schedule. */
  paused: Scalars['Boolean']['output'];
  /** The times the channel is scheduled to post on the day: HH:MM */
  times: Array<Scalars['String']['output']>;
};

/** Posting Schedule input */
export type ScheduleV2Input = {
  /** The day of the week: mon, tue, wed, thu, fri, sat, sun */
  day: DayOfWeek;
  /** Indicates if this days is paused in the posting schedule. */
  paused: Scalars['Boolean']['input'];
  /** The times the channel is scheduled to post on the day: HH:MM */
  times: Array<Scalars['String']['input']>;
};

export type ScheduledSubscriptionUpdate = {
  __typename?: 'ScheduledSubscriptionUpdate';
  effectiveDate: Scalars['DateTime']['output'];
  newInterval: BillingInterval;
  newPlan: Scalars['String']['output'];
  newQuantity: Scalars['Int']['output'];
};

export type SchedulesError = {
  __typename?: 'SchedulesError';
  cause: Scalars['String']['output'];
};

export type SchedulesInput = {
  channelId: Scalars['String']['input'];
};

export type SchedulesPayload = SchedulesError | SchedulesResponse;

export type SchedulesResponse = {
  __typename?: 'SchedulesResponse';
  schedule: PostingSchedule;
};

/** Indicates whether the post was scheduled for notification publishing or automatic publishing */
export enum SchedulingType {
  /** The post was created natively on the social network using automatic publishing */
  Automatic = 'automatic',
  /** The post was created natively on the social network using notification publishing */
  Notification = 'notification'
}

/** Link data for link preview */
export type ScrapedLink = {
  /** Description for the scraped link */
  text: Scalars['String']['output'];
  /** Thumbnails of media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** URL that the link asset has been built from */
  url: Scalars['String']['output'];
};

/** Input for searching Threads locations */
export type SearchThreadsLocationsInput = {
  /** Channel IDs for the Threads channels to search locations for */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** Search query for locations (minimum 2 characters required) */
  query: Scalars['String']['input'];
};

/** Payload returned when searching for Threads locations */
export type SearchThreadsLocationsPayload = ChannelRefreshRequired | SearchThreadsLocationsResponse | TooShortQueryStringError;

/** Success response for searching Threads locations */
export type SearchThreadsLocationsResponse = {
  __typename?: 'SearchThreadsLocationsResponse';
  /** List of locations matching the search query */
  locations: Array<ThreadsLocation>;
};

/** success response for sendTestNotification mutation */
export type SendTestNotificationError = {
  __typename?: 'SendTestNotificationError';
  /** Error code if the notification was not sent successfully. */
  code: Scalars['Int']['output'];
  /** Error message if the notification was not sent successfully. */
  message: Scalars['String']['output'];
};

/** SendTestNotification response payload. */
export type SendTestNotificationPayload = SendTestNotificationError | SendTestNotificationSuccess;

/** error response for sendTestNotification mutation */
export type SendTestNotificationSuccess = {
  __typename?: 'SendTestNotificationSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Represents sentiment analysis results for a comment. */
export type SentimentAnalysis = {
  __typename?: 'SentimentAnalysis';
  /** The sentiment score indicating intensity. */
  score: Scalars['Int']['output'];
  /** The type of sentiment detected (e.g., positive, negative, neutral). */
  type: CommentLabel;
};

/** The list of services that can be authorized. */
export enum Service {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  Googlebusiness = 'googlebusiness',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Mastodon = 'mastodon',
  Pinterest = 'pinterest',
  StartPage = 'startPage',
  Threads = 'threads',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Youtube = 'youtube'
}

/** Indicates the type of subscription the user has on Twitter - Deprecated in favor of TwitterMetadata */
export type ServiceData = {
  __typename?: 'ServiceData';
  /** The type of subscription the user has on Twitter */
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

/** Represents a tag associated with a specific service. */
export type ServiceMention = {
  __typename?: 'ServiceMention';
  /** The user-friendly name of the tag, to displayed in the UI. */
  displayName: Scalars['String']['output'];
  /** The entity that the tag represents within the given service. */
  entity: Scalars['String']['output'];
  /** The unique identifier of the service tag. */
  id: Scalars['String']['output'];
  /** Image representing the tag, used for display purposes. */
  image?: Maybe<Scalars['URL']['output']>;
  /** A link or URL associated with the tag. */
  link: Scalars['URL']['output'];
  /** A URL-friendly version of the tag's name. */
  vanityName: Scalars['String']['output'];
};

/** Input type for the `serviceTags` query. */
export type ServiceMentionsInput = {
  /** The unique identifier of the account querying for tags. */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The search query string used to query for tags. */
  query: Scalars['String']['input'];
};

/** The current status of the connectable service */
export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  /**
   * Details to be used when allowing users to upvote service functionality.
   * If `label: none`, details will be null
   */
  details?: Maybe<UpvoteDetails>;
  /** The label used to reflect the current status of a service */
  label: StatusLabel;
};

/** input for setPasswordForAccount mutation */
export type SetPasswordForAccountInput = {
  /** Account id to set password. */
  accountId: Scalars['AccountId']['input'];
  /** New password to set. */
  newPassword: Scalars['String']['input'];
};

/** setPasswordForAccount response payload. */
export type SetPasswordForAccountPayload = InvalidInputError | NotFoundError | SetPasswordSuccess | UnexpectedError;

/** success response for setPasswordForAccount mutation */
export type SetPasswordSuccess = MutationSuccess & {
  __typename?: 'SetPasswordSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for setting up posting schedules for a Channel */
export type SetPostingScheduleForChannelInput = {
  /** The channel id to update the posting schedule */
  channelId: Scalars['ChannelId']['input'];
  /** The posting schedule to update for a Channel */
  postingSchedule: Array<InputMaybe<ScheduleV2Input>>;
};

/** The payload of the response from setPostingScheduleForChannel */
export type SetPostingScheduleForChannelPayload = InvalidInputError | NotFoundError | SetPostingScheduleForChannelResponse | UnauthorizedError | UnexpectedError;

/** The response for setting up posting schedules for a Channel */
export type SetPostingScheduleForChannelResponse = {
  __typename?: 'SetPostingScheduleForChannelResponse';
  /** The posting schedules updated from the Channel */
  postingSchedule: Array<Maybe<ScheduleV2>>;
};

/** Settings */
export type Settings = {
  __typename?: 'Settings';
  aiSettings?: Maybe<AiSettings>;
};

export type SettingsInput = {
  aiSettings?: InputMaybe<AiSettingsInput>;
};

/** How the post is being scheduled. */
export enum ShareMode {
  AddToQueue = 'addToQueue',
  ShareNext = 'shareNext',
  ShareNow = 'shareNow'
}

/**
 * ShopGrid Custom Links
 * This query retrieves the custom links for the shop grid.
 * The response includes the color, contrast color, and a list of custom links.
 * The input requires the channel ID to fetch the specific links for that channel.
 */
export type ShopGridCustomLinksInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
};

/** Mutation Payload for custom links: Success and errors */
export type ShopGridCustomLinksMutationPayload = NotFoundError | ShopGridCustomLinksPayload | UnauthorizedError | UnexpectedError;

/** Response payload for Shop Grid Custom Link */
export type ShopGridCustomLinksPayload = {
  __typename?: 'ShopGridCustomLinksPayload';
  /** Color for links */
  color?: Maybe<Scalars['HexColorCode']['output']>;
  /** Contrast color for links */
  contrastColor?: Maybe<Scalars['HexColorCode']['output']>;
  /** List of links */
  links?: Maybe<Array<CustomLink>>;
};

/** Direction to sort the results by. */
export enum SortDirection {
  /** Sort records in ascending order. */
  Asc = 'asc',
  /** Sort records in descending order. */
  Desc = 'desc'
}

export type SplitEnabledResponse = {
  __typename?: 'SplitEnabledResponse';
  isEnabled: Scalars['Boolean']['output'];
};

export type StartImpersonationInput = {
  bufferTeammateAccountId: Scalars['String']['input'];
  impersonatedCustomerAccountId: Scalars['String']['input'];
};

/** The start of week preference for the account. */
export enum StartOfWeek {
  /** The start of week is Monday. */
  Monday = 'monday',
  /** The start of week is Sunday. */
  Sunday = 'sunday'
}

export type StartPage = {
  __typename?: 'StartPage';
  blocks?: Maybe<Array<Maybe<StartPageBlock>>>;
  domain?: Maybe<Scalars['String']['output']>;
  hasUnPublishedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  migrationAsAChannel?: Maybe<StartPageMigrationAsAChannel>;
  organizationId: Scalars['ID']['output'];
  statistics?: Maybe<StartPageStats>;
  theme?: Maybe<StartPageThemeSaved>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Output Types */
export type StartPageBlock = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockButtonLink = StartPageBlock & {
  __typename?: 'StartPageBlockButtonLink';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Button link specific data */
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockFeed = StartPageBlock & {
  __typename?: 'StartPageBlockFeed';
  /** Feed specific data */
  children?: Maybe<Array<Maybe<StartPageBlockFeedPost>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type StartPageBlockFeedChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageBlockFeedPost = StartPageBlock & {
  __typename?: 'StartPageBlockFeedPost';
  /**
   * Feed Post specific data
   * @deprecated deprecated, will be removed
   */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockHeader = StartPageBlock & {
  __typename?: 'StartPageBlockHeader';
  backgroundMedia?: Maybe<StartPageMedia>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  logoMedia?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  overlay?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** Header specific data */
  title?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockIconLinks = StartPageBlock & {
  __typename?: 'StartPageBlockIconLinks';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Icon links specific data */
  links?: Maybe<Array<Maybe<StartPageIconLink>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockImageLink = StartPageBlock & {
  __typename?: 'StartPageBlockImageLink';
  /** Image link specific data */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockImageLinksGrid = StartPageBlock & {
  __typename?: 'StartPageBlockImageLinksGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Links grid specific data */
  links?: Maybe<Array<Maybe<StartPageLinkGrid>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

/** deprecated(reason: "Use StartPageBlockImageLinksGrid.") */
export type StartPageBlockInstagramLinksGrid = StartPageBlock & {
  __typename?: 'StartPageBlockInstagramLinksGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Links grid specific data */
  links?: Maybe<Array<Maybe<StartPageLinkGrid>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockMailchimp = StartPageBlock & {
  __typename?: 'StartPageBlockMailchimp';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Mailchimp specific data */
  htmlText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockSpotify = StartPageBlock & {
  __typename?: 'StartPageBlockSpotify';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  /** Spotify specific data */
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockStyles = {
  __typename?: 'StartPageBlockStyles';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<StartPageBlockTypes>;
  border?: Maybe<Scalars['String']['output']>;
  corners?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
  secondaryFontFamily?: Maybe<Scalars['String']['output']>;
  secondaryTextColor?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<StartPageTextAlign>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockStylesInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  blockType?: InputMaybe<StartPageBlockTypes>;
  border?: InputMaybe<Scalars['String']['input']>;
  corners?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  secondaryFontFamily?: InputMaybe<Scalars['String']['input']>;
  secondaryTextColor?: InputMaybe<Scalars['String']['input']>;
  textAlign?: InputMaybe<StartPageTextAlign>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageBlockSubHeading = StartPageBlock & {
  __typename?: 'StartPageBlockSubHeading';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** SubHeading specific data */
  text?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockText = StartPageBlock & {
  __typename?: 'StartPageBlockText';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  htmlJson?: Maybe<Scalars['String']['output']>;
  htmlText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** Text specific data */
  text?: Maybe<Scalars['String']['output']>;
};

export enum StartPageBlockTypes {
  ButtonLink = 'BUTTON_LINK',
  Feed = 'FEED',
  FeedPost = 'FEED_POST',
  Header = 'HEADER',
  IconLinks = 'ICON_LINKS',
  ImageLink = 'IMAGE_LINK',
  ImageLinksGrid = 'IMAGE_LINKS_GRID',
  InstagramLinksGrid = 'INSTAGRAM_LINKS_GRID',
  Mailchimp = 'MAILCHIMP',
  Spotify = 'SPOTIFY',
  SubHeading = 'SUB_HEADING',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type StartPageBlockVideo = StartPageBlock & {
  __typename?: 'StartPageBlockVideo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Video specific data */
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

/** Input Types */
export type StartPageConfigInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  /** deprecated(reason: "Use `template`.") */
  preset?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<StartPageThemeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageData = {
  __typename?: 'StartPageData';
  link?: Maybe<Scalars['String']['output']>;
};

/** Output Types */
export type StartPageGlobalStyles = {
  __typename?: 'StartPageGlobalStyles';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type StartPageGlobalStylesInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageIconLink = {
  __typename?: 'StartPageIconLink';
  icon?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum StartPageIconType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Messenger = 'MESSENGER',
  Pinterest = 'PINTEREST',
  Twitter = 'TWITTER',
  Whatsapp = 'WHATSAPP'
}

export type StartPageLinkGrid = {
  __typename?: 'StartPageLinkGrid';
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageLinksClicks = {
  __typename?: 'StartPageLinksClicks';
  block?: Maybe<StartPageBlock>;
  clicks?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type StartPageMedia = {
  __typename?: 'StartPageMedia';
  altText?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageMigrationAsAChannel = {
  __typename?: 'StartPageMigrationAsAChannel';
  errorReason?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  wasAtLimit?: Maybe<Scalars['Boolean']['output']>;
  wasBilling?: Maybe<Scalars['String']['output']>;
  wasMobile?: Maybe<Scalars['Boolean']['output']>;
  wasPublished?: Maybe<Scalars['Boolean']['output']>;
  wasTrialist?: Maybe<Scalars['Boolean']['output']>;
};

export type StartPageMutationResponse = CommonError | StartPageMutationSuccess;

/** Query / Mutation responses */
export type StartPageMutationSuccess = MutationResponse & {
  __typename?: 'StartPageMutationSuccess';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  startPage?: Maybe<StartPage>;
  startPages?: Maybe<Array<Maybe<StartPage>>>;
  success: Scalars['Boolean']['output'];
};

/** Start Page post metadata */
export type StartPagePostMetadata = CommonPostMetadata & {
  __typename?: 'StartPagePostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Optional link in post */
  link?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Start Page post metadata */
export type StartPagePostMetadataInput = {
  /** Optional link in post */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageResponse = CommonError | StartPage;

export type StartPageStats = {
  __typename?: 'StartPageStats';
  allTimeViews?: Maybe<Scalars['Int']['output']>;
  dailyViews?: Maybe<Scalars['Int']['output']>;
  linksClicks?: Maybe<Array<Maybe<StartPageLinksClicks>>>;
  weeklyViews?: Maybe<Scalars['Int']['output']>;
};

export type StartPageTemplate = {
  __typename?: 'StartPageTemplate';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type StartPageTemplatesResponse = {
  __typename?: 'StartPageTemplatesResponse';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templates?: Maybe<Array<Maybe<StartPageTemplate>>>;
};

export enum StartPageTextAlign {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type StartPageTheme = {
  __typename?: 'StartPageTheme';
  blockStyles?: Maybe<Array<Maybe<StartPageBlockStyles>>>;
  globalStyles?: Maybe<StartPageGlobalStyles>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StartPageThemeInput = {
  blockStyles?: InputMaybe<Array<InputMaybe<StartPageBlockStylesInput>>>;
  globalStyles?: InputMaybe<StartPageGlobalStylesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageThemeSaved = {
  __typename?: 'StartPageThemeSaved';
  blockStyles?: Maybe<Array<Maybe<StartPageBlockStyles>>>;
  globalStyles?: Maybe<StartPageGlobalStyles>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StartPageThemesResponse = {
  __typename?: 'StartPageThemesResponse';
  themes?: Maybe<Array<Maybe<StartPageTheme>>>;
};

export type StartPages = {
  __typename?: 'StartPages';
  startPages?: Maybe<Array<Maybe<StartPage>>>;
};

export type StartPagesResponse = CommonError | StartPages;

/** The label used to reflect the current status of a service */
export enum StatusLabel {
  /** The service is not yet available but will be soon */
  ComingSoon = 'coming_soon',
  /** The service is new to our platform */
  New = 'new',
  /** The service has no status, typically it is available and has been for some time */
  None = 'none'
}

export type StopImpersonationInput = {
  bufferTeammateAccountId: Scalars['String']['input'];
};

/** Represents a streak of consecutive actions or achievements */
export type Streak = {
  __typename?: 'Streak';
  /** The number of consecutive periods the streak goal has been met. */
  count: Scalars['Int']['output'];
  /** The longest streak. This value takes into account the current streak. */
  longestCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of weeks ahead of the current streak
   * It currently returns either 0 or 1 because every period requires a DB call
   */
  periodsAhead?: Maybe<Scalars['Int']['output']>;
  /** Previous period streak count. If the current streak is the only one, it returns 0 */
  previousCount?: Maybe<Scalars['Int']['output']>;
  /** The current streak status */
  status: StreakStatus;
  /** The enum indicating which streak content to display on the client */
  userStreakState: UserStreakState;
};

/** Represents the current status of a user's streak */
export enum StreakStatus {
  /** There is a low chance the goal will be met in this period. */
  AtRisk = 'AtRisk',
  /** The goal for the period was hit */
  Hit = 'Hit',
  /** The streak has been reset (broken streak) */
  Missed = 'Missed',
  /** There is a good chance the goal will be met in this period. */
  OnTrack = 'OnTrack',
  /** Neutral value at the start of the period. This is the default value. */
  Started = 'Started'
}

/** Deprecated in favor of Billing type. */
export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  cycle?: Maybe<Scalars['String']['output']>;
  cycleEndDate?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<LegacyDiscount>;
  isActiveTrial?: Maybe<Scalars['Boolean']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  product?: Maybe<Scalars['String']['output']>;
  subscriptionCanceledDate?: Maybe<Scalars['Int']['output']>;
  subscriptionEndDate?: Maybe<Scalars['Int']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionIsCanceled?: Maybe<Scalars['Boolean']['output']>;
  subscriptionIsPaused?: Maybe<Scalars['Boolean']['output']>;
  trialEndDate?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Deprecated in favor of Billing type. */
export type Subscriptionv2 = {
  __typename?: 'Subscriptionv2';
  analyze: SubscriptionDetails;
  analyzeTrial: SubscriptionDetails;
  publish: SubscriptionDetails;
  publishTrial: SubscriptionDetails;
};

/** Represents a suggested response or action for a comment. */
export type Suggestion = {
  __typename?: 'Suggestion';
  /** The source of the suggestion (e.g., AI, predefined template). */
  source: CommentSuggestionSource;
  /** The suggested text to respond with. */
  text: Scalars['String']['output'];
};

/** Represents whether a client is currently supported by the API */
export enum SupportStatus {
  NotSupported = 'notSupported',
  Supported = 'supported'
}

/** Swap post's request input. */
export type SwapPostsInQueueInput = {
  /** ID of the source post, i.e., the post that was dragged */
  sourceId: Scalars['PostId']['input'];
  /** ID of the target post, i.e., the post the source post was dropped on */
  targetId: Scalars['PostId']['input'];
};

/** Swap post's request response payload. */
export type SwapPostsInQueuePayload = NotFoundError | RestProxyError | SwapPostsInQueueSuccess | UnauthorizedError | UnexpectedError;

/** Swap post's request success response. */
export type SwapPostsInQueueSuccess = {
  __typename?: 'SwapPostsInQueueSuccess';
  /** Return the swapped posts - Order is not relevant. */
  posts: Array<Post>;
};

/** Input for the mutation to swap shop grid custom links */
export type SwapShopGridCustomLinksInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The source ID of the custom link to be swapped */
  sourceId: Scalars['ShopGridLinkId']['input'];
  /** The target ID of the custom link to be swapped */
  targetId: Scalars['ShopGridLinkId']['input'];
};

/** TFA information */
export type Tfa = {
  __typename?: 'TFA';
  /** The method of Two Factor Authentication */
  type: TwoFactorMethod;
};

/** Tag entity */
export type Tag = {
  __typename?: 'Tag';
  /** Hex color for tag e.g '#F523F1' */
  color: Scalars['String']['output'];
  /** ObjectId of the tag */
  id: Scalars['TagId']['output'];
  /**
   * Locked tag cannot be assigned to new items in the UI.
   * A Tag is locked after a customer downgrades and has more tags than the free plan limit allows
   */
  isLocked: Scalars['Boolean']['output'];
  /** Name of the tag e.g 'Summer sales' */
  name: Scalars['String']['output'];
};

export type TagActionInIdeasPayload = CoreWebAppCommonError | TagActionInIdeasSuccess;

export type TagActionInIdeasSuccess = CoreWebAppMutationResponse & {
  __typename?: 'TagActionInIdeasSuccess';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Success response returns the full up-to-date tag from after the action was performed. */
export type TagActionSuccess = {
  __typename?: 'TagActionSuccess';
  /** Tag on which the action was successfully performed. */
  tag: Tag;
};

export type TagInput = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type TagRemovalFromIdeaInput = {
  ideaId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type TagRemovalFromIdeasInput = {
  organizationId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** Input to pass when creating a Tag. */
export type TagToCreateInput = {
  /** Hex color for tag e.g '#F523F1' */
  color: Scalars['String']['input'];
  /** Name of the tag e.g 'Summer sales' */
  name: Scalars['String']['input'];
};

/** Input to pass when updating a Tag. */
export type TagToUpdateInput = {
  /** Hex color for tag e.g '#F523F1' */
  color: Scalars['String']['input'];
  /** Name of the tag e.g 'Summer sales' */
  name: Scalars['String']['input'];
};

/** Filter to pass when fetching tags. */
export type TagsFiltersInput = {
  /** if not defined, it returns all tags - if true, it only returns locked tags - if false, it only returns not locked tags */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input to pass when fetching tags. */
export type TagsInput = {
  /** A list of option filters */
  filter?: InputMaybe<TagsFiltersInput>;
  /** The Organization id to fetch tags for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type TaxDetails = {
  __typename?: 'TaxDetails';
  automaticTax?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<TaxLocation>;
};

export type TaxId = {
  __typename?: 'TaxId';
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  verification?: Maybe<TaxIdVerification>;
};

export type TaxIdVerification = {
  __typename?: 'TaxIdVerification';
  status?: Maybe<Scalars['String']['output']>;
  verifiedAddress?: Maybe<Scalars['String']['output']>;
  verifiedName?: Maybe<Scalars['String']['output']>;
};

export type TaxLocation = {
  __typename?: 'TaxLocation';
  country?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type TestIdeasInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};

export type TextGenerated = {
  __typename?: 'TextGenerated';
  suggestions: Array<Maybe<TextSuggestionGenerated>>;
};

/** Query / Mutation responses */
export type TextGenerationResponse = CommonError | TextGenerated;

/** Output Types */
export type TextSuggestionGenerated = {
  __typename?: 'TextSuggestionGenerated';
  content: Scalars['String']['output'];
};

/**
 * A post authored by the user which is posted to a thread.
 * This is commonly used for long-format twitter and meta threads posts to
 * allow authored content to span multiple threads.
 * Threads are represented as a list of replies, each replying to the previous one.
 */
export type ThreadedPost = {
  __typename?: 'ThreadedPost';
  /** Media assets of the threaded post */
  assets: Array<Asset>;
  /** The text body content of the threaded post */
  text: Scalars['String']['output'];
};

/**
 * A post authored by the user which is posted to a thread.
 * This is commonly used for long-format twitter and meta threads posts to
 * allow authored content to span multiple threads.
 * Threads are represented as a list of replies, each replying to the previous one.
 */
export type ThreadedPostInput = {
  /** Media assets of the threaded post */
  assets?: InputMaybe<AssetsInput>;
  /** The text body content of the threaded post */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Common properties for all posts that support threaded replies.
 * See ThreadedPost for more details.
 */
export type ThreadedPostMetadata = {
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
};

export type ThreadsData = {
  __typename?: 'ThreadsData';
  location_id?: Maybe<Scalars['String']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** Represents a location that can be tagged in Threads posts */
export type ThreadsLocation = {
  __typename?: 'ThreadsLocation';
  /** Street address of the location (optional) */
  address?: Maybe<Scalars['String']['output']>;
  /** City where the location is situated (optional) */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the location is situated (optional) */
  country?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the location */
  id: Scalars['String']['output'];
  /** Latitude coordinate of the location (optional) */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude coordinate of the location (optional) */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Display name of the location */
  name: Scalars['String']['output'];
  /** Postal code of the location (optional) */
  postalCode?: Maybe<Scalars['String']['output']>;
};

/** Threads post metadata */
export type ThreadsPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'ThreadsPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** LocationId associated with the post */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Location name associated with the post */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** Topic associated with the post */
  topic?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Threads post metadata */
export type ThreadsPostMetadataInput = {
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** LocationId associated with the post */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** Location name associated with the post */
  locationName?: InputMaybe<Scalars['String']['input']>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
  /** Topic associated with the post */
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** Tiktok post metadata */
export type TiktokPostMetadata = CommonPostMetadata & {
  __typename?: 'TiktokPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** The time format preference for the account. */
export enum TimeFormat {
  /** The time format in 12-hour format. */
  TwelveHour = 'twelveHour',
  /** The time format in 24-hour format. */
  TwentyFourHour = 'twentyFourHour'
}

export type TokenUsageInput = {
  featureAction: FeatureAction;
  usedTokens?: InputMaybe<Scalars['Int']['input']>;
};

/** Error returned when the input query string is too short */
export type TooShortQueryStringError = MutationError & {
  __typename?: 'TooShortQueryStringError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Response type for track an action in a survey or saved a completed survey */
export type TrackActionOnboardingSurveySuccess = {
  __typename?: 'TrackActionOnboardingSurveySuccess';
  actionsTaken: Array<OnboardingSurveyActionTaken>;
  /** onboarding survey saved in the DB */
  surveyId: Scalars['String']['output'];
};

export type TrackExternalServiceUsageResponse = Error | Response;

/** Error type for specific transfer-related issues. */
export type TransferError = MutationError & {
  __typename?: 'TransferError';
  /**
   * A human-readable message explaining why the transfer cannot happen.
   * E.g., the new owner is not an Admin, they have channels, or are not on the
   * Free plan
   */
  message: Scalars['String']['output'];
};

/** Input for transferOrganizationOwnership mutation */
export type TransferOrganizationOwnershipInput = {
  /** The ID of the account that will become the new owner. */
  newOwner: Scalars['AccountId']['input'];
  /** The ID of the organization for which ownership is being transferred. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors for transferOrganizationOwnership */
export type TransferOrganizationOwnershipPayload = EmptySuccess | TransferError;

export type Trial = {
  __typename?: 'Trial';
  endDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Returns whether an admin need to take an action: it happens when the trial expires, we present the admin with a modal to decide if they want to start paying for Buffer */
  isAwaitingUserAction: Scalars['Boolean']['output'];
  remainingDays: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

/** Twitter metadata */
export type TwitterMetadata = {
  __typename?: 'TwitterMetadata';
  /** Indicates the type of subscription the user has on Twitter */
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

/** Twitter post metadata */
export type TwitterPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'TwitterPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The details of the tweet being retweeted */
  retweet?: Maybe<RetweetMetadata>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Twitter post metadata */
export type TwitterPostMetadataInput = {
  /** The details of the tweet being retweeted */
  retweet?: InputMaybe<RetweetMetadataInput>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

/** Input for confirming Two Factor Authentication */
export type TwoFactorConfirmInput = {
  /** Confirmation Code */
  code: Scalars['String']['input'];
  /** The Account with the Two Factor Authentication set up */
  key: Scalars['String']['input'];
  /** Method type */
  method: TwoFactorMethod;
};

/** The payload of the response from TwoFactorConfirm */
export type TwoFactorConfirmPayload = InvalidInputError | TwoFactorConfirmResponse | UnexpectedError;

/** The response for confirming Two Factor Authentication */
export type TwoFactorConfirmResponse = {
  __typename?: 'TwoFactorConfirmResponse';
  /** Recovery code */
  recoveryCode: Scalars['String']['output'];
};

/**
 * Input for disabling Two Factor Authentication with Account ID
 * This is used for Buffer Admin to disable Two Factor Authentication for an account
 */
export type TwoFactorDisableByAccountIdInput = {
  /** The Account ID */
  accountId: Scalars['AccountId']['input'];
};

/** The payload of the response from TwoFactorDisable */
export type TwoFactorDisablePayload = EmptySuccess | UnexpectedError;

/** The type of Two Factor Authentication method */
export enum TwoFactorMethod {
  App = 'app',
  Email = 'email'
}

/** The input for showing the Two Factor recovery code */
export type TwoFactorRecoveryCodeInput = {
  /** The one time password code */
  code: Scalars['String']['input'];
};

/** The Payload for Two Factor Recovery Code */
export type TwoFactorRecoveryCodePayload = InvalidInputError | TwoFactorRecoveryCodeResponse | UnexpectedError;

/** The response for showing the Two Factor recovery code */
export type TwoFactorRecoveryCodeResponse = {
  __typename?: 'TwoFactorRecoveryCodeResponse';
  /** The recovery code */
  recoveryCode: Scalars['String']['output'];
};

/** The Payload for Two Factor Request One-Time Password */
export type TwoFactorRequestOneTimePasswordPayload = EmptySuccess | UnexpectedError;

/** Input for setting up Two Factor Authentication */
export type TwoFactorSetupInput = {
  /** Method type */
  method: TwoFactorMethod;
};

/** The payload of the response from TwoFactorSetup */
export type TwoFactorSetupPayload = InvalidInputError | TwoFactorSetupResponse | UnexpectedError;

/** The response for setting up Two Factor Authentication */
export type TwoFactorSetupResponse = {
  __typename?: 'TwoFactorSetupResponse';
  /** The Account with the Two Factor Authentication set up */
  key?: Maybe<Scalars['String']['output']>;
};

/** Error returned when the user is not authorized to perform the action */
export type UnauthorizedError = MutationError & {
  __typename?: 'UnauthorizedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Input type for the `undismissComment` mutation.
 * Defines the comment being undismissed.
 */
export type UndismissCommentInput = {
  /** ID of the comment being undismissed. */
  commentId: Scalars['CommentId']['input'];
};

/** Mutation Response: Success and errors */
export type UndismissCommentPayload = InvalidInputError | NotFoundError | UnauthorizedError | UndismissCommentSuccess | UnexpectedError;

/** Successful undismiss response. */
export type UndismissCommentSuccess = {
  __typename?: 'UndismissCommentSuccess';
  /** The comment that was successfully undismissed. */
  comment: CommentData;
};

/** Error returned when unexpected error occurs */
export type UnexpectedError = MutationError & {
  __typename?: 'UnexpectedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Error message returned when channel is a non-supported type */
export type UnsupportedChannelError = MutationError & {
  __typename?: 'UnsupportedChannelError';
  /** Error message returned when token is requested for unsupported channel */
  message: Scalars['String']['output'];
};

export type UnverifiedEmailAddressError = {
  __typename?: 'UnverifiedEmailAddressError';
  cause: Scalars['String']['output'];
};

export type UpcomingInvoiceCostsPreview = {
  __typename?: 'UpcomingInvoiceCostsPreview';
  chargeAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  isScheduledChange: Scalars['Boolean']['output'];
  nextBillingDate: Scalars['DateTime']['output'];
};

/** Input for the updateAccountAvatar mutation */
export type UpdateAccountAvatarInput = {
  /** new url for the account avatar */
  url: Scalars['String']['input'];
};

/** updateAccountAvatar response payload */
export type UpdateAccountAvatarPayload = InvalidInputError | NotFoundError | UnexpectedError | UpdateAccountAvatarSuccess;

/** success response for deleteAccount mutation */
export type UpdateAccountAvatarSuccess = MutationSuccess & {
  __typename?: 'UpdateAccountAvatarSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updateAccountName mutation */
export type UpdateAccountNameInput = {
  /** new name for the account */
  name: Scalars['String']['input'];
};

/** updateAccountName response payload */
export type UpdateAccountNamePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateAccountNameSuccess;

/** success response for updateName mutation */
export type UpdateAccountNameSuccess = MutationSuccess & {
  __typename?: 'UpdateAccountNameSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updatePreferences mutation */
export type UpdateAccountPreferencesInput = {
  /** default schedule option, if not provided, the default schedule option will not be updated */
  defaultScheduleOption?: InputMaybe<ScheduleOption>;
  /** start of week, if not provided, the start of week will not be updated */
  startOfWeek?: InputMaybe<StartOfWeek>;
  /** time format, if not provided, the time format will not be updated */
  timeFormat?: InputMaybe<TimeFormat>;
};

/** updatePreferences response payload */
export type UpdateAccountPreferencesPayload = InvalidInputError | UpdateAccountPreferencesSuccess;

/** success response for updatePreferences mutation */
export type UpdateAccountPreferencesSuccess = {
  __typename?: 'UpdateAccountPreferencesSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  preferences: Preferences;
};

/** Input for updateAccountTimezone mutation */
export type UpdateAccountTimezoneInput = {
  /** New timezone to set */
  timezone: Scalars['String']['input'];
};

/** updateAccountTimezone response payload */
export type UpdateAccountTimezonePayload = InvalidInputError | NotFoundError | UnexpectedError | UpdateAccountTimezoneSuccess;

/** success response for updateAccountTimezone mutation */
export type UpdateAccountTimezoneSuccess = {
  __typename?: 'UpdateAccountTimezoneSuccess';
  /** The id of the updated account */
  accountId: Scalars['AccountId']['output'];
  /** The updated timezone for the account */
  timezone: Scalars['String']['output'];
};

/** input for updateAdminComment mutation */
export type UpdateAdminCommentInput = {
  /** ID of the account that will have the comment applied */
  accountId: Scalars['AccountId']['input'];
  /** Text to be applied as a comment to the account */
  message: Scalars['String']['input'];
};

/** updateAdminComment response payload */
export type UpdateAdminCommentPayload = NotFoundError | UnauthorizedError | UnexpectedError | UpdateAdminCommentSuccess;

/** success response for updateAdminComment mutation */
export type UpdateAdminCommentSuccess = {
  __typename?: 'UpdateAdminCommentSuccess';
  /** Returns the updated admin comment */
  adminComment: Scalars['String']['output'];
};

/** Bluesky-specific metadata for custom channel update */
export type UpdateBlueskyMetadata = {
  /** Bluesky account App Password */
  appPassword?: InputMaybe<Scalars['String']['input']>;
  /** Bluesky account Handle (username) */
  handle?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updateChannelGroup mutation */
export type UpdateChannelGroupInput = {
  /** The channels to be added to the group */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The id of the channel group */
  id: Scalars['ChannelGroupId']['input'];
  /** The name of the channel group */
  name: Scalars['String']['input'];
};

/** Mutation Response: Success and errors */
export type UpdateChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Input for updating the posting goal for a Channel */
export type UpdateChannelPostingGoalInput = {
  /** The channel id to update the posting goal */
  channelId: Scalars['ChannelId']['input'];
  /** The posting goal */
  goal: Scalars['Int']['input'];
  /**
   * Indicates if the posting schedules should be overridden
   * @deprecated Use scheduleUpdateMode instead
   */
  overridePostingSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mode for updating the posting schedule: override, add, or none */
  scheduleUpdateMode?: InputMaybe<ScheduleUpdateMode>;
};

/** The payload of the response from updateChannelPostingGoal */
export type UpdateChannelPostingGoalPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateChannelPostingGoalResponse;

/** The response for updating the posting goal for a Channel */
export type UpdateChannelPostingGoalResponse = {
  __typename?: 'UpdateChannelPostingGoalResponse';
  /** The posting goal updated from the Channel */
  channel: Channel;
};

/** Input for updating custom channels, like Bluesky or FB Group */
export type UpdateCustomChannelInput = {
  /** Channel ID of updated channel */
  channelId: Scalars['ChannelId']['input'];
  /** Channel-specific metadata to use during creation */
  customChannelMetadata?: InputMaybe<UpdateCustomChannelMetadata>;
  /** Timezone to be used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Channel-specific metadata for custom channel update */
export type UpdateCustomChannelMetadata = {
  /** Bluesky-specific metadata */
  blueskyMetadata?: InputMaybe<UpdateBlueskyMetadata>;
  /** FB Group-specific metadata */
  facebookGroupMetadata?: InputMaybe<UpdateFacebookGroupMetadata>;
  /** IG Personal Profile-specific metadata */
  instagramPersonalProfileMetadata?: InputMaybe<UpdateInstagramPersonalProfileMetadata>;
};

/** Payload for updateCustomChannel mutation */
export type UpdateCustomChannelPayload = CustomChannelError | UpdateCustomChannelResponse;

/** The response for custom channel refresh */
export type UpdateCustomChannelResponse = {
  __typename?: 'UpdateCustomChannelResponse';
  /** Updated channel */
  channel: Channel;
};

/** Input to update custom links colors for a channel */
export type UpdateCustomLinksColorsInput = {
  /** The channel id to update the custom links colors */
  channelId: Scalars['ChannelId']['input'];
  /** The color for the custom links */
  color: Scalars['HexColorCode']['input'];
  /** The contrast color for the custom links */
  contrastColor: Scalars['HexColorCode']['input'];
};

/** The response for updating custom links colors for a Channel */
export type UpdateCustomLinksColorsPayload = EmptySuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Facebook Group-specific metadata for custom channel update */
export type UpdateFacebookGroupMetadata = {
  /** Avatar URL of this FB Group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this FB Group */
  name?: InputMaybe<Scalars['String']['input']>;
  /** URL to FB Group's page */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing failed post error. */
export type UpdateFailedPostErrorInput = {
  /** ID of the failed post error to update. */
  id: Scalars['ErrorMessageId']['input'];
  /** Updated link to further information. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Updated localized link text. */
  linkText?: InputMaybe<LocalizedTextInput>;
  /** Updated patterns for this error. */
  patterns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The position of the error message in the list of error messages. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The service that this error is associated with. */
  service?: InputMaybe<Service>;
  /** Updated localized text for the error message. */
  text?: InputMaybe<LocalizedTextInput>;
};

/** Union type representing either a successful update of a failed post error or an error */
export type UpdateFailedPostErrorPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateFailedPostErrorSuccess;

/** Payload for successfully updating a failed post error. */
export type UpdateFailedPostErrorSuccess = {
  __typename?: 'UpdateFailedPostErrorSuccess';
  /** The failed post error that was updated. */
  failedPostError: FailedPostError;
};

/** Input for updateFeedCollection mutation */
export type UpdateFeedCollectionInput = {
  /** Id of the feed collection to update */
  feedCollectionId: Scalars['FeedCollectionId']['input'];
  /**
   * Feeds to subscribe to in this feed, if not set, will not update
   * @deprecated(reason: "Use moveFeed mutation to manage feed associations")
   */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
  /** The name of the feed collection. If set, this will override the name of the feed. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization that the feed collection will belong to */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Input type for updating an idea group. */
export type UpdateIdeaGroupInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Union type representing possible payloads for updating an idea group. */
export type UpdateIdeaGroupPayload = IdeaGroup | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** updateIdea input type */
export type UpdateIdeaInput = {
  /** New content and metadata for the idea */
  content: IdeaContentInput;
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** New group ID (null for unassigned group) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the idea to update */
  id: Scalars['String']['input'];
};

/** updateIdea response (including errors) */
export type UpdateIdeaPayload = IdeaResponse | InvalidInputError | UnauthorizedError | UnexpectedError;

/** Instagram Personal Profile-specific metadata for custom channel update */
export type UpdateInstagramPersonalProfileMetadata = {
  /** Avatar URL for the channel */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this IG Profile */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating lastActivityAt for a channel */
export type UpdateLastActivityAtForChannelInput = {
  /** The channel id to update the lastActivityAt */
  channelId: Scalars['ChannelId']['input'];
};

/** UpdateChannelLastActivityAt possible responses */
export type UpdateLastActivityAtForChannelPayload = UnauthorizedError | UnexpectedError | UpdateLastActivityAtForChannelSuccess;

/** success response for updateLastActivityAtForChannel mutation */
export type UpdateLastActivityAtForChannelSuccess = MutationSuccess & {
  __typename?: 'UpdateLastActivityAtForChannelSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input type for updating a note on a post */
export type UpdateNoteOnPostInput = {
  /** The ID of the note */
  noteId: Scalars['NoteId']['input'];
  /** The ID of the post */
  postId: Scalars['PostId']['input'];
  /** The new text for the note */
  text: Scalars['String']['input'];
};

/** Union type representing the possible outcomes of the updateNoteOnPost mutation */
export type UpdateNoteOnPostPayload = InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateNoteOnPostSuccess;

/** Type returned on successful update of a note on a post */
export type UpdateNoteOnPostSuccess = {
  __typename?: 'UpdateNoteOnPostSuccess';
  /** The post with the updated note */
  post: Post;
};

/** Input for the updatePassword mutation */
export type UpdatePasswordInput = {
  /** New Password to update Account with */
  newPassword: Scalars['String']['input'];
  /** Current Password for Account to verify if we allow updating the password */
  password: Scalars['String']['input'];
};

/** updatePassword response payload */
export type UpdatePasswordPayload = EmptySuccess | InvalidInputError | UnauthorizedError | UnexpectedError;

export type UpdatePostDueAtInput = {
  postId: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

/** @deprecated: use the generic PostUpdatedPayload */
export type UpdatePostDueAtMutationResponse = CoreWebAppCommonError | PostNotFound | PostNotUpdated | PostUpdated;

/** Update post's tags request input. */
export type UpdatePostTagsInput = {
  /** Post id to update. */
  id: Scalars['PostId']['input'];
  /**
   * The entire list of tags to assign to the Post. This list will fully replace the existing one.
   * E.g., if a post has two tags and you call this mutation with a new tag, the Post will have only the new tag assigned and the two old tags will be removed.
   */
  tags: Array<Scalars['TagId']['input']>;
};

/** Update post's tags request response payload. */
export type UpdatePostTagsPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input type for updating a saved reply. */
export type UpdateSavedReplyInput = {
  /** Id of the saved reply to update. */
  id: Scalars['SavedReplyId']['input'];
  /** The new data for the saved reply. */
  savedReply: SavedReplyToUpdateInput;
};

/**
 * Response type for the updateSavedReply mutation.
 * It can return either success or an error.
 */
export type UpdateSavedReplyPayload = DuplicateError | InvalidInputError | NotFoundError | SavedReplyActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for the mutation to update a shop grid custom link */
export type UpdateShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The ID of the custom link to be updated */
  id: Scalars['ShopGridLinkId']['input'];
  /** Link text to be saved */
  text: Scalars['String']['input'];
  /** URL to be saved */
  url: Scalars['String']['input'];
};

/** Input for the mutation to update a shop grid post link */
export type UpdateShopGridPostLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Link to be saved */
  link?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post to be updated */
  postId: Scalars['PostId']['input'];
};

/** Mutation Payload for updating shop grid link: Success and errors */
export type UpdateShopGridPostLinkPayload = EmptySuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for the updateStartOfWeekPreference mutation */
export type UpdateStartOfWeekPreferenceInput = {
  /** preferences to update */
  startOfWeek: StartOfWeek;
};

/** updateStartOfWeekPreference response payload */
export type UpdateStartOfWeekPreferencePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateStartOfWeekPreferenceSuccess;

/** success response for updateStartOfWeekPreference mutation */
export type UpdateStartOfWeekPreferenceSuccess = MutationSuccess & {
  __typename?: 'UpdateStartOfWeekPreferenceSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type UpdateTagInIdeasInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** Input to pass when updating a Tag. */
export type UpdateTagInput = {
  /** The id of tag to update */
  id: Scalars['TagId']['input'];
  /** The new tag data to set */
  tag: TagToUpdateInput;
};

/** Update tag request response payload. */
export type UpdateTagPayload = DuplicateError | InvalidInputError | NotFoundError | RestProxyError | TagActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for the updateTimeFormatPreference mutation */
export type UpdateTimeFormatPreferenceInput = {
  /** preferences to update */
  timeFormat: TimeFormat;
};

/** updateTimeFormatPreference response payload */
export type UpdateTimeFormatPreferencePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateTimeFormatPreferenceSuccess;

/** success response for updateTimeFormatPreference mutation */
export type UpdateTimeFormatPreferenceSuccess = MutationSuccess & {
  __typename?: 'UpdateTimeFormatPreferenceSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for setting the timezone for a Channel */
export type UpdateTimezoneForChannelInput = {
  /** The channel id to update the timezone */
  channelId: Scalars['ChannelId']['input'];
  /** The timezone value (IANA timezone format) */
  timezone: Scalars['TimeZone']['input'];
};

/** The payload of the response from updateTimezoneForChannel */
export type UpdateTimezoneForChannelPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateTimezoneForChannelResponse;

/** The response for updating timezone for a Channel */
export type UpdateTimezoneForChannelResponse = {
  __typename?: 'UpdateTimezoneForChannelResponse';
  /** The timezone updated in the Channel */
  channel: Channel;
};

export type UploadDetails = {
  __typename?: 'UploadDetails';
  duration: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  transcodedLocation?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type UploadIdInput = {
  id: Scalars['String']['input'];
};

export type UploadPayload = CoreWebAppCommonError | UploadDetails;

/** The type of uploads we support. It will determine where we store the media in S3. */
export enum UploadType {
  AccountAvatar = 'accountAvatar',
  ChannelAvatar = 'channelAvatar',
  PostAsset = 'postAsset'
}

/** Details to be used when allowing users to upvote service functionality */
export type UpvoteDetails = {
  __typename?: 'UpvoteDetails';
  /**
   * The (optional) message to be displayed when the feature upvote has been tracked. Clients should fallback to a default
   * message if this is not provided.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** The ID to be used when tracking the upvote for the feature */
  upvoteId: Scalars['Int']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  id?: Maybe<Scalars['String']['output']>;
  showMarkAsReadWarningModal?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * An enum representing the streak status used to map client content.
 * The underlying logic is opaque and simply indicates the user-facing streak status.
 */
export enum UserStreakState {
  ChannelConnectionStreakCelebration = 'ChannelConnectionStreakCelebration',
  ExistingStreakAtRisk = 'ExistingStreakAtRisk',
  ExistingStreakHit = 'ExistingStreakHit',
  ExistingStreakHitAndAhead = 'ExistingStreakHitAndAhead',
  ExistingStreakOnTrack = 'ExistingStreakOnTrack',
  ExistingStreakOnTrackAndAhead = 'ExistingStreakOnTrackAndAhead',
  NewStreakHit = 'NewStreakHit',
  NewStreakHitAndAhead = 'NewStreakHitAndAhead',
  NewStreakNoProgress = 'NewStreakNoProgress',
  NewStreakOnTrack = 'NewStreakOnTrack',
  NewStreakOnTrackAndAhead = 'NewStreakOnTrackAndAhead',
  StreakLost = 'StreakLost'
}

/** User tag in the image */
export type UserTag = {
  __typename?: 'UserTag';
  /** The handle of the user */
  handle: Scalars['String']['output'];
  /** The x coordinate of the user tag */
  x: Scalars['Float']['output'];
  /** The y coordinate of the user tag */
  y: Scalars['Float']['output'];
};

/** User tag in the image */
export type UserTagInput = {
  /** The handle of the user */
  handle: Scalars['String']['input'];
  /** The x coordinate of the user tag */
  x: Scalars['Float']['input'];
  /** The y coordinate of the user tag */
  y: Scalars['Float']['input'];
};

/** Input for the verifyPassword mutation */
export type VerifyPasswordInput = {
  /** current password for the account to be verified */
  password: Scalars['String']['input'];
};

/** verifyPassword response payload */
export type VerifyPasswordPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | VerifyPasswordSuccess;

/** success response for verifypassword mutation */
export type VerifyPasswordSuccess = MutationSuccess & {
  __typename?: 'VerifyPasswordSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for verifyTfaCode mutation */
export type VerifyTfaCodeInput = {
  /** TFA code to verify. */
  tfaCode: Scalars['String']['input'];
};

/** verifyTfaCode response payload. */
export type VerifyTfaCodePayload = InvalidInputError | MutationBasicResponse | NotFoundError | UnexpectedError;

/** Video asset */
export type VideoAsset = Asset & {
  __typename?: 'VideoAsset';
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
  /** Video specific metadata */
  video: VideoMetadata;
};

/** Video asset */
export type VideoAssetInput = {
  /** Video specific metadata */
  metadata?: InputMaybe<VideoMetadataInput>;
  /** URL to the thumbnail of the video */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the file source */
  url: Scalars['String']['input'];
};

/** Video metadata */
export type VideoMetadata = {
  __typename?: 'VideoMetadata';
  /** Audio codec */
  audioCodec?: Maybe<Scalars['String']['output']>;
  /** Video container format */
  containerFormat?: Maybe<Scalars['String']['output']>;
  /** Video duration in seconds */
  durationMs: Scalars['Int']['output'];
  /** Video fileSize in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** Video framerate */
  frameRate?: Maybe<Scalars['Int']['output']>;
  /** Video height in pixels */
  height: Scalars['Int']['output'];
  /** Whether the video needs to be transcoded before it can be broadcasted */
  isTranscodingRequired: Scalars['Boolean']['output'];
  /** Rotation degree */
  rotationDegree?: Maybe<Scalars['Int']['output']>;
  /** Video bitrate in kbps */
  videoBitRate?: Maybe<Scalars['Int']['output']>;
  /** Video codec */
  videoCodec?: Maybe<Scalars['String']['output']>;
  /** Video width in pixels */
  width: Scalars['Int']['output'];
};

/** Video metadata */
export type VideoMetadataInput = {
  /** Offset of the thumbnail chosen for the video, in ms */
  thumbnailOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Video title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Error returned when video still processing error occurs */
export type VideoProcessingError = MutationError & {
  __typename?: 'VideoProcessingError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Error implementation that allows clients to resolve the MutationError on mutations that do not currently have typed errors.
 * This allows clients to automatically handle errors that may be added to a mutation in future.
 *
 * Do not directly throw this error, use a custom typed error instead
 */
export type VoidMutationError = MutationError & {
  __typename?: 'VoidMutationError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Weekly posting limit for a channel */
export type WeeklyPostingLimit = {
  __typename?: 'WeeklyPostingLimit';
  /** The weekly posting limit for the channel */
  limit: Scalars['Int']['output'];
  /** The number of posts the channel has scheduled for this week */
  scheduled: Scalars['Int']['output'];
  /** The number of posts the channel has sent this week */
  sent: Scalars['Int']['output'];
};

/** Input for the weekly posting streak query */
export type WeeklyPostingStreakInput = {
  /** The organization to get the weekly posting streak for */
  organizationId: Scalars['String']['input'];
};

export type YoutubeCategory = {
  __typename?: 'YoutubeCategory';
  categoryId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type YoutubeData = {
  __typename?: 'YoutubeData';
  title?: Maybe<Scalars['String']['output']>;
};

/** List of license types */
export enum YoutubeLicense {
  CreativeCommon = 'creativeCommon',
  Youtube = 'youtube'
}

/** Youtube post metadata */
export type YoutubePostMetadata = CommonPostMetadata & {
  __typename?: 'YoutubePostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Post category */
  category?: Maybe<YoutubeCategory>;
  /** Indicates whether the video allows embedding */
  embeddable: Scalars['Boolean']['output'];
  /** Video license */
  license?: Maybe<YoutubeLicense>;
  /** Indicates whether the video is suitable for kids */
  madeForKids: Scalars['Boolean']['output'];
  /** Indicates whether to notify subscribers on publish video */
  notifySubscribers: Scalars['Boolean']['output'];
  /** Privacy setting for post */
  privacy?: Maybe<YoutubePrivacy>;
  /** Title of the Youtube post */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Youtube */
  type: PostType;
};

/** Youtube post metadata */
export type YoutubePostMetadataInput = {
  /**
   * Youtube Category ID, one ID of this list:
   * ID: 1 -> Film & Animation
   * ID: 2 -> Autos & Vehicles
   * ID: 10 -> Music
   * ID: 15 -> Pets & Animals
   * ID: 17 -> Sports
   * ID: 19 -> Travel & Events
   * ID: 20 -> Gaming
   * ID: 22 -> People & Blogs
   * ID: 23 -> Comedy
   * ID: 24 -> Entertainment
   * ID: 25 -> News & Politics
   * ID: 26 -> Howto & Style
   * ID: 27 -> Education
   * ID: 28 -> Science & Technology
   * ID: 29 -> Nonprofits & Activism
   */
  categoryId: Scalars['String']['input'];
  /** Indicates whether the video allows embedding (default: true) */
  embeddable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Video license (default: youtube) */
  license?: InputMaybe<YoutubeLicense>;
  /** Indicates whether the video is suitable for kids (default: false) */
  madeForKids?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether to notify subscribers on publish video (default: true) */
  notifySubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Privacy setting for post (default: public) */
  privacy?: InputMaybe<YoutubePrivacy>;
  /** Title of the Youtube post */
  title: Scalars['String']['input'];
};

/** List of privacy types */
export enum YoutubePrivacy {
  Private = 'private',
  Public = 'public',
  Unlisted = 'unlisted'
}

export type AccountSetSettingsPayload = AccountSetSettingsError | AccountSetSettingsResponse;

export type CanConnectChannelsInput = {
  organizationId: Scalars['ID']['input'];
  service: Service;
  serviceId: Scalars['String']['input'];
};

export type TrackActionOnboardingSurveyPayload = InvalidInputError | TrackActionOnboardingSurveySuccess | UnauthorizedError | UnexpectedError;

export type VoteForFeatureMutationResponse = BasicError | MutationBasicResponse;

export type AccountSetCurrentOrganizationMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountSetCurrentOrganizationMutation = { __typename?: 'Mutation', accountSetCurrentOrganization: boolean };

export type AccountInitiateEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountInitiateEmailVerificationMutation = { __typename?: 'Mutation', accountInitiateEmailVerification: { __typename?: 'AccountInitiateEmailVerificationError', userFriendlyMessage: string } | { __typename?: 'AccountInitiateEmailVerificationResponse', success: boolean } };

export type DismissBannerMutationVariables = Exact<{
  banner: Scalars['String']['input'];
}>;


export type DismissBannerMutation = { __typename?: 'Mutation', dismissBanner: { __typename?: 'DismissBannerError', cause: string } | { __typename?: 'DismissBannerResponse', success: boolean } };

export type DismissObjectMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  dismissedObject: DismissedObjectInput;
}>;


export type DismissObjectMutation = { __typename?: 'Mutation', addOrUpdateDismissedObject: { __typename?: 'AddOrUpdateDismissedObjectError', cause: string, userFriendlyMessage: string } | { __typename?: 'AddOrUpdateDismissedObjectResponse', success: boolean } };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, email: string, name?: string | null, hasVerifiedEmail?: boolean | null, helpScoutBeaconSignature?: string | null, avatar: string, createdAt?: any | null, featureFlips: Array<string>, isImpersonation: boolean, shouldShowEmailVerificationCommunication?: boolean | null, shouldShowEmailVerificationLinkRequest?: boolean | null, dismissedBanners?: Array<string | null> | null, hellonextSsoToken?: string | null, preferences?: { __typename?: 'Preferences', startOfWeek?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: any, organizationId: any, isLocked: boolean, serverUrl?: string | null }>, currentOrganization?: { __typename?: 'AccountOrganization', id: string, name: string, canEdit: boolean, channelRecommendations?: Array<string | null> | null, role: Role, createdAt?: any | null, isOneBufferOrganization: boolean, channelLimit: number, isBetaEnabled?: boolean | null, isAlphaEnabled?: boolean | null, shouldDisplayInviteCTA: boolean, featureFlips: Array<string>, ownerEmail: string, shouldShowTeamMemberOrganizationDowngradedBanner: boolean, privileges: { __typename?: 'AccountPrivileges', canManageBilling: boolean }, members: { __typename?: 'MemberConnection', totalCount: number }, lifetimeConnectedChannelsCount?: Array<{ __typename?: 'LifetimeConnectedChannelCount', service?: Service | null, serviceIds?: Array<string | null> | null } | null> | null, dismissedObjects?: Array<{ __typename?: 'DismissedObject', id: string } | null> | null, commonTrackingProperties?: { __typename?: 'CommonTrackingProperties', atEventBillingState: BillingState, atEventBillingPlan: string, atEventBillingCycle: BillingInterval, atEventBillingGateway: BillingGateway, atEventIsNewBuffer: boolean, atEventChannelQty: number } | null, channels: Array<{ __typename?: 'Channel', id: any, avatar: string, name: string, service: Service, serviceId: string, type: ChannelType, organizationId: any, isLocked: boolean, shouldShowPinterestUpgradeBanner: boolean, shouldShowLinkedInUpgradeBanner: boolean, shouldShowTiktokUpgradeBanner: boolean, serverUrl?: string | null, apiVersion?: string | null, postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, times: Array<string>, paused: boolean }> }>, billing: { __typename?: 'MPBilling', taxExempt?: string | null, billingRedirectUrl: string, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscriptions: Array<{ __typename?: 'MPSubscription', interval: BillingInterval, plan: string, product: Product, trial?: { __typename?: 'Trial', isActive: boolean } | null }>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } | { __typename?: 'OBBilling', canStartTrial: boolean, hasNeverBeenPayingCustomer: boolean, taxExempt?: string | null, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscription: { __typename?: 'OBSubscription', quantity: number, interval: BillingInterval, periodEnd?: any | null, isCanceledAtPeriodEnd: boolean, isPaymentPastDue?: boolean | null, trial?: { __typename?: 'Trial', isActive: boolean, remainingDays: number, isAwaitingUserAction: boolean, startDate: any, endDate: any } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string } }, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null, gatewayPlatform?: BillingGatewayPlatform | null }, channelSlotDetails: { __typename?: 'ChannelSlotDetails', flatFee: number, currentQuantity: number, chargableQuantity: number, pricePerQuantity: number, minimumQuantity: number }, pricingTiers: Array<{ __typename?: 'PricingTier', flatFee: number, unitPrice: number, upperBound: number }>, changePlanOptions: Array<{ __typename?: 'OBPlanOption', planId: ObPlanId, planName: string, planInterval: BillingInterval, description: string, isCurrentPlan: boolean, highlightsHeading: string, highlights: Array<string | null>, currency: string, basePrice: number, totalPrice: number, priceNote: string, absoluteSavings: string, isRecommended: boolean, downgradedMessage: string, summary: { __typename?: 'OBPlanOptionSummary', details: Array<string | null> }, channelSlotDetails?: { __typename?: 'ChannelSlotDetails', flatFee: number, currentQuantity: number, chargableQuantity: number, pricePerQuantity: number, minimumQuantity: number } | null, pricingTiers: Array<{ __typename?: 'PricingTier', flatFee: number, unitPrice: number, upperBound: number }> } | null>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } } | null, organizations: Array<{ __typename?: 'AccountOrganization', id: string, name: string, canEdit: boolean, channelRecommendations?: Array<string | null> | null, role: Role, createdAt?: any | null, isOneBufferOrganization: boolean, isBetaEnabled?: boolean | null, ownerEmail: string, shouldDisplayInviteCTA: boolean, featureFlips: Array<string>, members: { __typename?: 'MemberConnection', totalCount: number }, privileges: { __typename?: 'AccountPrivileges', canManageBilling: boolean }, dismissedObjects?: Array<{ __typename?: 'DismissedObject', id: string } | null> | null, commonTrackingProperties?: { __typename?: 'CommonTrackingProperties', atEventBillingState: BillingState, atEventBillingPlan: string, atEventBillingCycle: BillingInterval, atEventBillingGateway: BillingGateway, atEventIsNewBuffer: boolean, atEventChannelQty: number } | null, channels: Array<{ __typename?: 'Channel', id: any, avatar: string, name: string, service: Service, serviceId: string, organizationId: any, isLocked: boolean, shouldShowPinterestUpgradeBanner: boolean, shouldShowLinkedInUpgradeBanner: boolean, serverUrl?: string | null }>, billing: { __typename?: 'MPBilling', taxExempt?: string | null, billingRedirectUrl: string, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscriptions: Array<{ __typename?: 'MPSubscription', interval: BillingInterval, plan: string, product: Product, trial?: { __typename?: 'Trial', isActive: boolean } | null }>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } | { __typename?: 'OBBilling', canStartTrial: boolean, hasNeverBeenPayingCustomer: boolean, taxExempt?: string | null, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscription: { __typename?: 'OBSubscription', quantity: number, interval: BillingInterval, periodEnd?: any | null, isCanceledAtPeriodEnd: boolean, isPaymentPastDue?: boolean | null, trial?: { __typename?: 'Trial', isActive: boolean, remainingDays: number, isAwaitingUserAction: boolean, startDate: any, endDate: any } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string } }, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null }, channelSlotDetails: { __typename?: 'ChannelSlotDetails', flatFee: number, currentQuantity: number, chargableQuantity: number, pricePerQuantity: number, minimumQuantity: number }, changePlanOptions: Array<{ __typename?: 'OBPlanOption', planId: ObPlanId, planName: string, planInterval: BillingInterval, description: string, isCurrentPlan: boolean, highlightsHeading: string, highlights: Array<string | null>, currency: string, basePrice: number, totalPrice: number, priceNote: string, absoluteSavings: string, isRecommended: boolean, downgradedMessage: string, summary: { __typename?: 'OBPlanOptionSummary', details: Array<string | null> }, channelSlotDetails?: { __typename?: 'ChannelSlotDetails', flatFee: number, currentQuantity: number, chargableQuantity: number, pricePerQuantity: number, minimumQuantity: number } | null } | null>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } }>, products?: Array<{ __typename?: 'ProductLink', name: Product, userId?: string | null }> | null } };

export type SendTestNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification: { __typename?: 'SendTestNotificationError', code: number } | { __typename?: 'SendTestNotificationSuccess' } };

export type GetAccountTfaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountTfaQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, createdAt?: any | null, tfa?: { __typename?: 'TFA', type: TwoFactorMethod } | null } };

export type UpdatePlanMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  interval?: InputMaybe<BillingInterval>;
  attribution?: InputMaybe<AttributionInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdatePlanMutation = { __typename?: 'Mutation', billingUpdateSubscriptionPlan: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingUpdateSubscriptionPlanResponse', success: boolean, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdate', newPlan: string, newInterval: BillingInterval, newQuantity: number, effectiveDate: any } | null } };

export type UpdatePlanToFreeMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  interval?: InputMaybe<BillingInterval>;
}>;


export type UpdatePlanToFreeMutation = { __typename?: 'Mutation', billingUpdateSubscriptionPlan: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingUpdateSubscriptionPlanResponse', success: boolean } };

export type UpdateQuantityMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  attribution?: InputMaybe<AttributionInput>;
}>;


export type UpdateQuantityMutation = { __typename?: 'Mutation', billingUpdateSubscriptionQuantity: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingUpdateSubscriptionPlanResponse', success: boolean, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdate', newPlan: string, newInterval: BillingInterval, newQuantity: number, effectiveDate: any } | null } };

export type UpdateQuantityByChannelIdsMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  channelIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<AttributionInput>;
}>;


export type UpdateQuantityByChannelIdsMutation = { __typename?: 'Mutation', billingIncreaseSubscriptionQuantityByChannelIds: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingResponse', success: boolean } };

export type StartTrialMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  interval?: InputMaybe<BillingInterval>;
  attribution?: InputMaybe<AttributionInput>;
}>;


export type StartTrialMutation = { __typename?: 'Mutation', billingStartTrial: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingResponse', success: boolean } };

export type GetInvoicePreviewQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  plan?: InputMaybe<ObPlanId>;
  interval?: InputMaybe<BillingInterval>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInvoicePreviewQuery = { __typename?: 'Query', previewCustomUpcomingInvoice: { __typename?: 'UpcomingInvoiceCostsPreview', chargeAmount: number, creditAmount: number, isScheduledChange: boolean, nextBillingDate: any } };

export type BillingCreateCheckoutSessionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  plan: ObPlanId;
  interval: BillingInterval;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  currentURL?: InputMaybe<Scalars['String']['input']>;
  shouldCollectAutomaticTax?: InputMaybe<Scalars['Boolean']['input']>;
  attribution?: InputMaybe<AttributionInput>;
}>;


export type BillingCreateCheckoutSessionMutation = { __typename?: 'Mutation', billingCreateCheckoutSession: { __typename?: 'BillingCreateCheckoutSessionResponse', redirectUrl: string } | { __typename?: 'BillingError', userFriendlyMessage: string } };

export type CreateCustomChannelsMutationVariables = Exact<{
  input: CreateCustomChannelsInput;
}>;


export type CreateCustomChannelsMutation = { __typename?: 'Mutation', createCustomChannels: { __typename?: 'CreateCustomChannelsResponse', channels: Array<{ __typename?: 'Channel', id: any }> } | { __typename?: 'CustomChannelError', message: string } };

export type UpdateCustomChannelMutationVariables = Exact<{
  input: UpdateCustomChannelInput;
}>;


export type UpdateCustomChannelMutation = { __typename?: 'Mutation', updateCustomChannel: { __typename?: 'CustomChannelError', message: string } | { __typename?: 'UpdateCustomChannelResponse', channel: { __typename?: 'Channel', id: any } } };

export type StartPagesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type StartPagesQuery = { __typename?: 'Query', startPages?: { __typename?: 'CommonError', code: string, success: boolean } | { __typename?: 'StartPages', startPages?: Array<{ __typename?: 'StartPage', id: string, domain?: string | null, organizationId: string, isPublished?: boolean | null, title?: string | null, migrationAsAChannel?: { __typename?: 'StartPageMigrationAsAChannel', success?: boolean | null, wasPublished?: boolean | null, wasBilling?: string | null, wasMobile?: boolean | null, wasTrialist?: boolean | null, wasAtLimit?: boolean | null } | null } | null> | null } | null };

export type GetDismissedBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDismissedBannersQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, dismissedBanners?: Array<string | null> | null } };

export type CreateCustomerPortalSessionMutationVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  returnURL: Scalars['String']['input'];
}>;


export type CreateCustomerPortalSessionMutation = { __typename?: 'Mutation', createCustomerPortalSession: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'CreateCustomerPortalSessionResponse', customerPortalSessionUrl: string } };

export type UpdateChannelPostingGoalMutationVariables = Exact<{
  input: UpdateChannelPostingGoalInput;
}>;


export type UpdateChannelPostingGoalMutation = { __typename?: 'Mutation', updateChannelPostingGoal: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateChannelPostingGoalResponse', channel: { __typename?: 'Channel', id: any, postingGoal?: { __typename?: 'PostingGoal', goal: number, sentCount: number, scheduledCount: number, periodStart: any, periodEnd: any, status: PostingGoalStatus } | null } } };

export type SetPostingScheduleForChannelMutationVariables = Exact<{
  input: SetPostingScheduleForChannelInput;
}>;


export type SetPostingScheduleForChannelMutation = { __typename?: 'Mutation', setPostingScheduleForChannel: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'SetPostingScheduleForChannelResponse', postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, paused: boolean, times: Array<string> } | null> } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type WeeklyPostingStreakQueryVariables = Exact<{
  input: WeeklyPostingStreakInput;
}>;


export type WeeklyPostingStreakQuery = { __typename?: 'Query', weeklyPostingStreak?: { __typename?: 'Streak', count: number, status: StreakStatus, periodsAhead?: number | null, previousCount?: number | null, longestCount?: number | null, userStreakState: UserStreakState } | null };

export type EngageOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type EngageOrganizationQuery = { __typename?: 'Query', engageOrganization?: { __typename?: 'EngageOrganization', channels?: Array<{ __typename?: 'EngageChannel', id?: string | null, totalPendingComments?: number | null } | null> | null } | null };

export type GetConnectableServicesQueryVariables = Exact<{
  input: ConnectableServicesInput;
}>;


export type GetConnectableServicesQuery = { __typename?: 'Query', connectableServices: { __typename: 'ConnectableServicesError', userFriendlyMessage: string, cause: string } | { __typename: 'ConnectableServicesResponse', services: Array<{ __typename?: 'ConnectableService', service: Service, types: Array<ChannelType>, products: Array<Product>, isNew: boolean, canConnect: boolean, title: string, subtitle: string, serviceIconUrl: string, description: Array<string>, contentTypes: Array<ContentType>, audience?: string | null, socialProof?: string | null, similarNetworks?: Array<Service> | null, tag?: string | null, categories: Array<ChannelCategory>, serviceStatus: { __typename?: 'ServiceStatus', label: StatusLabel, details?: { __typename?: 'UpvoteDetails', message?: string | null, upvoteId: number } | null }, status: { __typename?: 'ChannelConnectionStatus', status: ConnectionStatus }, links?: Array<{ __typename?: 'HelpCenterLink', text: string, url: string }> | null }> } };

export type AccountHasActiveMemberDeviceQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountHasActiveMemberDeviceQuery = { __typename?: 'Query', account: { __typename?: 'Account', currentOrganization?: { __typename?: 'AccountOrganization', channels: Array<{ __typename?: 'Channel', hasActiveMemberDevice: boolean }> } | null } };

export type ChannelAuthorizationInfoQueryVariables = Exact<{
  input: ChannelAuthorizationInfoInput;
}>;


export type ChannelAuthorizationInfoQuery = { __typename?: 'Query', channelAuthorizationInfo: { __typename?: 'ChannelAuthorizationInfoResponse', url: string, state: string, redirectUri: string } };

export type GetChannelAutorizationInfoQueryVariables = Exact<{
  input: ChannelAuthorizationInfoInput;
}>;


export type GetChannelAutorizationInfoQuery = { __typename?: 'Query', channelAuthorizationInfo: { __typename?: 'ChannelAuthorizationInfoResponse', url: string, state: string, redirectUri: string } };


export const AccountSetCurrentOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountSetCurrentOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountSetCurrentOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<AccountSetCurrentOrganizationMutation, AccountSetCurrentOrganizationMutationVariables>;
export const AccountInitiateEmailVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountInitiateEmailVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountInitiateEmailVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountInitiateEmailVerificationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountInitiateEmailVerificationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<AccountInitiateEmailVerificationMutation, AccountInitiateEmailVerificationMutationVariables>;
export const DismissBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"banner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"banner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"banner"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissBannerResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissBannerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<DismissBannerMutation, DismissBannerMutationVariables>;
export const DismissObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dismissedObject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DismissedObjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrUpdateDismissedObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dismissedObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dismissedObject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddOrUpdateDismissedObjectResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddOrUpdateDismissedObjectError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<DismissObjectMutation, DismissObjectMutationVariables>;
export const AccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasVerifiedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"helpScoutBeaconSignature"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"isImpersonation"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowEmailVerificationCommunication"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowEmailVerificationLinkRequest"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedBanners"}},{"kind":"Field","name":{"kind":"Name","value":"hellonextSsoToken"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"channelRecommendations"}},{"kind":"Field","name":{"kind":"Name","value":"privileges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canManageBilling"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"channelLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isBetaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isAlphaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lifetimeConnectedChannelsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldDisplayInviteCTA"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPinterestUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedInUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowTiktokUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowTeamMemberOrganizationDowngradedBanner"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutomaticTaxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticTax"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAwaitingUserAction"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelSlotDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"chargableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changePlanOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"planInterval"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"highlightsHeading"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"priceNote"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteSavings"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"downgradedMessage"}},{"kind":"Field","name":{"kind":"Name","value":"channelSlotDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"chargableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"channelRecommendations"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"privileges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canManageBilling"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"isBetaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldDisplayInviteCTA"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPinterestUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedInUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutomaticTaxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticTax"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAwaitingUserAction"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelSlotDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"chargableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changePlanOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"planInterval"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"highlightsHeading"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"priceNote"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteSavings"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"downgradedMessage"}},{"kind":"Field","name":{"kind":"Name","value":"channelSlotDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"chargableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQuantity"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<AccountQuery, AccountQueryVariables>;
export const SendTestNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendTestNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendTestNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendTestNotificationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const GetAccountTfaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountTFA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tfa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountTfaQuery, GetAccountTfaQueryVariables>;
export const UpdatePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingUpdateSubscriptionPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingUpdateSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePlanMutation, UpdatePlanMutationVariables>;
export const UpdatePlanToFreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePlanToFree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingUpdateSubscriptionPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingUpdateSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePlanToFreeMutation, UpdatePlanToFreeMutationVariables>;
export const UpdateQuantityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuantity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingUpdateSubscriptionQuantity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingUpdateSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQuantityMutation, UpdateQuantityMutationVariables>;
export const UpdateQuantityByChannelIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuantityByChannelIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingIncreaseSubscriptionQuantityByChannelIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQuantityByChannelIdsMutation, UpdateQuantityByChannelIdsMutationVariables>;
export const StartTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startTrial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingStartTrial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<StartTrialMutation, StartTrialMutationVariables>;
export const GetInvoicePreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoicePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewCustomUpcomingInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"creditAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isScheduledChange"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"}}]}}]}}]} as unknown as DocumentNode<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>;
export const BillingCreateCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"billingCreateCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentURL"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldCollectAutomaticTax"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingCreateCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentURL"}}},{"kind":"Argument","name":{"kind":"Name","value":"shouldCollectAutomaticTax"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldCollectAutomaticTax"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingCreateCheckoutSessionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<BillingCreateCheckoutSessionMutation, BillingCreateCheckoutSessionMutationVariables>;
export const CreateCustomChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomChannelsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomChannelsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomChannelsMutation, CreateCustomChannelsMutationVariables>;
export const UpdateCustomChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomChannelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomChannelMutation, UpdateCustomChannelMutationVariables>;
export const StartPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"startPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StartPages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"migrationAsAChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"wasPublished"}},{"kind":"Field","name":{"kind":"Name","value":"wasBilling"}},{"kind":"Field","name":{"kind":"Name","value":"wasMobile"}},{"kind":"Field","name":{"kind":"Name","value":"wasTrialist"}},{"kind":"Field","name":{"kind":"Name","value":"wasAtLimit"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<StartPagesQuery, StartPagesQueryVariables>;
export const GetDismissedBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDismissedBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedBanners"}}]}}]}}]} as unknown as DocumentNode<GetDismissedBannersQuery, GetDismissedBannersQueryVariables>;
export const CreateCustomerPortalSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomerPortalSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnURL"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerPortalSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"returnURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnURL"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerPortalSessionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPortalSessionUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>;
export const UpdateChannelPostingGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChannelPostingGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelPostingGoalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChannelPostingGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelPostingGoalResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"sentCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateChannelPostingGoalMutation, UpdateChannelPostingGoalMutationVariables>;
export const SetPostingScheduleForChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPostingScheduleForChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPostingScheduleForChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPostingScheduleForChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetPostingScheduleForChannelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetPostingScheduleForChannelMutation, SetPostingScheduleForChannelMutationVariables>;
export const WeeklyPostingStreakDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WeeklyPostingStreak"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WeeklyPostingStreakInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weeklyPostingStreak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"periodsAhead"}},{"kind":"Field","name":{"kind":"Name","value":"previousCount"}},{"kind":"Field","name":{"kind":"Name","value":"longestCount"}},{"kind":"Field","name":{"kind":"Name","value":"userStreakState"}}]}}]}}]} as unknown as DocumentNode<WeeklyPostingStreakQuery, WeeklyPostingStreakQueryVariables>;
export const EngageOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"engageOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engageOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalPendingComments"}}]}}]}}]}}]} as unknown as DocumentNode<EngageOrganizationQuery, EngageOrganizationQueryVariables>;
export const GetConnectableServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectableServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectableServicesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectableServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectableServicesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"services"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"upvoteId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"canConnect"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"socialProof"}},{"kind":"Field","name":{"kind":"Name","value":"similarNetworks"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectableServicesError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}},{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<GetConnectableServicesQuery, GetConnectableServicesQueryVariables>;
export const AccountHasActiveMemberDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountHasActiveMemberDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasActiveMemberDevice"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountHasActiveMemberDeviceQuery, AccountHasActiveMemberDeviceQueryVariables>;
export const ChannelAuthorizationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChannelAuthorizationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelAuthorizationInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelAuthorizationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelAuthorizationInfoResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUri"}}]}}]}}]}}]} as unknown as DocumentNode<ChannelAuthorizationInfoQuery, ChannelAuthorizationInfoQueryVariables>;
export const GetChannelAutorizationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChannelAutorizationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelAuthorizationInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelAuthorizationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelAuthorizationInfoResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUri"}}]}}]}}]}}]} as unknown as DocumentNode<GetChannelAutorizationInfoQuery, GetChannelAutorizationInfoQueryVariables>;